import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  FirebaseTimestamp: { input: any; output: any; }
  JSON: { input: any; output: any; }
  ObjectId: { input: any; output: any; }
};

export type About = {
  __typename?: 'About';
  git?: Maybe<Git>;
  name?: Maybe<Scalars['String']['output']>;
};

export type Account = {
  __typename?: 'Account';
  customer?: Maybe<Customer>;
  customerId?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  uid?: Maybe<Scalars['String']['output']>;
  user?: Maybe<Profile>;
  userInfo?: Maybe<UserInfo>;
};

export type Achievement = {
  __typename?: 'Achievement';
  achievement?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  group?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  iconUrl?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  rank?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type AchievementCollected = {
  __typename?: 'AchievementCollected';
  achievement?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  info?: Maybe<Achievement>;
  mint?: Maybe<NftHistory>;
  uid?: Maybe<Scalars['String']['output']>;
};

export type ActiveSubscriptionInfo = {
  __typename?: 'ActiveSubscriptionInfo';
  activeSubscription?: Maybe<Scalars['String']['output']>;
  checkInDate?: Maybe<Scalars['String']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  ownerUID?: Maybe<Scalars['String']['output']>;
  previousSubscription?: Maybe<Scalars['String']['output']>;
  subscriptionInfo?: Maybe<Scalars['JSON']['output']>;
};

export type AdditionalRestriction = {
  __typename?: 'AdditionalRestriction';
  invoiceIds?: Maybe<Array<Scalars['String']['output']>>;
  planIds?: Maybe<Array<Scalars['String']['output']>>;
  productIds?: Maybe<Array<Scalars['String']['output']>>;
  quantity?: Maybe<Scalars['Int']['output']>;
  subscriptionIds?: Maybe<Array<Scalars['String']['output']>>;
  time?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type Address = {
  __typename?: 'Address';
  address?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  emails?: Maybe<Array<Maybe<Email>>>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
};

export type AddressInput = {
  address: Scalars['String']['input'];
  address2?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  country?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<Scalars['String']['input']>;
  postalCode: Scalars['String']['input'];
  region: Scalars['String']['input'];
};

export type AndroidIntroductoryPriceInfo = {
  __typename?: 'AndroidIntroductoryPriceInfo';
  introductoryPriceAmountMicros?: Maybe<Scalars['String']['output']>;
  introductoryPriceCurrencyCode?: Maybe<Scalars['String']['output']>;
  introductoryPriceCycles?: Maybe<Scalars['Float']['output']>;
  introductoryPricePeriod?: Maybe<Scalars['String']['output']>;
};

export type AndroidSubscription = {
  __typename?: 'AndroidSubscription';
  acknowledgementState?: Maybe<Scalars['Float']['output']>;
  autoRenewing?: Maybe<Scalars['Boolean']['output']>;
  autoResumeTimeMillis?: Maybe<Scalars['String']['output']>;
  cancelReason?: Maybe<Scalars['Float']['output']>;
  cancelSurveyResult?: Maybe<AndroidSubscriptionCancelSurveyResult>;
  countryCode?: Maybe<Scalars['String']['output']>;
  developerPayload?: Maybe<Scalars['String']['output']>;
  emailAddress?: Maybe<Scalars['String']['output']>;
  expiryTimeMillis?: Maybe<Scalars['String']['output']>;
  externalAccountId?: Maybe<Scalars['String']['output']>;
  familyName?: Maybe<Scalars['String']['output']>;
  givenName?: Maybe<Scalars['String']['output']>;
  introductoryPriceInfo?: Maybe<AndroidIntroductoryPriceInfo>;
  kind?: Maybe<Scalars['String']['output']>;
  linkedPurchaseToken?: Maybe<Scalars['String']['output']>;
  orderId?: Maybe<Scalars['String']['output']>;
  paymentState?: Maybe<Scalars['Float']['output']>;
  priceAmountMicros?: Maybe<Scalars['String']['output']>;
  priceChange?: Maybe<AndroidSubscriptionPriceChange>;
  priceCurrencyCode?: Maybe<Scalars['String']['output']>;
  profileId?: Maybe<Scalars['String']['output']>;
  profileName?: Maybe<Scalars['String']['output']>;
  promotionCode?: Maybe<Scalars['String']['output']>;
  promotionType?: Maybe<Scalars['Float']['output']>;
  purchaseType?: Maybe<Scalars['Float']['output']>;
  startTimeMillis?: Maybe<Scalars['String']['output']>;
  userCancellationTimeMillis?: Maybe<Scalars['String']['output']>;
};

export type AndroidSubscriptionCancelSurveyResult = {
  __typename?: 'AndroidSubscriptionCancelSurveyResult';
  cancelSurveyReason?: Maybe<Scalars['Float']['output']>;
  userInputCancelReason?: Maybe<Scalars['String']['output']>;
};

export type AndroidSubscriptionPrice = {
  __typename?: 'AndroidSubscriptionPrice';
  currency?: Maybe<Scalars['String']['output']>;
  priceMicros?: Maybe<Scalars['String']['output']>;
};

export type AndroidSubscriptionPriceChange = {
  __typename?: 'AndroidSubscriptionPriceChange';
  newPrice?: Maybe<AndroidSubscriptionPrice>;
  state?: Maybe<Scalars['Float']['output']>;
};

export type AppleSubscription = {
  __typename?: 'AppleSubscription';
  id?: Maybe<Scalars['String']['output']>;
};

export type BatchSendCloudLabelWithParcel = {
  __typename?: 'BatchSendCloudLabelWithParcel';
  batch?: Maybe<Scalars['String']['output']>;
  labels?: Maybe<Array<Maybe<SendCloudLabelWithParcel>>>;
};

export type BillingAnchor = {
  __typename?: 'BillingAnchor';
  billingAnchorInstruction?: Maybe<InstructionMethod>;
  chronology?: Maybe<Scalars['String']['output']>;
};

export type BooleanFilter = {
  EQ?: InputMaybe<Scalars['Boolean']['input']>;
  NE?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CalculateRatesInput = {
  carrierCode: Scalars['String']['input'];
  confirmation?: InputMaybe<ShipStationConfirmation>;
  dimensions?: InputMaybe<ShipStationDimensionsInput>;
  fromPostalCode: Scalars['String']['input'];
  packageCode?: InputMaybe<Scalars['String']['input']>;
  residential?: InputMaybe<Scalars['Boolean']['input']>;
  serviceCode?: InputMaybe<Scalars['String']['input']>;
  toCity?: InputMaybe<Scalars['String']['input']>;
  toCountry: Scalars['String']['input'];
  toPostalCode: Scalars['String']['input'];
  toState?: InputMaybe<Scalars['String']['input']>;
  weight: ShipStationWeightInput;
};

export type CancelAndRefundResult = {
  __typename?: 'CancelAndRefundResult';
  invoice?: Maybe<Invoice>;
  order?: Maybe<ShipStationOrder>;
  refund?: Maybe<Transaction>;
  refundError?: Maybe<Scalars['String']['output']>;
};

export type ChangeSubscription = {
  __typename?: 'ChangeSubscription';
  activationTime?: Maybe<Scalars['String']['output']>;
  autopay?: Maybe<Scalars['Boolean']['output']>;
  billingAnchor?: Maybe<BillingAnchor>;
  billingStatus?: Maybe<Scalars['String']['output']>;
  cancelCategory?: Maybe<Scalars['String']['output']>;
  cancelDescription?: Maybe<Scalars['String']['output']>;
  canceledBy?: Maybe<Scalars['String']['output']>;
  canceledTime?: Maybe<Scalars['String']['output']>;
  createdTime?: Maybe<Scalars['String']['output']>;
  customFields?: Maybe<Scalars['JSON']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  initialInvoiceId?: Maybe<Scalars['String']['output']>;
  items: Array<Item>;
  lineItemSubtotal: Scalars['Float']['output'];
  lineItems: Array<LineItem>;
  orderType?: Maybe<Scalars['String']['output']>;
  poNumber?: Maybe<Scalars['String']['output']>;
  recentInvoiceId?: Maybe<Scalars['String']['output']>;
  recurringInterval?: Maybe<RecurringInterval>;
  riskMetadata?: Maybe<RiskMetadata>;
  startTime?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updatedTime?: Maybe<Scalars['String']['output']>;
  websiteId?: Maybe<Scalars['String']['output']>;
};

export type CheckoutResponse = {
  __typename?: 'CheckoutResponse';
  customer?: Maybe<Customer>;
  transaction?: Maybe<Transaction>;
};

export type Coupon = {
  __typename?: 'Coupon';
  additionalRestrictions?: Maybe<Array<Maybe<AdditionalRestriction>>>;
  canceledTime?: Maybe<Scalars['Date']['output']>;
  couponId?: Maybe<Scalars['String']['output']>;
  createdTime?: Maybe<Scalars['Date']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
};

export type CouponInput = {
  couponId: Scalars['String']['input'];
  discountsPerRedemption?: InputMaybe<DiscountsPerRedemption>;
  minimumOrderAmount?: InputMaybe<MinimumOrderAmount>;
  paidByTime?: InputMaybe<PaidByTime>;
  redemptionsPerCustomer?: InputMaybe<RedemptionsPerCustomer>;
  restrictToInvoices?: InputMaybe<RestrictToInvoices>;
  restrictToPlans?: InputMaybe<RestrictToPlans>;
  restrictToProducts?: InputMaybe<RestrictToProducts>;
  restrictToSubscriptions?: InputMaybe<RestrictToSubscriptions>;
  totalRedemptions?: InputMaybe<TotalRedemptions>;
};

export enum CouponRestrictionType {
  DiscountsPerRedemption = 'DiscountsPerRedemption',
  MinimumOrderAmount = 'MinimumOrderAmount',
  PaidByTime = 'PaidByTime',
  RedemptionsPerCustomer = 'RedemptionsPerCustomer',
  RestrictToInvoices = 'RestrictToInvoices',
  RestrictToPlans = 'RestrictToPlans',
  RestrictToProducts = 'RestrictToProducts',
  RestrictToSubscriptions = 'RestrictToSubscriptions',
  TotalRedemptions = 'TotalRedemptions'
}

export type CreateLabelInput = {
  advancedOptions?: InputMaybe<ShipStationAdvancedOptionsInput>;
  carrierCode: Scalars['String']['input'];
  confirmation: Scalars['String']['input'];
  dimensions?: InputMaybe<ShipStationDimensionsInput>;
  insuranceOptions?: InputMaybe<ShipStationInsuranceOptionsInput>;
  internationalOptions?: InputMaybe<ShipStationInternationalOptionsInput>;
  orderId: Scalars['Float']['input'];
  packageCode?: InputMaybe<Scalars['String']['input']>;
  serviceCode: Scalars['String']['input'];
  shipDate: Scalars['String']['input'];
  testLabel: Scalars['Boolean']['input'];
  weight?: InputMaybe<ShipStationWeightInput>;
};

export type CumulativeSubscriptionCount = {
  __typename?: 'CumulativeSubscriptionCount';
  canceledCount?: Maybe<Scalars['Int']['output']>;
  cumulativeCount?: Maybe<Scalars['Int']['output']>;
  day?: Maybe<Scalars['String']['output']>;
  month?: Maybe<Scalars['String']['output']>;
  netCount?: Maybe<Scalars['Int']['output']>;
  newCount?: Maybe<Scalars['Int']['output']>;
  planId?: Maybe<Scalars['String']['output']>;
};

export type CumulativeSubscriptionCountResult = {
  __typename?: 'CumulativeSubscriptionCountResult';
  data?: Maybe<Array<Maybe<CumulativeSubscriptionCount>>>;
};

export type CumulativeTransactionCount = {
  __typename?: 'CumulativeTransactionCount';
  aggregationFieldValue?: Maybe<Scalars['String']['output']>;
  amount?: Maybe<Scalars['Float']['output']>;
  approvedThroughput?: Maybe<Scalars['Float']['output']>;
  authApprovalCount?: Maybe<Scalars['Int']['output']>;
  authApprovedThroughput?: Maybe<Scalars['Float']['output']>;
  count?: Maybe<Scalars['Int']['output']>;
  disputesCount?: Maybe<Scalars['Int']['output']>;
  disputesRate?: Maybe<Scalars['Float']['output']>;
  refundsCount?: Maybe<Scalars['Int']['output']>;
  refundsValue?: Maybe<Scalars['Float']['output']>;
  salesAverage?: Maybe<Scalars['Float']['output']>;
  salesCount?: Maybe<Scalars['Int']['output']>;
  salesValue?: Maybe<Scalars['Float']['output']>;
};

export type CumulativeTransactionCountResult = {
  __typename?: 'CumulativeTransactionCountResult';
  data?: Maybe<Array<Maybe<CumulativeTransactionCount>>>;
};

export type CurrencyAmount = {
  __typename?: 'CurrencyAmount';
  amount?: Maybe<Scalars['Float']['output']>;
  amountUsd?: Maybe<Scalars['Float']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
};

export type Customer = {
  __typename?: 'Customer';
  activeSubscriptionInfo?: Maybe<ActiveSubscriptionInfo>;
  averageValue?: Maybe<CurrencyAmount>;
  createdTime?: Maybe<Scalars['String']['output']>;
  customFields?: Maybe<Scalars['JSON']['output']>;
  customerIds: Array<Maybe<Scalars['String']['output']>>;
  defaultPaymentInstrument?: Maybe<PaymentInstrumentId>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  invoiceCount?: Maybe<Scalars['String']['output']>;
  invoices?: Maybe<InvoicesPage>;
  invoicesPastDue?: Maybe<InvoicesPastDuePage>;
  isMasterEligible?: Maybe<MasterEligibility>;
  kycDocuments?: Maybe<Array<Maybe<KycDocument>>>;
  kycMaxAttempts?: Maybe<KycMaxAttempts>;
  lastName?: Maybe<Scalars['String']['output']>;
  lastPaymentTime?: Maybe<Scalars['String']['output']>;
  lifetimeRevenue?: Maybe<CurrencyAmount>;
  locale?: Maybe<Scalars['String']['output']>;
  mainSubscription?: Maybe<RebillySubscription>;
  pastSubscriptions?: Maybe<Array<Maybe<RebillySubscription>>>;
  paymentCards?: Maybe<Array<Maybe<PaymentCard>>>;
  paymentCount?: Maybe<Scalars['String']['output']>;
  paymentInstruments?: Maybe<Array<Maybe<PaymentCard>>>;
  primaryAddress?: Maybe<Address>;
  subscriptions?: Maybe<Array<Maybe<RebillySubscription>>>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  updatedTime?: Maybe<Scalars['String']['output']>;
  user?: Maybe<Profile>;
  userInfo?: Maybe<UserInfo>;
  websiteId?: Maybe<Scalars['String']['output']>;
};


export type CustomerInvoicesArgs = {
  filter?: InputMaybe<InvoiceFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type CustomerInvoicesPastDueArgs = {
  pagination?: InputMaybe<Pagination>;
};

export type CustomerInput = {
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type DateFilter = {
  ALL?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  EQ?: InputMaybe<Scalars['Date']['input']>;
  GT?: InputMaybe<Scalars['Date']['input']>;
  GTE?: InputMaybe<Scalars['Date']['input']>;
  IN?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  LT?: InputMaybe<Scalars['Date']['input']>;
  LTE?: InputMaybe<Scalars['Date']['input']>;
  NE?: InputMaybe<Scalars['Date']['input']>;
  NIN?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type DiscountsPerRedemption = {
  quantity: Scalars['Int']['input'];
};

export type DocumentMatches = {
  __typename?: 'DocumentMatches';
  data?: Maybe<Scalars['JSON']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
};

export type Email = {
  __typename?: 'Email';
  label?: Maybe<Scalars['String']['output']>;
  primary?: Maybe<Scalars['Boolean']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type FloatFilter = {
  ALL?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  EQ?: InputMaybe<Scalars['Float']['input']>;
  GT?: InputMaybe<Scalars['Float']['input']>;
  GTE?: InputMaybe<Scalars['Float']['input']>;
  IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  LT?: InputMaybe<Scalars['Float']['input']>;
  LTE?: InputMaybe<Scalars['Float']['input']>;
  NE?: InputMaybe<Scalars['Float']['input']>;
  NIN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type Git = {
  __typename?: 'Git';
  sha?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type InAppSubscription = {
  __typename?: 'InAppSubscription';
  subActive?: Maybe<Scalars['Boolean']['output']>;
  subCreatedDate?: Maybe<Scalars['String']['output']>;
  subDate?: Maybe<Scalars['String']['output']>;
  subOrder?: Maybe<Scalars['String']['output']>;
  subOs?: Maybe<Scalars['String']['output']>;
  subSku?: Maybe<Scalars['String']['output']>;
  subscription?: Maybe<Scalars['String']['output']>;
};

export type InstructionMethod = {
  __typename?: 'InstructionMethod';
  method?: Maybe<Scalars['String']['output']>;
};

export type IntFilter = {
  ALL?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  EQ?: InputMaybe<Scalars['Int']['input']>;
  GT?: InputMaybe<Scalars['Int']['input']>;
  GTE?: InputMaybe<Scalars['Int']['input']>;
  IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  LT?: InputMaybe<Scalars['Int']['input']>;
  LTE?: InputMaybe<Scalars['Int']['input']>;
  NE?: InputMaybe<Scalars['Int']['input']>;
  NIN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type Invoice = {
  __typename?: 'Invoice';
  abandonedTime?: Maybe<Scalars['String']['output']>;
  amount?: Maybe<Scalars['Float']['output']>;
  autopayRetryNumber?: Maybe<Scalars['Int']['output']>;
  autopayScheduledTime?: Maybe<Scalars['String']['output']>;
  billingAddress?: Maybe<Address>;
  collectionPeriod?: Maybe<Scalars['Int']['output']>;
  createdTime?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  delinquentCollectionPeriod?: Maybe<Scalars['Int']['output']>;
  deliveryAddress?: Maybe<Address>;
  discountAmount?: Maybe<Scalars['Float']['output']>;
  discounts?: Maybe<Scalars['JSON']['output']>;
  dueTime?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  invoiceNumber?: Maybe<Scalars['Int']['output']>;
  issuedTime?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Array<Maybe<InvoiceItem>>>;
  notes?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['String']['output']>;
  paidTime?: Maybe<Scalars['String']['output']>;
  poNumber?: Maybe<Scalars['Int']['output']>;
  retryInstruction?: Maybe<Scalars['String']['output']>;
  shippingAmount?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  subscriptionId?: Maybe<Scalars['String']['output']>;
  subtotalAmount?: Maybe<Scalars['Float']['output']>;
  taxAmount?: Maybe<Scalars['Float']['output']>;
  taxes?: Maybe<Scalars['JSON']['output']>;
  transactions?: Maybe<Array<Maybe<Transaction>>>;
  type?: Maybe<Scalars['String']['output']>;
  updatedTime?: Maybe<Scalars['String']['output']>;
  voidedTime?: Maybe<Scalars['String']['output']>;
  websiteId?: Maybe<Scalars['String']['output']>;
};

export type InvoiceFilter = {
  status?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subscriptionId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type InvoiceItem = {
  __typename?: 'InvoiceItem';
  createdTime?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  periodEndTime?: Maybe<Scalars['String']['output']>;
  periodNumber?: Maybe<Scalars['Int']['output']>;
  periodStartTime?: Maybe<Scalars['String']['output']>;
  planId?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  productId?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  rebillNumber?: Maybe<Scalars['Int']['output']>;
  subscription?: Maybe<Scalars['String']['output']>;
  subscriptionId?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  unitPrice?: Maybe<Scalars['Float']['output']>;
  updatedTime?: Maybe<Scalars['String']['output']>;
};

export type InvoicesPage = {
  __typename?: 'InvoicesPage';
  data?: Maybe<Array<Maybe<Invoice>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type InvoicesPastDuePage = {
  __typename?: 'InvoicesPastDuePage';
  data?: Maybe<Array<Maybe<Invoice>>>;
  error?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type Item = {
  __typename?: 'Item';
  planId: Scalars['String']['output'];
  quantity?: Maybe<Scalars['Int']['output']>;
};

export type ItemInput = {
  plan?: InputMaybe<PlanInput>;
  planId: Scalars['String']['input'];
  quantity?: InputMaybe<Scalars['Int']['input']>;
};

export type KycDocument = {
  __typename?: 'KycDocument';
  createdTime?: Maybe<Scalars['String']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  documentMatches?: Maybe<DocumentMatches>;
  documentType?: Maybe<Scalars['String']['output']>;
  download?: Maybe<Scalars['JSON']['output']>;
  fileId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  processedTime?: Maybe<Scalars['String']['output']>;
  rejectionReason?: Maybe<RejectionReason>;
  status?: Maybe<Scalars['String']['output']>;
  updatedTime?: Maybe<Scalars['String']['output']>;
};

export type KycDocumentInput = {
  customerId?: InputMaybe<Scalars['String']['input']>;
  documentType?: InputMaybe<KycDocumentType>;
  file: Scalars['String']['input'];
};

export type KycDocumentResult = {
  __typename?: 'KycDocumentResult';
  customerId?: Maybe<Scalars['String']['output']>;
  kycDocument?: Maybe<KycDocument>;
  kycMaxAttempts?: Maybe<KycMaxAttempts>;
};

export enum KycDocumentType {
  AddressProof = 'addressProof',
  IdentityProof = 'identityProof'
}

export type KycMaxAttempts = {
  __typename?: 'KycMaxAttempts';
  attempts?: Maybe<Scalars['Int']['output']>;
  attemptsToday?: Maybe<Scalars['Int']['output']>;
  maxAttempts?: Maybe<Scalars['Int']['output']>;
  maxAttemptsToday?: Maybe<Scalars['Int']['output']>;
};

export type LineItem = {
  __typename?: 'LineItem';
  createdTime?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  periodEndTime?: Maybe<Scalars['String']['output']>;
  periodStartTime?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  unitPriceAmount?: Maybe<Scalars['Float']['output']>;
  unitPriceCurrency?: Maybe<Scalars['String']['output']>;
};

export type MarkShippedInput = {
  carrierCode: Scalars['String']['input'];
  notifyCustomer?: InputMaybe<Scalars['Boolean']['input']>;
  notifySalesChannel?: InputMaybe<Scalars['Boolean']['input']>;
  orderId: Scalars['Float']['input'];
  shipDate?: InputMaybe<Scalars['String']['input']>;
  trackingNumber?: InputMaybe<Scalars['String']['input']>;
};

export type MarkedShipped = {
  __typename?: 'MarkedShipped';
  carrierCode?: Maybe<Scalars['String']['output']>;
  notifyCustomer?: Maybe<Scalars['Boolean']['output']>;
  notifySalesChannel?: Maybe<Scalars['Boolean']['output']>;
  orderId?: Maybe<Scalars['Float']['output']>;
  shipDate?: Maybe<Scalars['String']['output']>;
  trackingNumber?: Maybe<Scalars['String']['output']>;
};

export type MasterEligibility = {
  __typename?: 'MasterEligibility';
  message?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Boolean']['output']>;
};

export type MinimumOrderAmount = {
  amount: Scalars['Int']['input'];
  currency: Scalars['String']['input'];
};

export type MonthlyActivityInfo = {
  __typename?: 'MonthlyActivityInfo';
  collected?: Maybe<Scalars['Float']['output']>;
  collectedCount?: Maybe<Scalars['Int']['output']>;
  dropCount?: Maybe<Scalars['Int']['output']>;
  dropped?: Maybe<Scalars['Float']['output']>;
  redeemCount?: Maybe<Scalars['Int']['output']>;
  startDate?: Maybe<Scalars['String']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptKycDocument?: Maybe<KycDocument>;
  activateRefundRequest?: Maybe<RefundRequest>;
  addKycAttempts?: Maybe<Customer>;
  addPayment?: Maybe<Customer>;
  batchCancelAndRefundOrders?: Maybe<Array<Maybe<CancelAndRefundResult>>>;
  batchCreateSendCloudLabelsForOrder?: Maybe<BatchSendCloudLabelWithParcel>;
  calculateRates?: Maybe<Array<Maybe<ShipStationRate>>>;
  cancelOrder?: Maybe<ShipStationOrder>;
  cancelSubscription?: Maybe<RebillySubscription>;
  cancelSubscriptionAdmin?: Maybe<RebillySubscription>;
  cancelSubscriptions?: Maybe<Array<Maybe<RebillySubscription>>>;
  changeSubscription?: Maybe<RebillySubscription>;
  changeSubscriptionPreview?: Maybe<ChangeSubscription>;
  checkout: CheckoutResponse;
  clearDeviceList?: Maybe<UserInfo>;
  createCustomer?: Maybe<Customer>;
  createKycDocument?: Maybe<KycDocumentResult>;
  createLabelForOrder?: Maybe<ShipStationLabel>;
  createSendCloudLabelsForOrder?: Maybe<Array<Maybe<SendCloudLabelWithParcel>>>;
  createSubscription?: Maybe<RebillySubscription>;
  createTransaction?: Maybe<Transaction>;
  deactivatePaymentCard?: Maybe<PaymentCard>;
  deactivateRefundRequest?: Maybe<RefundRequest>;
  deleteOrder?: Maybe<ShipStationOrder>;
  empty?: Maybe<Scalars['String']['output']>;
  generateRefundRequest?: Maybe<RefundRequest>;
  holdOrder?: Maybe<ShipStationOrder>;
  markOrderAsShipped?: Maybe<MarkedShipped>;
  processRefundRequest?: Maybe<RefundRequest>;
  processedRefundRequest?: Maybe<RefundRequest>;
  reactivateSubscription?: Maybe<RebillySubscription>;
  redeem?: Maybe<Array<Maybe<ActiveSubscriptionInfo>>>;
  refundTransaction?: Maybe<Transaction>;
  refundTransactions?: Maybe<Array<Transaction>>;
  rejectKycDocument?: Maybe<KycDocument>;
  remintAchievement?: Maybe<NftHistory>;
  restoreOrderFromHold?: Maybe<ShipStationOrder>;
  sendToSendCloud?: Maybe<SendToSendCloudResult>;
  updateKycDocument?: Maybe<KycDocumentResult>;
  updateOrderAddress?: Maybe<ShipStationOrder>;
  updateOrderItems?: Maybe<ShipStationOrder>;
  updateOrderNotes?: Maybe<ShipStationOrder>;
  voidLabel?: Maybe<Scalars['Boolean']['output']>;
};


export type MutationAcceptKycDocumentArgs = {
  id: Scalars['String']['input'];
};


export type MutationActivateRefundRequestArgs = {
  id: Scalars['String']['input'];
};


export type MutationAddKycAttemptsArgs = {
  attempts: Scalars['Int']['input'];
  uid: Scalars['String']['input'];
};


export type MutationAddPaymentArgs = {
  authorize?: InputMaybe<Scalars['Boolean']['input']>;
  customer?: InputMaybe<CustomerInput>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  paymentToken: Scalars['String']['input'];
};


export type MutationBatchCancelAndRefundOrdersArgs = {
  orderIds: Array<Scalars['Float']['input']>;
  orderNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationBatchCreateSendCloudLabelsForOrderArgs = {
  orderNumbers: Array<Scalars['String']['input']>;
};


export type MutationCalculateRatesArgs = {
  input: CalculateRatesInput;
};


export type MutationCancelOrderArgs = {
  orderId: Scalars['Float']['input'];
};


export type MutationCancelSubscriptionArgs = {
  canceledBy?: InputMaybe<Scalars['String']['input']>;
  churnTime?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  prorated?: InputMaybe<Scalars['Boolean']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  subscriptionId: Scalars['String']['input'];
};


export type MutationCancelSubscriptionAdminArgs = {
  canceledBy?: InputMaybe<Scalars['String']['input']>;
  churnTime?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  prorated?: InputMaybe<Scalars['Boolean']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  subscriptionId: Scalars['String']['input'];
};


export type MutationCancelSubscriptionsArgs = {
  canceledBy?: InputMaybe<Scalars['String']['input']>;
  churnTime?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  prorated?: InputMaybe<Scalars['Boolean']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  subscriptionIds: Array<Scalars['String']['input']>;
};


export type MutationChangeSubscriptionArgs = {
  effectiveTime?: InputMaybe<Scalars['String']['input']>;
  paymentInstrument?: InputMaybe<PaymentInstrumentInput>;
  planId: Scalars['String']['input'];
  prorated?: InputMaybe<Scalars['Boolean']['input']>;
  renewalPolicy?: InputMaybe<Scalars['String']['input']>;
  stickyGatewayId?: InputMaybe<Scalars['String']['input']>;
  subscriptionId: Scalars['String']['input'];
};


export type MutationChangeSubscriptionPreviewArgs = {
  effectiveTime?: InputMaybe<Scalars['String']['input']>;
  planId: Scalars['String']['input'];
  prorated?: InputMaybe<Scalars['Boolean']['input']>;
  renewalPolicy?: InputMaybe<Scalars['String']['input']>;
  subscriptionId: Scalars['String']['input'];
};


export type MutationCheckoutArgs = {
  billing?: InputMaybe<AddressInput>;
  coupons?: InputMaybe<Array<CouponInput>>;
  customFields?: InputMaybe<TransactionCustomFields>;
  customJson?: InputMaybe<Scalars['JSON']['input']>;
  customer?: InputMaybe<CustomerInput>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  items?: InputMaybe<Array<ItemInput>>;
  paymentInstruction?: InputMaybe<PaymentInstructionInput>;
  paymentInstrument?: InputMaybe<PaymentInstrumentInput>;
  paymentToken?: InputMaybe<Scalars['String']['input']>;
  planId?: InputMaybe<Scalars['String']['input']>;
  shipping?: InputMaybe<AddressInput>;
  shippingAmount?: InputMaybe<Scalars['Float']['input']>;
  stickyGatewayId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationClearDeviceListArgs = {
  reason?: InputMaybe<Scalars['String']['input']>;
  uid: Scalars['String']['input'];
};


export type MutationCreateCustomerArgs = {
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateKycDocumentArgs = {
  input: KycDocumentInput;
};


export type MutationCreateLabelForOrderArgs = {
  input: CreateLabelInput;
};


export type MutationCreateSendCloudLabelsForOrderArgs = {
  orderNumbers: Array<Scalars['String']['input']>;
};


export type MutationCreateSubscriptionArgs = {
  subscription: SubscriptionInput;
};


export type MutationCreateTransactionArgs = {
  customFields?: InputMaybe<TransactionCustomFields>;
  customJson?: InputMaybe<Scalars['JSON']['input']>;
  customer?: InputMaybe<CustomerInput>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  invoiceId?: InputMaybe<Scalars['String']['input']>;
  invoiceIds?: InputMaybe<Array<Scalars['String']['input']>>;
  paymentInstruction?: InputMaybe<PaymentInstructionInput>;
  paymentInstrument?: InputMaybe<PaymentInstrumentInput>;
};


export type MutationDeactivatePaymentCardArgs = {
  paymentCardId: Scalars['String']['input'];
};


export type MutationDeactivateRefundRequestArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteOrderArgs = {
  orderId: Scalars['Float']['input'];
};


export type MutationGenerateRefundRequestArgs = {
  expireSeconds?: InputMaybe<Scalars['Int']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  uid: Scalars['String']['input'];
};


export type MutationHoldOrderArgs = {
  holdUntilDate: Scalars['String']['input'];
  orderId: Scalars['Float']['input'];
};


export type MutationMarkOrderAsShippedArgs = {
  input: MarkShippedInput;
};


export type MutationProcessRefundRequestArgs = {
  id: Scalars['String']['input'];
};


export type MutationProcessedRefundRequestArgs = {
  id: Scalars['String']['input'];
};


export type MutationReactivateSubscriptionArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  effectiveTime?: InputMaybe<Scalars['String']['input']>;
  renewalTime?: InputMaybe<Scalars['String']['input']>;
  subscriptionId: Scalars['String']['input'];
};


export type MutationRedeemArgs = {
  dry?: InputMaybe<Scalars['Boolean']['input']>;
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  uids?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationRefundTransactionArgs = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['String']['input'];
};


export type MutationRefundTransactionsArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type MutationRejectKycDocumentArgs = {
  id: Scalars['String']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRemintAchievementArgs = {
  address: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  reference: Scalars['String']['input'];
};


export type MutationRestoreOrderFromHoldArgs = {
  orderId: Scalars['Float']['input'];
};


export type MutationSendToSendCloudArgs = {
  orderId: Scalars['Float']['input'];
};


export type MutationUpdateKycDocumentArgs = {
  id: Scalars['String']['input'];
  input: KycDocumentInput;
};


export type MutationUpdateOrderAddressArgs = {
  input: OrderAddressInput;
  orderId: Scalars['Float']['input'];
};


export type MutationUpdateOrderItemsArgs = {
  items: Array<OrderItemInput>;
  orderId: Scalars['Float']['input'];
};


export type MutationUpdateOrderNotesArgs = {
  input: OrderNotesInput;
  orderId: Scalars['Float']['input'];
};


export type MutationVoidLabelArgs = {
  orderId: Scalars['Float']['input'];
  shipmentId: Scalars['Float']['input'];
};

export type NftHistory = {
  __typename?: 'NftHistory';
  achievement?: Maybe<Scalars['String']['output']>;
  completedTime?: Maybe<Scalars['String']['output']>;
  ethAddress?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  initialHash?: Maybe<Scalars['String']['output']>;
  mintError?: Maybe<Scalars['String']['output']>;
  nftId?: Maybe<Scalars['Int']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  requestedTime?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  transactionHash?: Maybe<Scalars['String']['output']>;
  uid?: Maybe<Scalars['String']['output']>;
};

export type ObjectIdFilter = {
  ALL?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  EQ?: InputMaybe<Scalars['ObjectId']['input']>;
  GT?: InputMaybe<Scalars['ObjectId']['input']>;
  GTE?: InputMaybe<Scalars['ObjectId']['input']>;
  IN?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  LT?: InputMaybe<Scalars['ObjectId']['input']>;
  LTE?: InputMaybe<Scalars['ObjectId']['input']>;
  NE?: InputMaybe<Scalars['ObjectId']['input']>;
  NIN?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
};

export type OrderAddressInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street1?: InputMaybe<Scalars['String']['input']>;
  street2?: InputMaybe<Scalars['String']['input']>;
  street3?: InputMaybe<Scalars['String']['input']>;
};

export type OrderItemInput = {
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
  weight?: InputMaybe<ShipStationWeightInput>;
};

export type OrderNotesInput = {
  customerNotes?: InputMaybe<Scalars['String']['input']>;
  gift?: InputMaybe<Scalars['Boolean']['input']>;
  giftMessage?: InputMaybe<Scalars['String']['input']>;
  internalNotes?: InputMaybe<Scalars['String']['input']>;
};

export type Pagination = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};

export type PaidByTime = {
  time: Scalars['String']['input'];
};

export type PaymentCard = {
  __typename?: 'PaymentCard';
  bankCountry?: Maybe<Scalars['String']['output']>;
  bankName?: Maybe<Scalars['String']['output']>;
  billingAddress?: Maybe<Address>;
  billingContact?: Maybe<Scalars['String']['output']>;
  billingContactId?: Maybe<Scalars['String']['output']>;
  bin?: Maybe<Scalars['String']['output']>;
  brand?: Maybe<Scalars['String']['output']>;
  createdTime?: Maybe<Scalars['String']['output']>;
  customFields?: Maybe<Scalars['JSON']['output']>;
  customer?: Maybe<Scalars['String']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  digitalWallet?: Maybe<Scalars['String']['output']>;
  expMonth?: Maybe<Scalars['Int']['output']>;
  expYear?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  last4?: Maybe<Scalars['String']['output']>;
  method?: Maybe<Scalars['String']['output']>;
  panFingerprint?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  stickyGatewayAccountId?: Maybe<Scalars['String']['output']>;
  updatedTime?: Maybe<Scalars['String']['output']>;
};

export type PaymentInstructionInput = {
  paymentInstrumentId?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};

export type PaymentInstrumentId = {
  __typename?: 'PaymentInstrumentId';
  method?: Maybe<Scalars['String']['output']>;
  paymentCardId?: Maybe<Scalars['String']['output']>;
};

export type PaymentInstrumentInput = {
  method?: InputMaybe<Scalars['String']['input']>;
  paymentCardId?: InputMaybe<Scalars['String']['input']>;
};

export type Plan = {
  __typename?: 'Plan';
  billingAnchor?: Maybe<BillingAnchor>;
  contractTermLength?: Maybe<Scalars['Int']['output']>;
  contractTermUnit?: Maybe<Scalars['Float']['output']>;
  createdTime?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  currencySign?: Maybe<Scalars['String']['output']>;
  customFields?: Maybe<Scalars['JSON']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  expireTime?: Maybe<Scalars['String']['output']>;
  expiredTime?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isActive?: Maybe<Scalars['Boolean']['output']>;
  maxQuantity?: Maybe<Scalars['Int']['output']>;
  meteredBilling?: Maybe<Scalars['Boolean']['output']>;
  minQuantity?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  planType?: Maybe<Scalars['String']['output']>;
  pricing?: Maybe<Pricing>;
  productId?: Maybe<Scalars['String']['output']>;
  productOptions?: Maybe<Scalars['JSON']['output']>;
  recurringAmount?: Maybe<Scalars['Float']['output']>;
  recurringInterval?: Maybe<RecurringInterval>;
  recurringPeriodLength?: Maybe<Scalars['Int']['output']>;
  recurringPeriodLimit?: Maybe<Scalars['Int']['output']>;
  recurringPeriodUnit?: Maybe<Scalars['String']['output']>;
  richDescription?: Maybe<Scalars['String']['output']>;
  setup?: Maybe<Setup>;
  setupAmount?: Maybe<Scalars['Float']['output']>;
  subscriptionCount?: Maybe<Scalars['Int']['output']>;
  trial?: Maybe<Trial>;
  trialAmount?: Maybe<Scalars['Float']['output']>;
  trialPeriodLength?: Maybe<Scalars['Int']['output']>;
  trialPeriodUnit?: Maybe<Scalars['String']['output']>;
  updatedTime?: Maybe<Scalars['String']['output']>;
};

export type PlanInput = {
  currency?: InputMaybe<Scalars['String']['input']>;
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  pricing?: InputMaybe<PricingInput>;
  productId: Scalars['String']['input'];
  productOptions?: InputMaybe<Scalars['JSON']['input']>;
};

export type Pricing = {
  __typename?: 'Pricing';
  formula?: Maybe<Scalars['String']['output']>;
  maxQuantity?: Maybe<Scalars['Int']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
};

export type PricingInput = {
  formula?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
};

export type Product = {
  __typename?: 'Product';
  _links?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  accountingCode?: Maybe<Scalars['String']['output']>;
  createdTime?: Maybe<Scalars['String']['output']>;
  customFields?: Maybe<Scalars['JSON']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  options?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  requiresShipping?: Maybe<Scalars['Boolean']['output']>;
  taxCategoryId?: Maybe<Scalars['String']['output']>;
  unitLabel?: Maybe<Scalars['String']['output']>;
  updatedTime?: Maybe<Scalars['String']['output']>;
};

export type Profile = {
  __typename?: 'Profile';
  customer?: Maybe<Customer>;
  email?: Maybe<Scalars['String']['output']>;
  inAppSubscription?: Maybe<InAppSubscription>;
  photoURL?: Maybe<Scalars['String']['output']>;
  uid?: Maybe<Scalars['String']['output']>;
  userInfo?: Maybe<UserInfo>;
};

export type Query = {
  __typename?: 'Query';
  about?: Maybe<About>;
  account?: Maybe<Account>;
  accounts?: Maybe<Array<Maybe<Account>>>;
  androidSubscription?: Maybe<AndroidSubscription>;
  appleSubscription?: Maybe<AppleSubscription>;
  coinPlans?: Maybe<Array<Maybe<Plan>>>;
  cumulativeSubscriptionCount?: Maybe<CumulativeSubscriptionCountResult>;
  cumulativeTransactionCount?: Maybe<CumulativeTransactionCountResult>;
  customFields?: Maybe<TransactionCustomFieldsResult>;
  customer?: Maybe<Customer>;
  customerProfileByUid?: Maybe<Profile>;
  customers?: Maybe<Array<Maybe<Customer>>>;
  empty?: Maybe<Scalars['String']['output']>;
  findAccounts?: Maybe<Array<Maybe<Account>>>;
  getCarrier?: Maybe<ShipStationCarrier>;
  getOrder?: Maybe<ShipStationOrder>;
  getParcel?: Maybe<SendCloudParcel>;
  invoice?: Maybe<Invoice>;
  invoices?: Maybe<Array<Maybe<Invoice>>>;
  kycDocumentById?: Maybe<KycDocument>;
  listCarriers?: Maybe<ShipStationCarrierPage>;
  listFulfillments?: Maybe<ShipStationFulfillmentPage>;
  listOrders?: Maybe<ShipStationOrderPage>;
  listOrdersByTag?: Maybe<ShipStationOrderPage>;
  listProducts?: Maybe<ShipStationProductPage>;
  listShipments?: Maybe<ShipStationShipmentPage>;
  listStores?: Maybe<ShipStationStorePage>;
  listTags?: Maybe<ShipStationTagPage>;
  listWarehouses?: Maybe<ShipStationWarehousePage>;
  manySubscriptions?: Maybe<RebillySubscriptionPage>;
  me?: Maybe<Customer>;
  plan?: Maybe<Plan>;
  plans?: Maybe<Array<Maybe<Plan>>>;
  recoverAccounts?: Maybe<Array<Maybe<UserInfo>>>;
  refundRequest?: Maybe<RefundRequest>;
  refundRequests?: Maybe<RefundRequestPage>;
  subscription?: Maybe<RebillySubscription>;
  subscriptionCount?: Maybe<Scalars['Int']['output']>;
  subscriptions?: Maybe<Array<Maybe<RebillySubscription>>>;
  transaction?: Maybe<Transaction>;
  transactions?: Maybe<Array<Maybe<Transaction>>>;
  userInfoPage?: Maybe<UserInfoPage>;
};


export type QueryAccountsArgs = {
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  uids?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryAndroidSubscriptionArgs = {
  id: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type QueryAppleSubscriptionArgs = {
  id: Scalars['String']['input'];
};


export type QueryCoinPlansArgs = {
  planType?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCumulativeSubscriptionCountArgs = {
  end?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCumulativeTransactionCountArgs = {
  end?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCustomFieldsArgs = {
  customFields?: InputMaybe<TransactionCustomFields>;
};


export type QueryCustomerArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCustomerProfileByUidArgs = {
  uid: Scalars['String']['input'];
};


export type QueryCustomersArgs = {
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  uids?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryFindAccountsArgs = {
  search: Scalars['String']['input'];
};


export type QueryGetCarrierArgs = {
  carrierCode: Scalars['String']['input'];
};


export type QueryGetOrderArgs = {
  orderId: Scalars['Float']['input'];
};


export type QueryGetParcelArgs = {
  parcelId?: InputMaybe<Scalars['Float']['input']>;
  trackingNumber?: InputMaybe<Scalars['String']['input']>;
};


export type QueryInvoiceArgs = {
  id: Scalars['String']['input'];
};


export type QueryInvoicesArgs = {
  customerId: Scalars['String']['input'];
};


export type QueryKycDocumentByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryListFulfillmentsArgs = {
  filter?: InputMaybe<ShipStationFulfillmentsFilter>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<Sort>;
};


export type QueryListOrdersArgs = {
  filter?: InputMaybe<ShipStationOrderFilter>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<Sort>;
};


export type QueryListOrdersByTagArgs = {
  filter: ShipStationOrderByTagFilter;
  pagination?: InputMaybe<Pagination>;
};


export type QueryListProductsArgs = {
  filter?: InputMaybe<ShipStationProductFilter>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<Sort>;
};


export type QueryListShipmentsArgs = {
  filter?: InputMaybe<ShipStationShipmentsFilter>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<Sort>;
};


export type QueryListStoresArgs = {
  filter?: InputMaybe<ShipStationStoresFilter>;
};


export type QueryManySubscriptionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  planType?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPlanArgs = {
  id: Scalars['String']['input'];
};


export type QueryRecoverAccountsArgs = {
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryRefundRequestArgs = {
  id: Scalars['String']['input'];
};


export type QueryRefundRequestsArgs = {
  filter?: InputMaybe<RefundRequestFilter>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<Sort>;
};


export type QuerySubscriptionArgs = {
  id: Scalars['String']['input'];
};


export type QuerySubscriptionCountArgs = {
  planIds?: InputMaybe<Array<Scalars['String']['input']>>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySubscriptionsArgs = {
  customerId: Scalars['String']['input'];
};


export type QueryTransactionArgs = {
  id: Scalars['String']['input'];
};


export type QueryTransactionsArgs = {
  customerId: Scalars['String']['input'];
};


export type QueryUserInfoPageArgs = {
  filter?: InputMaybe<UserInfoFilter>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<Sort>;
};

export type RebillyFile = {
  __typename?: 'RebillyFile';
  createdTime?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  extension?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isPublic?: Maybe<Scalars['Boolean']['output']>;
  mime?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  sha1?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  updatedTime?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};

export type RebillyFileInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  file: Scalars['String']['input'];
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type RebillySub = {
  __typename?: 'RebillySub';
  subscriptionId?: Maybe<Scalars['String']['output']>;
  transactions?: Maybe<Array<RebillyTrans>>;
};

export type RebillySubscription = {
  __typename?: 'RebillySubscription';
  activationTime?: Maybe<Scalars['String']['output']>;
  autopay?: Maybe<Scalars['Boolean']['output']>;
  billingAddress?: Maybe<Address>;
  billingAnchor?: Maybe<Scalars['String']['output']>;
  billingStatus?: Maybe<Scalars['String']['output']>;
  cancelCategory?: Maybe<Scalars['String']['output']>;
  cancelDescription?: Maybe<Scalars['String']['output']>;
  canceledBy?: Maybe<Scalars['String']['output']>;
  canceledTime?: Maybe<Scalars['String']['output']>;
  createdTime?: Maybe<Scalars['String']['output']>;
  customFields?: Maybe<Scalars['JSON']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  deliveryAddress?: Maybe<Address>;
  endTime?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  inTrial?: Maybe<Scalars['Boolean']['output']>;
  initialInvoice?: Maybe<Invoice>;
  initialInvoiceId?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Array<Maybe<SubscriptionItem>>>;
  orderType?: Maybe<Scalars['String']['output']>;
  planId?: Maybe<Scalars['String']['output']>;
  planIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  planType?: Maybe<Scalars['String']['output']>;
  poNumber?: Maybe<Scalars['Int']['output']>;
  rebillNumber?: Maybe<Scalars['Int']['output']>;
  recentInvoice?: Maybe<Invoice>;
  recentInvoiceId?: Maybe<Scalars['String']['output']>;
  recurringInterval?: Maybe<Scalars['Int']['output']>;
  renewalTime?: Maybe<Scalars['String']['output']>;
  riskMetadata?: Maybe<RiskMetadata>;
  startTime?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  upcomingInvoice?: Maybe<Invoice>;
  updatedTime?: Maybe<Scalars['String']['output']>;
  websiteId?: Maybe<Scalars['String']['output']>;
};

export type RebillySubscriptionPage = {
  __typename?: 'RebillySubscriptionPage';
  data?: Maybe<Array<Maybe<RebillySubscription>>>;
  limit?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type RebillyTrans = {
  __typename?: 'RebillyTrans';
  amount: Scalars['Float']['output'];
  createdTime?: Maybe<Scalars['String']['output']>;
  transactionId: Scalars['String']['output'];
};

export type RecurringInterval = {
  __typename?: 'RecurringInterval';
  billingTime?: Maybe<Scalars['String']['output']>;
  length?: Maybe<Scalars['Int']['output']>;
  limit?: Maybe<Scalars['Int']['output']>;
  periodAnchorInstruction?: Maybe<InstructionMethod>;
  unit?: Maybe<Scalars['String']['output']>;
};

export type RedemptionsPerCustomer = {
  quantity: Scalars['Int']['input'];
};

export type RefundRequest = {
  __typename?: 'RefundRequest';
  accepted?: Maybe<Scalars['Boolean']['output']>;
  acceptedDate?: Maybe<Scalars['String']['output']>;
  active?: Maybe<Scalars['Boolean']['output']>;
  activeSubscription?: Maybe<Scalars['String']['output']>;
  androidErr?: Maybe<Scalars['String']['output']>;
  androidSub?: Maybe<Scalars['JSON']['output']>;
  collectedAmount?: Maybe<Scalars['Float']['output']>;
  collectedAmountRange?: Maybe<Scalars['JSON']['output']>;
  collectedCount?: Maybe<Scalars['Int']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  dropCount?: Maybe<Scalars['Int']['output']>;
  droppedAmount?: Maybe<Scalars['Float']['output']>;
  eligibleAmount?: Maybe<Scalars['Float']['output']>;
  eligibleMessage?: Maybe<Scalars['String']['output']>;
  eligibleMonths?: Maybe<Scalars['Int']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  expireAt?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  iosErr?: Maybe<Scalars['String']['output']>;
  iosSub?: Maybe<Scalars['JSON']['output']>;
  photoURL?: Maybe<Scalars['String']['output']>;
  rebillyErr?: Maybe<Scalars['String']['output']>;
  rebillySub?: Maybe<RebillySub>;
  redeemCount?: Maybe<Scalars['Int']['output']>;
  refunded?: Maybe<Scalars['Boolean']['output']>;
  refundedDate?: Maybe<Scalars['String']['output']>;
  refunding?: Maybe<Scalars['Boolean']['output']>;
  resetXyoCollectedAmount?: Maybe<Scalars['Float']['output']>;
  startTime?: Maybe<Scalars['String']['output']>;
  sweepstakesAmount?: Maybe<Scalars['Float']['output']>;
  sweepstakesCount?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  uid?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  xyoCollected?: Maybe<Scalars['Float']['output']>;
  xyoSweepstakes?: Maybe<Scalars['Float']['output']>;
};

export type RefundRequestFilter = {
  accepted?: InputMaybe<Scalars['Boolean']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<StringFilter>;
  refunded?: InputMaybe<Scalars['Boolean']['input']>;
  refunding?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<StringFilter>;
  uid?: InputMaybe<StringFilter>;
};

export type RefundRequestPage = {
  __typename?: 'RefundRequestPage';
  data?: Maybe<Array<Maybe<RefundRequest>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type RejectionReason = {
  __typename?: 'RejectionReason';
  message?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type RestrictToInvoices = {
  invoiceIds: Array<Scalars['String']['input']>;
};

export type RestrictToPlans = {
  planIds: Array<Scalars['String']['input']>;
};

export type RestrictToProducts = {
  productIds: Array<Scalars['String']['input']>;
};

export type RestrictToSubscriptions = {
  subscriptionIds: Array<Scalars['String']['input']>;
};

export type RiskMetadata = {
  __typename?: 'RiskMetadata';
  accuracyRadius?: Maybe<Scalars['Float']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  distance?: Maybe<Scalars['Float']['output']>;
  fingerprint?: Maybe<Scalars['String']['output']>;
  httpHeaders?: Maybe<Scalars['JSON']['output']>;
  ipAddress?: Maybe<Scalars['String']['output']>;
  isHosting?: Maybe<Scalars['Boolean']['output']>;
  isProxy?: Maybe<Scalars['Boolean']['output']>;
  isTor?: Maybe<Scalars['Boolean']['output']>;
  isVpn?: Maybe<Scalars['Boolean']['output']>;
  isp?: Maybe<Scalars['String']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  score?: Maybe<Scalars['Int']['output']>;
  timeZone?: Maybe<Scalars['String']['output']>;
  vpnServiceName?: Maybe<Scalars['String']['output']>;
};

export type SendCloudAddressDivided = {
  __typename?: 'SendCloudAddressDivided';
  house_number?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
};

export type SendCloudCountry = {
  __typename?: 'SendCloudCountry';
  iso_2?: Maybe<Scalars['String']['output']>;
  iso_3?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type SendCloudLabel = {
  __typename?: 'SendCloudLabel';
  label_printer?: Maybe<Scalars['String']['output']>;
  normal_printer?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type SendCloudLabelWithParcel = {
  __typename?: 'SendCloudLabelWithParcel';
  error?: Maybe<Scalars['String']['output']>;
  label_printer?: Maybe<Scalars['String']['output']>;
  normal_printer?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  parcel?: Maybe<SendCloudParcel>;
  parcelId?: Maybe<Scalars['Float']['output']>;
};

export type SendCloudParcel = {
  __typename?: 'SendCloudParcel';
  address?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  address_divided?: Maybe<SendCloudAddressDivided>;
  city?: Maybe<Scalars['String']['output']>;
  company_name?: Maybe<Scalars['String']['output']>;
  country?: Maybe<SendCloudCountry>;
  customs_declaration?: Maybe<Scalars['JSON']['output']>;
  data?: Maybe<Scalars['JSON']['output']>;
  date_created?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  external_order_id?: Maybe<Scalars['String']['output']>;
  external_reference?: Maybe<Scalars['String']['output']>;
  external_shipment_id?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  label?: Maybe<SendCloudLabel>;
  name?: Maybe<Scalars['String']['output']>;
  order_number?: Maybe<Scalars['String']['output']>;
  parcel_items?: Maybe<Array<Maybe<SendCloudParcelItem>>>;
  postal_code?: Maybe<Scalars['String']['output']>;
  shipment?: Maybe<SendCloudShipment>;
  shipment_uuid?: Maybe<Scalars['String']['output']>;
  status?: Maybe<SendCloudStatus>;
  telephone?: Maybe<Scalars['String']['output']>;
  tracking_number?: Maybe<Scalars['String']['output']>;
  tracking_url?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['String']['output']>;
};

export type SendCloudParcelInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  address_2?: InputMaybe<Scalars['String']['input']>;
  apply_shipping_rules?: InputMaybe<Scalars['Boolean']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  company_name?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  customs_invoice_nr?: InputMaybe<Scalars['String']['input']>;
  customs_shipment_type?: InputMaybe<Scalars['Int']['input']>;
  data?: InputMaybe<Scalars['JSON']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  external_order_id?: InputMaybe<Scalars['String']['input']>;
  external_reference?: InputMaybe<Scalars['String']['input']>;
  external_shipment_id?: InputMaybe<Scalars['String']['input']>;
  house_number?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order_number?: InputMaybe<Scalars['String']['input']>;
  order_status?: InputMaybe<SendCloudParcelStatusInput>;
  parcel_items?: InputMaybe<Array<InputMaybe<SendCloudParcelItemInput>>>;
  payment_status?: InputMaybe<SendCloudParcelPaymentStatusInput>;
  postal_code?: InputMaybe<Scalars['String']['input']>;
  request_label?: InputMaybe<Scalars['Boolean']['input']>;
  request_label_async?: InputMaybe<Scalars['Boolean']['input']>;
  sender_address?: InputMaybe<Scalars['Float']['input']>;
  shipment?: InputMaybe<SendCloudParcelShipmentInput>;
  shipping_method?: InputMaybe<Scalars['Float']['input']>;
  shipping_method_checkout_name?: InputMaybe<Scalars['String']['input']>;
  telephone?: InputMaybe<Scalars['String']['input']>;
  to_post_number?: InputMaybe<Scalars['String']['input']>;
  to_service_point?: InputMaybe<Scalars['String']['input']>;
  to_state?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['String']['input']>;
};

export type SendCloudParcelItem = {
  __typename?: 'SendCloudParcelItem';
  description?: Maybe<Scalars['String']['output']>;
  hs_code?: Maybe<Scalars['String']['output']>;
  origin_country?: Maybe<Scalars['String']['output']>;
  product_id?: Maybe<Scalars['String']['output']>;
  properties?: Maybe<Scalars['JSON']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  sku?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['String']['output']>;
};

export type SendCloudParcelItemInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  hs_code?: InputMaybe<Scalars['String']['input']>;
  origin_country?: InputMaybe<Scalars['String']['input']>;
  product_id?: InputMaybe<Scalars['String']['input']>;
  properties?: InputMaybe<Scalars['JSON']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['String']['input']>;
};

export type SendCloudParcelPaymentStatusInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
};

export type SendCloudParcelShipmentInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type SendCloudParcelStatusInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
};

export type SendCloudShipment = {
  __typename?: 'SendCloudShipment';
  id?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type SendCloudStatus = {
  __typename?: 'SendCloudStatus';
  id?: Maybe<Scalars['Float']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type SendToSendCloudResult = {
  __typename?: 'SendToSendCloudResult';
  order?: Maybe<ShipStationOrder>;
  orderId?: Maybe<Scalars['Float']['output']>;
  parcel?: Maybe<SendCloudParcel>;
};

export type Setup = {
  __typename?: 'Setup';
  price?: Maybe<Scalars['Float']['output']>;
};

export type ShipStationAddress = {
  __typename?: 'ShipStationAddress';
  addressVerified?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  residential?: Maybe<Scalars['Boolean']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street1?: Maybe<Scalars['String']['output']>;
  street2?: Maybe<Scalars['String']['output']>;
  street3?: Maybe<Scalars['String']['output']>;
};

export type ShipStationAdvancedOptions = {
  __typename?: 'ShipStationAdvancedOptions';
  billToAccount?: Maybe<Scalars['String']['output']>;
  billToCountryCode?: Maybe<Scalars['String']['output']>;
  billToMyOtherAccount?: Maybe<Scalars['String']['output']>;
  billToParty?: Maybe<Scalars['String']['output']>;
  billToPostalCode?: Maybe<Scalars['String']['output']>;
  containsAlcohol?: Maybe<Scalars['Boolean']['output']>;
  customField1?: Maybe<Scalars['String']['output']>;
  customField2?: Maybe<Scalars['String']['output']>;
  customField3?: Maybe<Scalars['String']['output']>;
  mergedIds?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  mergedOrSplit?: Maybe<Scalars['Boolean']['output']>;
  nonMachinable?: Maybe<Scalars['Boolean']['output']>;
  parentId?: Maybe<Scalars['Float']['output']>;
  saturdayDelivery?: Maybe<Scalars['Boolean']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  storeId?: Maybe<Scalars['Int']['output']>;
  warehouseId?: Maybe<Scalars['Int']['output']>;
};

export type ShipStationAdvancedOptionsInput = {
  warehouseId?: InputMaybe<Scalars['Int']['input']>;
};

export type ShipStationCarrier = {
  __typename?: 'ShipStationCarrier';
  accountNumber?: Maybe<Scalars['String']['output']>;
  balance?: Maybe<Scalars['Float']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nickname?: Maybe<Scalars['String']['output']>;
  packages?: Maybe<Array<Maybe<ShipStationCarrierPackage>>>;
  primary?: Maybe<Scalars['Boolean']['output']>;
  requiresFundedAccount?: Maybe<Scalars['Boolean']['output']>;
  services?: Maybe<Array<Maybe<ShipStationCarrierService>>>;
  shippingProviderId?: Maybe<Scalars['Int']['output']>;
};

export type ShipStationCarrierPackage = {
  __typename?: 'ShipStationCarrierPackage';
  carrierCode?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  domestic?: Maybe<Scalars['Boolean']['output']>;
  international?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type ShipStationCarrierPage = {
  __typename?: 'ShipStationCarrierPage';
  data?: Maybe<Array<Maybe<ShipStationCarrier>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type ShipStationCarrierService = {
  __typename?: 'ShipStationCarrierService';
  carrierCode?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  domestic?: Maybe<Scalars['Boolean']['output']>;
  international?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export enum ShipStationConfirmation {
  AdultSignature = 'adult_signature',
  Delivery = 'delivery',
  DirectSignature = 'direct_signature',
  None = 'none',
  Signature = 'signature'
}

export type ShipStationCustomsItem = {
  __typename?: 'ShipStationCustomsItem';
  countryOfOrigin?: Maybe<Scalars['String']['output']>;
  customsItemId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  harmonizedTariffCode?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type ShipStationCustomsItemInput = {
  countryOfOrigin?: InputMaybe<Scalars['String']['input']>;
  customsItemId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  harmonizedTariffCode?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export enum ShipStationDimensionUnit {
  Centimeters = 'centimeters',
  Inches = 'inches'
}

export type ShipStationDimensions = {
  __typename?: 'ShipStationDimensions';
  height?: Maybe<Scalars['Float']['output']>;
  length?: Maybe<Scalars['Float']['output']>;
  units?: Maybe<ShipStationDimensionUnit>;
  width?: Maybe<Scalars['Float']['output']>;
};

export type ShipStationDimensionsInput = {
  height?: InputMaybe<Scalars['Float']['input']>;
  length?: InputMaybe<Scalars['Float']['input']>;
  units?: InputMaybe<ShipStationDimensionUnit>;
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type ShipStationFulfillment = {
  __typename?: 'ShipStationFulfillment';
  carrierCode?: Maybe<Scalars['String']['output']>;
  createDate?: Maybe<Scalars['String']['output']>;
  customerEmail?: Maybe<Scalars['String']['output']>;
  deliveryDate?: Maybe<Scalars['String']['output']>;
  fulfillmentFee?: Maybe<Scalars['Float']['output']>;
  fulfillmentId?: Maybe<Scalars['Float']['output']>;
  fulfillmentProviderCode?: Maybe<Scalars['String']['output']>;
  fulfillmentServiceCode?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  marketplaceNotified?: Maybe<Scalars['Boolean']['output']>;
  notifyErrorMessage?: Maybe<Scalars['String']['output']>;
  orderId?: Maybe<Scalars['Float']['output']>;
  orderNumber?: Maybe<Scalars['String']['output']>;
  shipDate?: Maybe<Scalars['String']['output']>;
  shipTo?: Maybe<ShipStationAddress>;
  trackingNumber?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
  voidDate?: Maybe<Scalars['String']['output']>;
  voidRequested?: Maybe<Scalars['Boolean']['output']>;
  voided?: Maybe<Scalars['Boolean']['output']>;
};

export type ShipStationFulfillmentPage = {
  __typename?: 'ShipStationFulfillmentPage';
  data?: Maybe<Array<Maybe<ShipStationFulfillment>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type ShipStationFulfillmentsFilter = {
  createDateEnd?: InputMaybe<Scalars['String']['input']>;
  createDateStart?: InputMaybe<Scalars['String']['input']>;
  fulfillmentId?: InputMaybe<Scalars['Float']['input']>;
  orderId?: InputMaybe<Scalars['Float']['input']>;
  orderNumber?: InputMaybe<Scalars['String']['input']>;
  recipientName?: InputMaybe<Scalars['String']['input']>;
  shipDateEnd?: InputMaybe<Scalars['String']['input']>;
  shipDateStart?: InputMaybe<Scalars['String']['input']>;
  trackingNumber?: InputMaybe<Scalars['String']['input']>;
};

export type ShipStationInsuranceOptions = {
  __typename?: 'ShipStationInsuranceOptions';
  insureShipment?: Maybe<Scalars['Boolean']['output']>;
  insuredValue?: Maybe<Scalars['Float']['output']>;
  provider?: Maybe<Scalars['String']['output']>;
};

export type ShipStationInsuranceOptionsInput = {
  insureShipment?: InputMaybe<Scalars['Boolean']['input']>;
  insuredValue?: InputMaybe<Scalars['Float']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
};

export enum ShipStationInternationalContents {
  Documents = 'documents',
  Gift = 'gift',
  Merchandise = 'merchandise',
  ReturnedGoods = 'returned_goods',
  Sample = 'sample'
}

export enum ShipStationInternationalNonDelivery {
  ReturnToSender = 'return_to_sender',
  TreatAsAbandoned = 'treat_as_abandoned'
}

export type ShipStationInternationalOptions = {
  __typename?: 'ShipStationInternationalOptions';
  contents?: Maybe<ShipStationInternationalContents>;
  customsItems?: Maybe<Array<Maybe<ShipStationCustomsItem>>>;
  nonDelivery?: Maybe<ShipStationInternationalNonDelivery>;
};

export type ShipStationInternationalOptionsInput = {
  contents?: InputMaybe<Scalars['String']['input']>;
  customsItems?: InputMaybe<Array<InputMaybe<ShipStationCustomsItemInput>>>;
  nonDelivery?: InputMaybe<Scalars['String']['input']>;
};

export type ShipStationLabel = {
  __typename?: 'ShipStationLabel';
  formData?: Maybe<Scalars['String']['output']>;
  insuranceCost?: Maybe<Scalars['Float']['output']>;
  labelData?: Maybe<Scalars['String']['output']>;
  shipmentCost?: Maybe<Scalars['Float']['output']>;
  shipmentId?: Maybe<Scalars['Float']['output']>;
  trackingNumber?: Maybe<Scalars['String']['output']>;
};

export type ShipStationOrder = {
  __typename?: 'ShipStationOrder';
  advancedOptions?: Maybe<ShipStationAdvancedOptions>;
  amountPaid?: Maybe<Scalars['Float']['output']>;
  billTo?: Maybe<ShipStationAddress>;
  carrierCode?: Maybe<Scalars['String']['output']>;
  confirmation?: Maybe<ShipStationConfirmation>;
  createDate?: Maybe<Scalars['String']['output']>;
  customerEmail?: Maybe<Scalars['String']['output']>;
  customerId?: Maybe<Scalars['Float']['output']>;
  customerNotes?: Maybe<Scalars['String']['output']>;
  customerUsername?: Maybe<Scalars['String']['output']>;
  dimensions?: Maybe<ShipStationDimensions>;
  externallyFulfilled?: Maybe<Scalars['Boolean']['output']>;
  externallyFulfilledBy?: Maybe<Scalars['String']['output']>;
  gift?: Maybe<Scalars['Boolean']['output']>;
  giftMessage?: Maybe<Scalars['String']['output']>;
  holdUntilDate?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  insuranceOptions?: Maybe<ShipStationInsuranceOptions>;
  internalNotes?: Maybe<Scalars['String']['output']>;
  internationalOptions?: Maybe<ShipStationInternationalOptions>;
  items?: Maybe<Array<Maybe<ShipStationOrderItem>>>;
  modifyDate?: Maybe<Scalars['String']['output']>;
  orderDate?: Maybe<Scalars['String']['output']>;
  orderId?: Maybe<Scalars['Float']['output']>;
  orderKey?: Maybe<Scalars['String']['output']>;
  orderNumber?: Maybe<Scalars['String']['output']>;
  orderStatus?: Maybe<ShipStationOrderStatus>;
  orderTotal?: Maybe<Scalars['Float']['output']>;
  packageCode?: Maybe<Scalars['String']['output']>;
  paymentDate?: Maybe<Scalars['String']['output']>;
  paymentMethod?: Maybe<Scalars['String']['output']>;
  requestedShippingService?: Maybe<Scalars['String']['output']>;
  serviceCode?: Maybe<Scalars['String']['output']>;
  shipByDate?: Maybe<Scalars['String']['output']>;
  shipDate?: Maybe<Scalars['String']['output']>;
  shipTo?: Maybe<ShipStationAddress>;
  shippingAmount?: Maybe<Scalars['Float']['output']>;
  tagIds?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  taxAmount?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<ShipStationWeight>;
};

export type ShipStationOrderActivity = {
  __typename?: 'ShipStationOrderActivity';
  changes?: Maybe<Scalars['JSON']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  labelData?: Maybe<Scalars['String']['output']>;
  orderId?: Maybe<Scalars['Float']['output']>;
  trackingNumber?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  uid?: Maybe<Scalars['String']['output']>;
};

export type ShipStationOrderByTagFilter = {
  orderStatus: ShipStationOrderStatus;
  tagId: Scalars['Int']['input'];
};

export type ShipStationOrderFilter = {
  createDateEnd?: InputMaybe<Scalars['String']['input']>;
  createDateStart?: InputMaybe<Scalars['String']['input']>;
  customerName?: InputMaybe<Scalars['String']['input']>;
  itemKeyword?: InputMaybe<Scalars['String']['input']>;
  modifyDateEnd?: InputMaybe<Scalars['String']['input']>;
  modifyDateStart?: InputMaybe<Scalars['String']['input']>;
  orderDateEnd?: InputMaybe<Scalars['String']['input']>;
  orderDateStart?: InputMaybe<Scalars['String']['input']>;
  orderNumber?: InputMaybe<Scalars['String']['input']>;
  orderStatus?: InputMaybe<ShipStationOrderStatus>;
  paymentDateEnd?: InputMaybe<Scalars['String']['input']>;
  paymentDateStart?: InputMaybe<Scalars['String']['input']>;
  storeId?: InputMaybe<Scalars['Int']['input']>;
};

export type ShipStationOrderItem = {
  __typename?: 'ShipStationOrderItem';
  adjustment?: Maybe<Scalars['Boolean']['output']>;
  createDate?: Maybe<Scalars['String']['output']>;
  fulfillmentSku?: Maybe<Scalars['String']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  lineItemKey?: Maybe<Scalars['String']['output']>;
  modifyDate?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  options?: Maybe<Array<Maybe<ShipStationOrderItemOption>>>;
  orderItemId?: Maybe<Scalars['Float']['output']>;
  productId?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  shippingAmount?: Maybe<Scalars['Float']['output']>;
  sku?: Maybe<Scalars['String']['output']>;
  taxAmount?: Maybe<Scalars['Float']['output']>;
  unitPrice?: Maybe<Scalars['Float']['output']>;
  upc?: Maybe<Scalars['String']['output']>;
  warehouseLocation?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<ShipStationWeight>;
};

export type ShipStationOrderItemOption = {
  __typename?: 'ShipStationOrderItemOption';
  name?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type ShipStationOrderPage = {
  __typename?: 'ShipStationOrderPage';
  data?: Maybe<Array<Maybe<ShipStationOrder>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export enum ShipStationOrderStatus {
  AwaitingPayment = 'awaiting_payment',
  AwaitingShipment = 'awaiting_shipment',
  Cancelled = 'cancelled',
  OnHold = 'on_hold',
  Shipped = 'shipped'
}

export type ShipStationProduct = {
  __typename?: 'ShipStationProduct';
  active?: Maybe<Scalars['Boolean']['output']>;
  createDate?: Maybe<Scalars['String']['output']>;
  customsCountryCode?: Maybe<Scalars['String']['output']>;
  customsDescription?: Maybe<Scalars['String']['output']>;
  customsTariffNo?: Maybe<Scalars['String']['output']>;
  customsValue?: Maybe<Scalars['Float']['output']>;
  defaultCarrierCode?: Maybe<Scalars['String']['output']>;
  defaultConfirmation?: Maybe<Scalars['String']['output']>;
  defaultCost?: Maybe<Scalars['Float']['output']>;
  defaultIntlCarrierCode?: Maybe<Scalars['String']['output']>;
  defaultIntlConfirmation?: Maybe<Scalars['String']['output']>;
  defaultIntlPackageCode?: Maybe<Scalars['String']['output']>;
  defaultIntlServiceCode?: Maybe<Scalars['String']['output']>;
  defaultPackageCode?: Maybe<Scalars['String']['output']>;
  defaultServiceCode?: Maybe<Scalars['String']['output']>;
  fulfillmentSku?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  internalNotes?: Maybe<Scalars['String']['output']>;
  length?: Maybe<Scalars['Float']['output']>;
  modifyDate?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  noCustoms?: Maybe<Scalars['Boolean']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  productCategory?: Maybe<ShipStationProductCategory>;
  productId?: Maybe<Scalars['Float']['output']>;
  productType?: Maybe<Scalars['String']['output']>;
  sku?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<ShipStationProductTag>;
  warehouseLocation?: Maybe<Scalars['String']['output']>;
  weightOz?: Maybe<Scalars['Float']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
};

export type ShipStationProductCategory = {
  __typename?: 'ShipStationProductCategory';
  categoryId?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type ShipStationProductFilter = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  productCategoryId?: InputMaybe<Scalars['String']['input']>;
  productTypeId?: InputMaybe<Scalars['String']['input']>;
  showInactive?: InputMaybe<Scalars['String']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  tagId?: InputMaybe<Scalars['String']['input']>;
};

export type ShipStationProductPage = {
  __typename?: 'ShipStationProductPage';
  data?: Maybe<Array<Maybe<ShipStationProduct>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type ShipStationProductTag = {
  __typename?: 'ShipStationProductTag';
  name?: Maybe<Scalars['String']['output']>;
  tagId?: Maybe<Scalars['Int']['output']>;
};

export type ShipStationRate = {
  __typename?: 'ShipStationRate';
  otherCost?: Maybe<Scalars['Float']['output']>;
  serviceCode?: Maybe<Scalars['String']['output']>;
  serviceName?: Maybe<Scalars['String']['output']>;
  shipmentCost?: Maybe<Scalars['Float']['output']>;
};

export type ShipStationShipment = {
  __typename?: 'ShipStationShipment';
  advancedOptions?: Maybe<ShipStationAdvancedOptions>;
  batchNumber?: Maybe<Scalars['String']['output']>;
  carrierCode?: Maybe<Scalars['String']['output']>;
  confirmation?: Maybe<ShipStationConfirmation>;
  createDate?: Maybe<Scalars['String']['output']>;
  customerEmail?: Maybe<Scalars['String']['output']>;
  dimensions?: Maybe<ShipStationDimensions>;
  formData?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  insuranceCost?: Maybe<Scalars['Float']['output']>;
  insuranceOptions?: Maybe<ShipStationInsuranceOptions>;
  isReturnLabel?: Maybe<Scalars['Boolean']['output']>;
  labelData?: Maybe<Scalars['String']['output']>;
  marketplaceNotified?: Maybe<Scalars['Boolean']['output']>;
  notifyErrorMessage?: Maybe<Scalars['String']['output']>;
  orderId?: Maybe<Scalars['Float']['output']>;
  orderKey?: Maybe<Scalars['String']['output']>;
  orderNumber?: Maybe<Scalars['String']['output']>;
  packageCode?: Maybe<Scalars['String']['output']>;
  serviceCode?: Maybe<Scalars['String']['output']>;
  shipDate?: Maybe<Scalars['String']['output']>;
  shipTo?: Maybe<ShipStationAddress>;
  shipmentCost?: Maybe<Scalars['Float']['output']>;
  shipmentId?: Maybe<Scalars['Float']['output']>;
  shipmentItems?: Maybe<Array<Maybe<ShipStationOrderItem>>>;
  trackingNumber?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
  voidDate?: Maybe<Scalars['String']['output']>;
  voided?: Maybe<Scalars['Boolean']['output']>;
  warehouseId?: Maybe<Scalars['Int']['output']>;
  weight?: Maybe<ShipStationWeight>;
};

export type ShipStationShipmentPage = {
  __typename?: 'ShipStationShipmentPage';
  data?: Maybe<Array<Maybe<ShipStationShipment>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type ShipStationShipmentsFilter = {
  carrierCode?: InputMaybe<Scalars['String']['input']>;
  createDateEnd?: InputMaybe<Scalars['String']['input']>;
  createDateStart?: InputMaybe<Scalars['String']['input']>;
  includeShipmentItems?: InputMaybe<Scalars['Boolean']['input']>;
  orderId?: InputMaybe<Scalars['Float']['input']>;
  orderNumber?: InputMaybe<Scalars['String']['input']>;
  recipientCountryCode?: InputMaybe<Scalars['String']['input']>;
  recipientName?: InputMaybe<Scalars['String']['input']>;
  serviceCode?: InputMaybe<Scalars['String']['input']>;
  shipDateEnd?: InputMaybe<Scalars['String']['input']>;
  shipDateStart?: InputMaybe<Scalars['String']['input']>;
  storeId?: InputMaybe<Scalars['Int']['input']>;
  trackingNumber?: InputMaybe<Scalars['String']['input']>;
  voidDateEnd?: InputMaybe<Scalars['String']['input']>;
  voidDateStart?: InputMaybe<Scalars['String']['input']>;
};

export type ShipStationStore = {
  __typename?: 'ShipStationStore';
  accountName?: Maybe<Scalars['String']['output']>;
  active?: Maybe<Scalars['Boolean']['output']>;
  autoRefresh?: Maybe<Scalars['Boolean']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  createDate?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  integrationUrl?: Maybe<Scalars['String']['output']>;
  lastRefreshAttempt?: Maybe<Scalars['String']['output']>;
  marketplaceId?: Maybe<Scalars['Int']['output']>;
  marketplaceName?: Maybe<Scalars['String']['output']>;
  modifyDate?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  publicEmail?: Maybe<Scalars['String']['output']>;
  refreshDate?: Maybe<Scalars['String']['output']>;
  storeId?: Maybe<Scalars['Int']['output']>;
  storeName?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

export type ShipStationStorePage = {
  __typename?: 'ShipStationStorePage';
  data?: Maybe<Array<Maybe<ShipStationStore>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type ShipStationStoresFilter = {
  marketplaceId?: InputMaybe<Scalars['Int']['input']>;
  showInactive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ShipStationTag = {
  __typename?: 'ShipStationTag';
  color?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  tagId?: Maybe<Scalars['Int']['output']>;
};

export type ShipStationTagPage = {
  __typename?: 'ShipStationTagPage';
  data?: Maybe<Array<Maybe<ShipStationTag>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type ShipStationWarehouse = {
  __typename?: 'ShipStationWarehouse';
  createDate?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  originAddress?: Maybe<ShipStationAddress>;
  returnAddress?: Maybe<ShipStationAddress>;
  warehouseId?: Maybe<Scalars['Int']['output']>;
  warehouseName?: Maybe<Scalars['String']['output']>;
};

export type ShipStationWarehousePage = {
  __typename?: 'ShipStationWarehousePage';
  data?: Maybe<Array<Maybe<ShipStationWarehouse>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type ShipStationWeight = {
  __typename?: 'ShipStationWeight';
  WeightUnits?: Maybe<Scalars['Float']['output']>;
  units?: Maybe<ShipStationWeightUnit>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type ShipStationWeightInput = {
  WeightUnits?: InputMaybe<Scalars['Int']['input']>;
  units?: InputMaybe<ShipStationWeightUnit>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export enum ShipStationWeightUnit {
  Grams = 'grams',
  Ounces = 'ounces',
  Pounds = 'pounds'
}

export type Sort = {
  field?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
};

export type StringFilter = {
  ALL?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  EQ?: InputMaybe<Scalars['String']['input']>;
  GT?: InputMaybe<Scalars['String']['input']>;
  GTE?: InputMaybe<Scalars['String']['input']>;
  IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  LT?: InputMaybe<Scalars['String']['input']>;
  LTE?: InputMaybe<Scalars['String']['input']>;
  NE?: InputMaybe<Scalars['String']['input']>;
  NIN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type SubscriptionInput = {
  autopay?: InputMaybe<Scalars['Boolean']['input']>;
  customFields?: InputMaybe<TransactionCustomFields>;
  customerId: Scalars['String']['input'];
  items: Array<ItemInput>;
  orderType: Scalars['String']['input'];
};

export type SubscriptionItem = {
  __typename?: 'SubscriptionItem';
  billingTiming?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  plan?: Maybe<SubscriptionPlan>;
  planId?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
};

export type SubscriptionPlan = {
  __typename?: 'SubscriptionPlan';
  productId?: Maybe<Scalars['String']['output']>;
};

export type TotalRedemptions = {
  quantity: Scalars['Int']['input'];
};

export type Transaction = {
  __typename?: 'Transaction';
  acquirerName?: Maybe<Scalars['String']['output']>;
  amount?: Maybe<Scalars['String']['output']>;
  billingAddress?: Maybe<Address>;
  billingContactId?: Maybe<Scalars['String']['output']>;
  billingDescriptor?: Maybe<Scalars['JSON']['output']>;
  bin?: Maybe<Scalars['String']['output']>;
  bumpOffer?: Maybe<Scalars['JSON']['output']>;
  childTransactions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  createdTime?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  customFields?: Maybe<Scalars['JSON']['output']>;
  customer?: Maybe<Scalars['String']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  dcc?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  gateway?: Maybe<Scalars['JSON']['output']>;
  gatewayAccountId?: Maybe<Scalars['String']['output']>;
  gatewayName?: Maybe<Scalars['String']['output']>;
  gatewayResponse?: Maybe<Scalars['JSON']['output']>;
  gatewayTransactionId?: Maybe<Scalars['String']['output']>;
  hadDiscrepancy?: Maybe<Scalars['Boolean']['output']>;
  has3ds?: Maybe<Scalars['Boolean']['output']>;
  hasBumpOffer?: Maybe<Scalars['Boolean']['output']>;
  hasDcc?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  invoiceIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  isDisputed?: Maybe<Scalars['Boolean']['output']>;
  isRebill?: Maybe<Scalars['Boolean']['output']>;
  isReconciled?: Maybe<Scalars['Boolean']['output']>;
  isRetry?: Maybe<Scalars['Boolean']['output']>;
  method?: Maybe<Scalars['String']['output']>;
  notificationUrl?: Maybe<Scalars['String']['output']>;
  orderId?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['String']['output']>;
  parentTransactionId?: Maybe<Scalars['String']['output']>;
  paymentCard?: Maybe<Scalars['String']['output']>;
  paymentCardId?: Maybe<Scalars['String']['output']>;
  paymentInstrument?: Maybe<PaymentInstrumentId>;
  paymentInstrumentFingerprint?: Maybe<Scalars['String']['output']>;
  planIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  processedTime?: Maybe<Scalars['String']['output']>;
  rebillNumber?: Maybe<Scalars['Int']['output']>;
  redirectUrl?: Maybe<Scalars['String']['output']>;
  redirectUrls?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  referenceData?: Maybe<Scalars['JSON']['output']>;
  requestId?: Maybe<Scalars['String']['output']>;
  result?: Maybe<Scalars['String']['output']>;
  retriedTransactionId?: Maybe<Scalars['String']['output']>;
  retriesResult?: Maybe<Scalars['String']['output']>;
  retryInstruction?: Maybe<Scalars['String']['output']>;
  retryNumber?: Maybe<Scalars['Int']['output']>;
  revision?: Maybe<Scalars['Int']['output']>;
  riskMetadata?: Maybe<RiskMetadata>;
  riskScore?: Maybe<Scalars['String']['output']>;
  scheduledTime?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  subscriptionIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  type?: Maybe<Scalars['String']['output']>;
  updatedTime?: Maybe<Scalars['String']['output']>;
  velocity?: Maybe<Scalars['Int']['output']>;
  website?: Maybe<Scalars['String']['output']>;
  websiteId?: Maybe<Scalars['String']['output']>;
};

export type TransactionCustomFields = {
  API?: InputMaybe<Scalars['String']['input']>;
  advertiser_id?: InputMaybe<Scalars['String']['input']>;
  aff_click_id?: InputMaybe<Scalars['String']['input']>;
  aff_id?: InputMaybe<Scalars['String']['input']>;
  aff_sub?: InputMaybe<Scalars['String']['input']>;
  aff_sub2?: InputMaybe<Scalars['String']['input']>;
  aff_sub3?: InputMaybe<Scalars['String']['input']>;
  aff_sub4?: InputMaybe<Scalars['String']['input']>;
  aff_sub5?: InputMaybe<Scalars['String']['input']>;
  affiliate_id?: InputMaybe<Scalars['String']['input']>;
  camp_id?: InputMaybe<Scalars['String']['input']>;
  coin_uid?: InputMaybe<Scalars['String']['input']>;
  context?: InputMaybe<Scalars['String']['input']>;
  contract_id?: InputMaybe<Scalars['String']['input']>;
  country_name?: InputMaybe<Scalars['String']['input']>;
  ddcref?: InputMaybe<Scalars['String']['input']>;
  device?: InputMaybe<Scalars['String']['input']>;
  device_type?: InputMaybe<Scalars['String']['input']>;
  emailHash?: InputMaybe<Scalars['String']['input']>;
  fbc?: InputMaybe<Scalars['String']['input']>;
  fbp?: InputMaybe<Scalars['String']['input']>;
  gclid?: InputMaybe<Scalars['String']['input']>;
  gclsrc?: InputMaybe<Scalars['String']['input']>;
  lpid?: InputMaybe<Scalars['String']['input']>;
  offer_id?: InputMaybe<Scalars['String']['input']>;
  oid?: InputMaybe<Scalars['String']['input']>;
  req_id?: InputMaybe<Scalars['String']['input']>;
  shipStationStoreId?: InputMaybe<Scalars['String']['input']>;
  sub_id?: InputMaybe<Scalars['String']['input']>;
  sweepstakeSku?: InputMaybe<Scalars['String']['input']>;
  testData?: InputMaybe<Scalars['String']['input']>;
  tune_transaction_id?: InputMaybe<Scalars['String']['input']>;
  user_agent?: InputMaybe<Scalars['String']['input']>;
  user_ip?: InputMaybe<Scalars['String']['input']>;
  utm_adid?: InputMaybe<Scalars['String']['input']>;
  utm_adsetid?: InputMaybe<Scalars['String']['input']>;
  utm_campaign?: InputMaybe<Scalars['String']['input']>;
  utm_campaignid?: InputMaybe<Scalars['String']['input']>;
  utm_content?: InputMaybe<Scalars['String']['input']>;
  utm_medium?: InputMaybe<Scalars['String']['input']>;
  utm_source?: InputMaybe<Scalars['String']['input']>;
  utm_term?: InputMaybe<Scalars['String']['input']>;
};

export type TransactionCustomFieldsResult = {
  __typename?: 'TransactionCustomFieldsResult';
  API?: Maybe<Scalars['String']['output']>;
  advertiser_id?: Maybe<Scalars['String']['output']>;
  aff_click_id?: Maybe<Scalars['String']['output']>;
  aff_id?: Maybe<Scalars['String']['output']>;
  aff_sub?: Maybe<Scalars['String']['output']>;
  aff_sub2?: Maybe<Scalars['String']['output']>;
  aff_sub3?: Maybe<Scalars['String']['output']>;
  aff_sub4?: Maybe<Scalars['String']['output']>;
  aff_sub5?: Maybe<Scalars['String']['output']>;
  affiliate_id?: Maybe<Scalars['String']['output']>;
  camp_id?: Maybe<Scalars['String']['output']>;
  coin_uid?: Maybe<Scalars['String']['output']>;
  context?: Maybe<Scalars['String']['output']>;
  contract_id?: Maybe<Scalars['String']['output']>;
  country_name?: Maybe<Scalars['String']['output']>;
  ddcref?: Maybe<Scalars['String']['output']>;
  device?: Maybe<Scalars['String']['output']>;
  device_type?: Maybe<Scalars['String']['output']>;
  emailHash?: Maybe<Scalars['String']['output']>;
  fbc?: Maybe<Scalars['String']['output']>;
  fbp?: Maybe<Scalars['String']['output']>;
  gclid?: Maybe<Scalars['String']['output']>;
  gclsrc?: Maybe<Scalars['String']['output']>;
  lpid?: Maybe<Scalars['String']['output']>;
  offer_id?: Maybe<Scalars['String']['output']>;
  oid?: Maybe<Scalars['String']['output']>;
  req_id?: Maybe<Scalars['String']['output']>;
  shipStationStoreId?: Maybe<Scalars['String']['output']>;
  sub_id?: Maybe<Scalars['String']['output']>;
  sweepstakeSku?: Maybe<Scalars['String']['output']>;
  testData?: Maybe<Scalars['String']['output']>;
  tune_transaction_id?: Maybe<Scalars['String']['output']>;
  user_agent?: Maybe<Scalars['String']['output']>;
  user_ip?: Maybe<Scalars['String']['output']>;
  utm_adid?: Maybe<Scalars['String']['output']>;
  utm_adsetid?: Maybe<Scalars['String']['output']>;
  utm_campaign?: Maybe<Scalars['String']['output']>;
  utm_campaignid?: Maybe<Scalars['String']['output']>;
  utm_content?: Maybe<Scalars['String']['output']>;
  utm_medium?: Maybe<Scalars['String']['output']>;
  utm_source?: Maybe<Scalars['String']['output']>;
  utm_term?: Maybe<Scalars['String']['output']>;
};

export type Trial = {
  __typename?: 'Trial';
  period?: Maybe<TrialPeriod>;
  price?: Maybe<Scalars['Float']['output']>;
};

export type TrialPeriod = {
  __typename?: 'TrialPeriod';
  length?: Maybe<Scalars['Int']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
};

export type UserInfo = {
  __typename?: 'UserInfo';
  achievementsCollected?: Maybe<Array<Maybe<AchievementCollected>>>;
  activeSubscription?: Maybe<Scalars['String']['output']>;
  activeSubscriptionLock?: Maybe<Scalars['Boolean']['output']>;
  addedToDrip?: Maybe<Scalars['Int']['output']>;
  advertisingId?: Maybe<Scalars['String']['output']>;
  appVersion?: Maybe<Scalars['String']['output']>;
  appsflyerId?: Maybe<Scalars['String']['output']>;
  checkInDate?: Maybe<Scalars['FirebaseTimestamp']['output']>;
  coinbaseEmail?: Maybe<Scalars['String']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['FirebaseTimestamp']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  deviceId?: Maybe<Scalars['String']['output']>;
  deviceIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  deviceName?: Maybe<Scalars['String']['output']>;
  didReceiveReturningUserGift?: Maybe<Scalars['Boolean']['output']>;
  didReceiveZendrizeDrop?: Maybe<Scalars['Boolean']['output']>;
  direction?: Maybe<Scalars['String']['output']>;
  driveAnalysisActiveSubscription?: Maybe<Scalars['String']['output']>;
  driveAnalysisCompleted?: Maybe<Scalars['Boolean']['output']>;
  driveAnalysisCompletedDate?: Maybe<Scalars['String']['output']>;
  driveAnalysisQualified?: Maybe<Scalars['Boolean']['output']>;
  driveAnalysisQualifiedDate?: Maybe<Scalars['String']['output']>;
  driveAnalysisRegistered?: Maybe<Scalars['Boolean']['output']>;
  driveAnalysisRegisteredDate?: Maybe<Scalars['String']['output']>;
  driveAnalysisReward?: Maybe<Scalars['Float']['output']>;
  driveAnalysisRewarded?: Maybe<Scalars['Boolean']['output']>;
  ethAddress?: Maybe<Scalars['String']['output']>;
  firstMaphash?: Maybe<Scalars['String']['output']>;
  hodlLastCollectedYYYYMMDD?: Maybe<Scalars['String']['output']>;
  ibeacons?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ip?: Maybe<Scalars['String']['output']>;
  kycComplete?: Maybe<Scalars['Boolean']['output']>;
  lastKnownAddress?: Maybe<Scalars['String']['output']>;
  lastMaphash?: Maybe<Scalars['String']['output']>;
  lastMined?: Maybe<Scalars['FirebaseTimestamp']['output']>;
  lastMinedWithSentinelBle?: Maybe<Scalars['FirebaseTimestamp']['output']>;
  lastMinedYYYYMMDD?: Maybe<Scalars['Int']['output']>;
  lastSync?: Maybe<Scalars['String']['output']>;
  liteOk?: Maybe<Scalars['Boolean']['output']>;
  masterOk?: Maybe<Scalars['Boolean']['output']>;
  mineCount?: Maybe<Scalars['Int']['output']>;
  mineCountNoSentinel?: Maybe<Scalars['Int']['output']>;
  mineCountSentinel?: Maybe<Scalars['Int']['output']>;
  nfcScanCount?: Maybe<Scalars['Float']['output']>;
  nftAddress?: Maybe<Scalars['String']['output']>;
  os?: Maybe<Scalars['String']['output']>;
  osDevMode?: Maybe<Scalars['Boolean']['output']>;
  osVersion?: Maybe<Scalars['String']['output']>;
  ownerUID?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  profileImage?: Maybe<Scalars['String']['output']>;
  profileImageExists?: Maybe<Scalars['Boolean']['output']>;
  profileImageUpdated?: Maybe<Scalars['String']['output']>;
  profileMultiplier?: Maybe<Scalars['Float']['output']>;
  random?: Maybe<Scalars['Int']['output']>;
  rebillyRevenue?: Maybe<Scalars['Float']['output']>;
  rebillyRevenueToReport?: Maybe<Scalars['Float']['output']>;
  recentCount?: Maybe<Scalars['Int']['output']>;
  recentMarker?: Maybe<Scalars['String']['output']>;
  recordVersion?: Maybe<Scalars['Float']['output']>;
  referrer?: Maybe<Scalars['String']['output']>;
  referrerUid?: Maybe<Scalars['String']['output']>;
  remineCount?: Maybe<Scalars['Int']['output']>;
  remineMarker?: Maybe<Scalars['String']['output']>;
  ringDate?: Maybe<Scalars['FirebaseTimestamp']['output']>;
  sentinels?: Maybe<Scalars['Int']['output']>;
  shipStreetAddress?: Maybe<Scalars['String']['output']>;
  speed?: Maybe<Scalars['Float']['output']>;
  ssid?: Maybe<Scalars['String']['output']>;
  subActive?: Maybe<Scalars['Boolean']['output']>;
  subOrder?: Maybe<Scalars['String']['output']>;
  subscriptionInfo?: Maybe<Scalars['JSON']['output']>;
  suspended?: Maybe<Scalars['String']['output']>;
  userDeleted?: Maybe<Scalars['Boolean']['output']>;
  userDeletedSource?: Maybe<Scalars['String']['output']>;
  userDeletedTime?: Maybe<Scalars['String']['output']>;
  userDeletedYYYYMMDD?: Maybe<Scalars['Int']['output']>;
  userQualityScore?: Maybe<Scalars['Int']['output']>;
  userQualityScoreUpdatedBy?: Maybe<Scalars['String']['output']>;
  userQualityScoreUpdatedDate?: Maybe<Scalars['Date']['output']>;
  username?: Maybe<Scalars['String']['output']>;
  verifiedAddressesTotal?: Maybe<Scalars['Float']['output']>;
  webDropsAllowed?: Maybe<Scalars['Boolean']['output']>;
  webDropsAmountMax?: Maybe<Scalars['Float']['output']>;
  webDropsQuantityMax?: Maybe<Scalars['Int']['output']>;
  xyoBossBalance?: Maybe<Scalars['Float']['output']>;
  xyoBossGifted?: Maybe<Scalars['Float']['output']>;
  xyoCollected?: Maybe<Scalars['Float']['output']>;
  xyoDropped?: Maybe<Scalars['Float']['output']>;
  xyoEnabled?: Maybe<Scalars['Boolean']['output']>;
  xyoExpired?: Maybe<Scalars['Float']['output']>;
  xyoGeoclaimed?: Maybe<Scalars['Float']['output']>;
  xyoGeomined?: Maybe<Scalars['Float']['output']>;
  xyoGifted?: Maybe<Scalars['Float']['output']>;
  xyoHodlRewards?: Maybe<Scalars['Float']['output']>;
  xyoInbrainRevoked?: Maybe<Scalars['Float']['output']>;
  xyoPending?: Maybe<Scalars['Float']['output']>;
  xyoPickedUp?: Maybe<Scalars['Float']['output']>;
  xyoRedeemPending?: Maybe<Scalars['Float']['output']>;
  xyoRedeemed?: Maybe<Scalars['Float']['output']>;
  xyoRestored?: Maybe<Scalars['Float']['output']>;
  xyoSurveys?: Maybe<Scalars['Float']['output']>;
  xyoSweepstakes?: Maybe<Scalars['Float']['output']>;
};

export type UserInfoFilter = {
  deviceId?: InputMaybe<StringFilter>;
  deviceIds?: InputMaybe<StringFilter>;
  didReceiveZendrizeDrop?: InputMaybe<BooleanFilter>;
  driveAnalysisCompleted?: InputMaybe<BooleanFilter>;
  driveAnalysisQualified?: InputMaybe<BooleanFilter>;
  driveAnalysisRegistered?: InputMaybe<BooleanFilter>;
  driveAnalysisRewarded?: InputMaybe<BooleanFilter>;
  ownerUID?: InputMaybe<StringFilter>;
  referrerUid?: InputMaybe<StringFilter>;
  suspended?: InputMaybe<StringFilter>;
};

export type UserInfoPage = {
  __typename?: 'UserInfoPage';
  data?: Maybe<Array<Maybe<UserInfo>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type ShipStationAddressFragment = { __typename?: 'ShipStationAddress', name?: string | null, company?: string | null, street1?: string | null, street2?: string | null, street3?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, country?: string | null, phone?: string | null, residential?: boolean | null, addressVerified?: string | null };

export type ShipStationOrderItemFragment = { __typename?: 'ShipStationOrderItem', orderItemId?: number | null, lineItemKey?: string | null, sku?: string | null, name?: string | null, imageUrl?: string | null, quantity?: number | null, unitPrice?: number | null, taxAmount?: number | null, shippingAmount?: number | null, warehouseLocation?: string | null, productId?: number | null, fulfillmentSku?: string | null, adjustment?: boolean | null, upc?: string | null, createDate?: string | null, modifyDate?: string | null, weight?: { __typename?: 'ShipStationWeight', value?: number | null, units?: ShipStationWeightUnit | null } | null, options?: Array<{ __typename?: 'ShipStationOrderItemOption', name?: string | null, value?: string | null } | null> | null };

export type ShipStationInsuranceOptionsFragment = { __typename?: 'ShipStationInsuranceOptions', provider?: string | null, insureShipment?: boolean | null, insuredValue?: number | null };

export type ShipStationInternationalOptionsFragment = { __typename?: 'ShipStationInternationalOptions', contents?: ShipStationInternationalContents | null, nonDelivery?: ShipStationInternationalNonDelivery | null, customsItems?: Array<{ __typename?: 'ShipStationCustomsItem', customsItemId?: string | null, description?: string | null, quantity?: number | null, value?: number | null, harmonizedTariffCode?: string | null, countryOfOrigin?: string | null } | null> | null };

export type ShipStationAdvancedOptionsFragment = { __typename?: 'ShipStationAdvancedOptions', warehouseId?: number | null, nonMachinable?: boolean | null, saturdayDelivery?: boolean | null, containsAlcohol?: boolean | null, storeId?: number | null, customField1?: string | null, customField2?: string | null, customField3?: string | null, source?: string | null, mergedOrSplit?: boolean | null, mergedIds?: Array<number | null> | null, parentId?: number | null, billToParty?: string | null, billToAccount?: string | null, billToPostalCode?: string | null, billToCountryCode?: string | null, billToMyOtherAccount?: string | null };

export type ShipStationOrderFragment = { __typename?: 'ShipStationOrder', id?: number | null, orderId?: number | null, orderNumber?: string | null, orderKey?: string | null, orderDate?: string | null, createDate?: string | null, modifyDate?: string | null, paymentDate?: string | null, shipByDate?: string | null, orderStatus?: ShipStationOrderStatus | null, customerId?: number | null, customerUsername?: string | null, customerEmail?: string | null, orderTotal?: number | null, amountPaid?: number | null, taxAmount?: number | null, shippingAmount?: number | null, customerNotes?: string | null, internalNotes?: string | null, gift?: boolean | null, giftMessage?: string | null, paymentMethod?: string | null, requestedShippingService?: string | null, carrierCode?: string | null, serviceCode?: string | null, packageCode?: string | null, confirmation?: ShipStationConfirmation | null, shipDate?: string | null, holdUntilDate?: string | null, tagIds?: Array<number | null> | null, userId?: string | null, externallyFulfilled?: boolean | null, externallyFulfilledBy?: string | null, billTo?: { __typename?: 'ShipStationAddress', name?: string | null, company?: string | null, street1?: string | null, street2?: string | null, street3?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, country?: string | null, phone?: string | null, residential?: boolean | null, addressVerified?: string | null } | null, shipTo?: { __typename?: 'ShipStationAddress', name?: string | null, company?: string | null, street1?: string | null, street2?: string | null, street3?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, country?: string | null, phone?: string | null, residential?: boolean | null, addressVerified?: string | null } | null, items?: Array<{ __typename?: 'ShipStationOrderItem', orderItemId?: number | null, lineItemKey?: string | null, sku?: string | null, name?: string | null, imageUrl?: string | null, quantity?: number | null, unitPrice?: number | null, taxAmount?: number | null, shippingAmount?: number | null, warehouseLocation?: string | null, productId?: number | null, fulfillmentSku?: string | null, adjustment?: boolean | null, upc?: string | null, createDate?: string | null, modifyDate?: string | null, weight?: { __typename?: 'ShipStationWeight', value?: number | null, units?: ShipStationWeightUnit | null } | null, options?: Array<{ __typename?: 'ShipStationOrderItemOption', name?: string | null, value?: string | null } | null> | null } | null> | null, weight?: { __typename?: 'ShipStationWeight', value?: number | null, units?: ShipStationWeightUnit | null } | null, dimensions?: { __typename?: 'ShipStationDimensions', length?: number | null, width?: number | null, height?: number | null, units?: ShipStationDimensionUnit | null } | null, insuranceOptions?: { __typename?: 'ShipStationInsuranceOptions', provider?: string | null, insureShipment?: boolean | null, insuredValue?: number | null } | null, internationalOptions?: { __typename?: 'ShipStationInternationalOptions', contents?: ShipStationInternationalContents | null, nonDelivery?: ShipStationInternationalNonDelivery | null, customsItems?: Array<{ __typename?: 'ShipStationCustomsItem', customsItemId?: string | null, description?: string | null, quantity?: number | null, value?: number | null, harmonizedTariffCode?: string | null, countryOfOrigin?: string | null } | null> | null } | null, advancedOptions?: { __typename?: 'ShipStationAdvancedOptions', warehouseId?: number | null, nonMachinable?: boolean | null, saturdayDelivery?: boolean | null, containsAlcohol?: boolean | null, storeId?: number | null, customField1?: string | null, customField2?: string | null, customField3?: string | null, source?: string | null, mergedOrSplit?: boolean | null, mergedIds?: Array<number | null> | null, parentId?: number | null, billToParty?: string | null, billToAccount?: string | null, billToPostalCode?: string | null, billToCountryCode?: string | null, billToMyOtherAccount?: string | null } | null };

export type ShipStationShipmentFragment = { __typename?: 'ShipStationShipment', id?: number | null, shipmentId?: number | null, orderId?: number | null, orderKey?: string | null, userId?: string | null, orderNumber?: string | null, createDate?: string | null, shipDate?: string | null, shipmentCost?: number | null, insuranceCost?: number | null, trackingNumber?: string | null, isReturnLabel?: boolean | null, customerEmail?: string | null, batchNumber?: string | null, carrierCode?: string | null, serviceCode?: string | null, packageCode?: string | null, confirmation?: ShipStationConfirmation | null, warehouseId?: number | null, voided?: boolean | null, voidDate?: string | null, marketplaceNotified?: boolean | null, notifyErrorMessage?: string | null, labelData?: string | null, formData?: string | null, shipTo?: { __typename?: 'ShipStationAddress', name?: string | null, company?: string | null, street1?: string | null, street2?: string | null, street3?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, country?: string | null, phone?: string | null, residential?: boolean | null, addressVerified?: string | null } | null, weight?: { __typename?: 'ShipStationWeight', value?: number | null, units?: ShipStationWeightUnit | null } | null, dimensions?: { __typename?: 'ShipStationDimensions', length?: number | null, width?: number | null, height?: number | null, units?: ShipStationDimensionUnit | null } | null, insuranceOptions?: { __typename?: 'ShipStationInsuranceOptions', provider?: string | null, insureShipment?: boolean | null, insuredValue?: number | null } | null, advancedOptions?: { __typename?: 'ShipStationAdvancedOptions', warehouseId?: number | null, nonMachinable?: boolean | null, saturdayDelivery?: boolean | null, containsAlcohol?: boolean | null, storeId?: number | null, customField1?: string | null, customField2?: string | null, customField3?: string | null, source?: string | null, mergedOrSplit?: boolean | null, mergedIds?: Array<number | null> | null, parentId?: number | null, billToParty?: string | null, billToAccount?: string | null, billToPostalCode?: string | null, billToCountryCode?: string | null, billToMyOtherAccount?: string | null } | null, shipmentItems?: Array<{ __typename?: 'ShipStationOrderItem', orderItemId?: number | null, lineItemKey?: string | null, sku?: string | null, name?: string | null, imageUrl?: string | null, quantity?: number | null, unitPrice?: number | null, taxAmount?: number | null, shippingAmount?: number | null, warehouseLocation?: string | null, productId?: number | null, fulfillmentSku?: string | null, adjustment?: boolean | null, upc?: string | null, createDate?: string | null, modifyDate?: string | null, weight?: { __typename?: 'ShipStationWeight', value?: number | null, units?: ShipStationWeightUnit | null } | null, options?: Array<{ __typename?: 'ShipStationOrderItemOption', name?: string | null, value?: string | null } | null> | null } | null> | null };

export type ShipStationProductFragment = { __typename?: 'ShipStationProduct', id?: number | null, productId?: number | null, sku?: string | null, name?: string | null, price?: number | null, defaultCost?: number | null, length?: number | null, width?: number | null, height?: number | null, weightOz?: number | null, internalNotes?: string | null, fulfillmentSku?: string | null, createDate?: string | null, modifyDate?: string | null, active?: boolean | null, productType?: string | null, warehouseLocation?: string | null, defaultCarrierCode?: string | null, defaultServiceCode?: string | null, defaultPackageCode?: string | null, defaultIntlCarrierCode?: string | null, defaultIntlServiceCode?: string | null, defaultIntlPackageCode?: string | null, defaultConfirmation?: string | null, defaultIntlConfirmation?: string | null, customsDescription?: string | null, customsValue?: number | null, customsTariffNo?: string | null, customsCountryCode?: string | null, noCustoms?: boolean | null, productCategory?: { __typename?: 'ShipStationProductCategory', categoryId?: number | null, name?: string | null } | null, tags?: { __typename?: 'ShipStationProductTag', tagId?: number | null, name?: string | null } | null };

export type ShipStationFulfillmentFragment = { __typename?: 'ShipStationFulfillment', id?: number | null, fulfillmentId?: number | null, orderId?: number | null, orderNumber?: string | null, userId?: string | null, customerEmail?: string | null, trackingNumber?: string | null, createDate?: string | null, shipDate?: string | null, voidDate?: string | null, deliveryDate?: string | null, carrierCode?: string | null, fulfillmentProviderCode?: string | null, fulfillmentServiceCode?: string | null, fulfillmentFee?: number | null, voidRequested?: boolean | null, voided?: boolean | null, marketplaceNotified?: boolean | null, notifyErrorMessage?: string | null, shipTo?: { __typename?: 'ShipStationAddress', name?: string | null, company?: string | null, street1?: string | null, street2?: string | null, street3?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, country?: string | null, phone?: string | null, residential?: boolean | null, addressVerified?: string | null } | null };

export type ShipStationCarrierFragment = { __typename?: 'ShipStationCarrier', id?: string | null, name?: string | null, code?: string | null, accountNumber?: string | null, requiresFundedAccount?: boolean | null, balance?: number | null, nickname?: string | null, shippingProviderId?: number | null, primary?: boolean | null };

export type ShipStationCarrierPackageFragment = { __typename?: 'ShipStationCarrierPackage', carrierCode?: string | null, code?: string | null, name?: string | null, domestic?: boolean | null, international?: boolean | null };

export type ShipStationCarrierServiceFragment = { __typename?: 'ShipStationCarrierService', carrierCode?: string | null, code?: string | null, name?: string | null, domestic?: boolean | null, international?: boolean | null };

export type ShipStationStoreFragment = { __typename?: 'ShipStationStore', id?: number | null, storeId?: number | null, storeName?: string | null, marketplaceId?: number | null, marketplaceName?: string | null, accountName?: string | null, email?: string | null, integrationUrl?: string | null, active?: boolean | null, companyName?: string | null, phone?: string | null, publicEmail?: string | null, website?: string | null, refreshDate?: string | null, lastRefreshAttempt?: string | null, createDate?: string | null, modifyDate?: string | null, autoRefresh?: boolean | null };

export type ShipStationWarehouseFragment = { __typename?: 'ShipStationWarehouse', id?: number | null, warehouseId?: number | null, warehouseName?: string | null, createDate?: string | null, isDefault?: boolean | null, originAddress?: { __typename?: 'ShipStationAddress', name?: string | null, company?: string | null, street1?: string | null, street2?: string | null, street3?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, country?: string | null, phone?: string | null, residential?: boolean | null, addressVerified?: string | null } | null, returnAddress?: { __typename?: 'ShipStationAddress', name?: string | null, company?: string | null, street1?: string | null, street2?: string | null, street3?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, country?: string | null, phone?: string | null, residential?: boolean | null, addressVerified?: string | null } | null };

export type SendCloudParcelFragment = { __typename?: 'SendCloudParcel', id?: number | null, name?: string | null, company_name?: string | null, address?: string | null, address2?: string | null, city?: string | null, postal_code?: string | null, telephone?: string | null, email?: string | null, date_created?: string | null, tracking_number?: string | null, tracking_url?: string | null, weight?: string | null, customs_declaration?: any | null, data?: any | null, order_number?: string | null, shipment_uuid?: string | null, external_order_id?: string | null, external_shipment_id?: string | null, external_reference?: string | null, address_divided?: { __typename?: 'SendCloudAddressDivided', street?: string | null, house_number?: string | null } | null, label?: { __typename?: 'SendCloudLabel', normal_printer?: Array<string | null> | null, label_printer?: string | null } | null, status?: { __typename?: 'SendCloudStatus', id?: number | null, message?: string | null } | null, country?: { __typename?: 'SendCloudCountry', iso_3?: string | null, iso_2?: string | null, name?: string | null } | null, shipment?: { __typename?: 'SendCloudShipment', id?: number | null, name?: string | null } | null, parcel_items?: Array<{ __typename?: 'SendCloudParcelItem', description?: string | null, hs_code?: string | null, origin_country?: string | null, product_id?: string | null, properties?: any | null, quantity?: number | null, sku?: string | null, value?: string | null, weight?: string | null } | null> | null };

export type ShipStationCancelOrderMutationVariables = Exact<{
  orderId: Scalars['Float']['input'];
}>;


export type ShipStationCancelOrderMutation = { __typename?: 'Mutation', cancelOrder?: { __typename?: 'ShipStationOrder', id?: number | null, orderId?: number | null, orderNumber?: string | null, orderKey?: string | null, orderDate?: string | null, createDate?: string | null, modifyDate?: string | null, paymentDate?: string | null, shipByDate?: string | null, orderStatus?: ShipStationOrderStatus | null, customerId?: number | null, customerUsername?: string | null, customerEmail?: string | null, orderTotal?: number | null, amountPaid?: number | null, taxAmount?: number | null, shippingAmount?: number | null, customerNotes?: string | null, internalNotes?: string | null, gift?: boolean | null, giftMessage?: string | null, paymentMethod?: string | null, requestedShippingService?: string | null, carrierCode?: string | null, serviceCode?: string | null, packageCode?: string | null, confirmation?: ShipStationConfirmation | null, shipDate?: string | null, holdUntilDate?: string | null, tagIds?: Array<number | null> | null, userId?: string | null, externallyFulfilled?: boolean | null, externallyFulfilledBy?: string | null, billTo?: { __typename?: 'ShipStationAddress', name?: string | null, company?: string | null, street1?: string | null, street2?: string | null, street3?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, country?: string | null, phone?: string | null, residential?: boolean | null, addressVerified?: string | null } | null, shipTo?: { __typename?: 'ShipStationAddress', name?: string | null, company?: string | null, street1?: string | null, street2?: string | null, street3?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, country?: string | null, phone?: string | null, residential?: boolean | null, addressVerified?: string | null } | null, items?: Array<{ __typename?: 'ShipStationOrderItem', orderItemId?: number | null, lineItemKey?: string | null, sku?: string | null, name?: string | null, imageUrl?: string | null, quantity?: number | null, unitPrice?: number | null, taxAmount?: number | null, shippingAmount?: number | null, warehouseLocation?: string | null, productId?: number | null, fulfillmentSku?: string | null, adjustment?: boolean | null, upc?: string | null, createDate?: string | null, modifyDate?: string | null, weight?: { __typename?: 'ShipStationWeight', value?: number | null, units?: ShipStationWeightUnit | null } | null, options?: Array<{ __typename?: 'ShipStationOrderItemOption', name?: string | null, value?: string | null } | null> | null } | null> | null, weight?: { __typename?: 'ShipStationWeight', value?: number | null, units?: ShipStationWeightUnit | null } | null, dimensions?: { __typename?: 'ShipStationDimensions', length?: number | null, width?: number | null, height?: number | null, units?: ShipStationDimensionUnit | null } | null, insuranceOptions?: { __typename?: 'ShipStationInsuranceOptions', provider?: string | null, insureShipment?: boolean | null, insuredValue?: number | null } | null, internationalOptions?: { __typename?: 'ShipStationInternationalOptions', contents?: ShipStationInternationalContents | null, nonDelivery?: ShipStationInternationalNonDelivery | null, customsItems?: Array<{ __typename?: 'ShipStationCustomsItem', customsItemId?: string | null, description?: string | null, quantity?: number | null, value?: number | null, harmonizedTariffCode?: string | null, countryOfOrigin?: string | null } | null> | null } | null, advancedOptions?: { __typename?: 'ShipStationAdvancedOptions', warehouseId?: number | null, nonMachinable?: boolean | null, saturdayDelivery?: boolean | null, containsAlcohol?: boolean | null, storeId?: number | null, customField1?: string | null, customField2?: string | null, customField3?: string | null, source?: string | null, mergedOrSplit?: boolean | null, mergedIds?: Array<number | null> | null, parentId?: number | null, billToParty?: string | null, billToAccount?: string | null, billToPostalCode?: string | null, billToCountryCode?: string | null, billToMyOtherAccount?: string | null } | null } | null };

export type ShipStationDeleteOrderMutationVariables = Exact<{
  orderId: Scalars['Float']['input'];
}>;


export type ShipStationDeleteOrderMutation = { __typename?: 'Mutation', deleteOrder?: { __typename?: 'ShipStationOrder', id?: number | null, orderId?: number | null, orderNumber?: string | null, orderKey?: string | null, orderDate?: string | null, createDate?: string | null, modifyDate?: string | null, paymentDate?: string | null, shipByDate?: string | null, orderStatus?: ShipStationOrderStatus | null, customerId?: number | null, customerUsername?: string | null, customerEmail?: string | null, orderTotal?: number | null, amountPaid?: number | null, taxAmount?: number | null, shippingAmount?: number | null, customerNotes?: string | null, internalNotes?: string | null, gift?: boolean | null, giftMessage?: string | null, paymentMethod?: string | null, requestedShippingService?: string | null, carrierCode?: string | null, serviceCode?: string | null, packageCode?: string | null, confirmation?: ShipStationConfirmation | null, shipDate?: string | null, holdUntilDate?: string | null, tagIds?: Array<number | null> | null, userId?: string | null, externallyFulfilled?: boolean | null, externallyFulfilledBy?: string | null, billTo?: { __typename?: 'ShipStationAddress', name?: string | null, company?: string | null, street1?: string | null, street2?: string | null, street3?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, country?: string | null, phone?: string | null, residential?: boolean | null, addressVerified?: string | null } | null, shipTo?: { __typename?: 'ShipStationAddress', name?: string | null, company?: string | null, street1?: string | null, street2?: string | null, street3?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, country?: string | null, phone?: string | null, residential?: boolean | null, addressVerified?: string | null } | null, items?: Array<{ __typename?: 'ShipStationOrderItem', orderItemId?: number | null, lineItemKey?: string | null, sku?: string | null, name?: string | null, imageUrl?: string | null, quantity?: number | null, unitPrice?: number | null, taxAmount?: number | null, shippingAmount?: number | null, warehouseLocation?: string | null, productId?: number | null, fulfillmentSku?: string | null, adjustment?: boolean | null, upc?: string | null, createDate?: string | null, modifyDate?: string | null, weight?: { __typename?: 'ShipStationWeight', value?: number | null, units?: ShipStationWeightUnit | null } | null, options?: Array<{ __typename?: 'ShipStationOrderItemOption', name?: string | null, value?: string | null } | null> | null } | null> | null, weight?: { __typename?: 'ShipStationWeight', value?: number | null, units?: ShipStationWeightUnit | null } | null, dimensions?: { __typename?: 'ShipStationDimensions', length?: number | null, width?: number | null, height?: number | null, units?: ShipStationDimensionUnit | null } | null, insuranceOptions?: { __typename?: 'ShipStationInsuranceOptions', provider?: string | null, insureShipment?: boolean | null, insuredValue?: number | null } | null, internationalOptions?: { __typename?: 'ShipStationInternationalOptions', contents?: ShipStationInternationalContents | null, nonDelivery?: ShipStationInternationalNonDelivery | null, customsItems?: Array<{ __typename?: 'ShipStationCustomsItem', customsItemId?: string | null, description?: string | null, quantity?: number | null, value?: number | null, harmonizedTariffCode?: string | null, countryOfOrigin?: string | null } | null> | null } | null, advancedOptions?: { __typename?: 'ShipStationAdvancedOptions', warehouseId?: number | null, nonMachinable?: boolean | null, saturdayDelivery?: boolean | null, containsAlcohol?: boolean | null, storeId?: number | null, customField1?: string | null, customField2?: string | null, customField3?: string | null, source?: string | null, mergedOrSplit?: boolean | null, mergedIds?: Array<number | null> | null, parentId?: number | null, billToParty?: string | null, billToAccount?: string | null, billToPostalCode?: string | null, billToCountryCode?: string | null, billToMyOtherAccount?: string | null } | null } | null };

export type ShipStationHoldOrderMutationVariables = Exact<{
  orderId: Scalars['Float']['input'];
  holdUntilDate: Scalars['String']['input'];
}>;


export type ShipStationHoldOrderMutation = { __typename?: 'Mutation', holdOrder?: { __typename?: 'ShipStationOrder', id?: number | null, orderId?: number | null, orderNumber?: string | null, orderKey?: string | null, orderDate?: string | null, createDate?: string | null, modifyDate?: string | null, paymentDate?: string | null, shipByDate?: string | null, orderStatus?: ShipStationOrderStatus | null, customerId?: number | null, customerUsername?: string | null, customerEmail?: string | null, orderTotal?: number | null, amountPaid?: number | null, taxAmount?: number | null, shippingAmount?: number | null, customerNotes?: string | null, internalNotes?: string | null, gift?: boolean | null, giftMessage?: string | null, paymentMethod?: string | null, requestedShippingService?: string | null, carrierCode?: string | null, serviceCode?: string | null, packageCode?: string | null, confirmation?: ShipStationConfirmation | null, shipDate?: string | null, holdUntilDate?: string | null, tagIds?: Array<number | null> | null, userId?: string | null, externallyFulfilled?: boolean | null, externallyFulfilledBy?: string | null, billTo?: { __typename?: 'ShipStationAddress', name?: string | null, company?: string | null, street1?: string | null, street2?: string | null, street3?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, country?: string | null, phone?: string | null, residential?: boolean | null, addressVerified?: string | null } | null, shipTo?: { __typename?: 'ShipStationAddress', name?: string | null, company?: string | null, street1?: string | null, street2?: string | null, street3?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, country?: string | null, phone?: string | null, residential?: boolean | null, addressVerified?: string | null } | null, items?: Array<{ __typename?: 'ShipStationOrderItem', orderItemId?: number | null, lineItemKey?: string | null, sku?: string | null, name?: string | null, imageUrl?: string | null, quantity?: number | null, unitPrice?: number | null, taxAmount?: number | null, shippingAmount?: number | null, warehouseLocation?: string | null, productId?: number | null, fulfillmentSku?: string | null, adjustment?: boolean | null, upc?: string | null, createDate?: string | null, modifyDate?: string | null, weight?: { __typename?: 'ShipStationWeight', value?: number | null, units?: ShipStationWeightUnit | null } | null, options?: Array<{ __typename?: 'ShipStationOrderItemOption', name?: string | null, value?: string | null } | null> | null } | null> | null, weight?: { __typename?: 'ShipStationWeight', value?: number | null, units?: ShipStationWeightUnit | null } | null, dimensions?: { __typename?: 'ShipStationDimensions', length?: number | null, width?: number | null, height?: number | null, units?: ShipStationDimensionUnit | null } | null, insuranceOptions?: { __typename?: 'ShipStationInsuranceOptions', provider?: string | null, insureShipment?: boolean | null, insuredValue?: number | null } | null, internationalOptions?: { __typename?: 'ShipStationInternationalOptions', contents?: ShipStationInternationalContents | null, nonDelivery?: ShipStationInternationalNonDelivery | null, customsItems?: Array<{ __typename?: 'ShipStationCustomsItem', customsItemId?: string | null, description?: string | null, quantity?: number | null, value?: number | null, harmonizedTariffCode?: string | null, countryOfOrigin?: string | null } | null> | null } | null, advancedOptions?: { __typename?: 'ShipStationAdvancedOptions', warehouseId?: number | null, nonMachinable?: boolean | null, saturdayDelivery?: boolean | null, containsAlcohol?: boolean | null, storeId?: number | null, customField1?: string | null, customField2?: string | null, customField3?: string | null, source?: string | null, mergedOrSplit?: boolean | null, mergedIds?: Array<number | null> | null, parentId?: number | null, billToParty?: string | null, billToAccount?: string | null, billToPostalCode?: string | null, billToCountryCode?: string | null, billToMyOtherAccount?: string | null } | null } | null };

export type ShipStationRestoreOrderMutationVariables = Exact<{
  orderId: Scalars['Float']['input'];
}>;


export type ShipStationRestoreOrderMutation = { __typename?: 'Mutation', restoreOrderFromHold?: { __typename?: 'ShipStationOrder', id?: number | null, orderId?: number | null, orderNumber?: string | null, orderKey?: string | null, orderDate?: string | null, createDate?: string | null, modifyDate?: string | null, paymentDate?: string | null, shipByDate?: string | null, orderStatus?: ShipStationOrderStatus | null, customerId?: number | null, customerUsername?: string | null, customerEmail?: string | null, orderTotal?: number | null, amountPaid?: number | null, taxAmount?: number | null, shippingAmount?: number | null, customerNotes?: string | null, internalNotes?: string | null, gift?: boolean | null, giftMessage?: string | null, paymentMethod?: string | null, requestedShippingService?: string | null, carrierCode?: string | null, serviceCode?: string | null, packageCode?: string | null, confirmation?: ShipStationConfirmation | null, shipDate?: string | null, holdUntilDate?: string | null, tagIds?: Array<number | null> | null, userId?: string | null, externallyFulfilled?: boolean | null, externallyFulfilledBy?: string | null, billTo?: { __typename?: 'ShipStationAddress', name?: string | null, company?: string | null, street1?: string | null, street2?: string | null, street3?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, country?: string | null, phone?: string | null, residential?: boolean | null, addressVerified?: string | null } | null, shipTo?: { __typename?: 'ShipStationAddress', name?: string | null, company?: string | null, street1?: string | null, street2?: string | null, street3?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, country?: string | null, phone?: string | null, residential?: boolean | null, addressVerified?: string | null } | null, items?: Array<{ __typename?: 'ShipStationOrderItem', orderItemId?: number | null, lineItemKey?: string | null, sku?: string | null, name?: string | null, imageUrl?: string | null, quantity?: number | null, unitPrice?: number | null, taxAmount?: number | null, shippingAmount?: number | null, warehouseLocation?: string | null, productId?: number | null, fulfillmentSku?: string | null, adjustment?: boolean | null, upc?: string | null, createDate?: string | null, modifyDate?: string | null, weight?: { __typename?: 'ShipStationWeight', value?: number | null, units?: ShipStationWeightUnit | null } | null, options?: Array<{ __typename?: 'ShipStationOrderItemOption', name?: string | null, value?: string | null } | null> | null } | null> | null, weight?: { __typename?: 'ShipStationWeight', value?: number | null, units?: ShipStationWeightUnit | null } | null, dimensions?: { __typename?: 'ShipStationDimensions', length?: number | null, width?: number | null, height?: number | null, units?: ShipStationDimensionUnit | null } | null, insuranceOptions?: { __typename?: 'ShipStationInsuranceOptions', provider?: string | null, insureShipment?: boolean | null, insuredValue?: number | null } | null, internationalOptions?: { __typename?: 'ShipStationInternationalOptions', contents?: ShipStationInternationalContents | null, nonDelivery?: ShipStationInternationalNonDelivery | null, customsItems?: Array<{ __typename?: 'ShipStationCustomsItem', customsItemId?: string | null, description?: string | null, quantity?: number | null, value?: number | null, harmonizedTariffCode?: string | null, countryOfOrigin?: string | null } | null> | null } | null, advancedOptions?: { __typename?: 'ShipStationAdvancedOptions', warehouseId?: number | null, nonMachinable?: boolean | null, saturdayDelivery?: boolean | null, containsAlcohol?: boolean | null, storeId?: number | null, customField1?: string | null, customField2?: string | null, customField3?: string | null, source?: string | null, mergedOrSplit?: boolean | null, mergedIds?: Array<number | null> | null, parentId?: number | null, billToParty?: string | null, billToAccount?: string | null, billToPostalCode?: string | null, billToCountryCode?: string | null, billToMyOtherAccount?: string | null } | null } | null };

export type ShipStationVoidLabelMutationVariables = Exact<{
  orderId: Scalars['Float']['input'];
  shipmentId: Scalars['Float']['input'];
}>;


export type ShipStationVoidLabelMutation = { __typename?: 'Mutation', voidLabel?: boolean | null };

export type ShipStationCalculateRatesMutationVariables = Exact<{
  input: CalculateRatesInput;
}>;


export type ShipStationCalculateRatesMutation = { __typename?: 'Mutation', calculateRates?: Array<{ __typename?: 'ShipStationRate', serviceName?: string | null, serviceCode?: string | null, shipmentCost?: number | null, otherCost?: number | null } | null> | null };

export type ShipStationMarkOrderAsShippedMutationVariables = Exact<{
  input: MarkShippedInput;
}>;


export type ShipStationMarkOrderAsShippedMutation = { __typename?: 'Mutation', markOrderAsShipped?: { __typename?: 'MarkedShipped', orderId?: number | null, carrierCode?: string | null, shipDate?: string | null, trackingNumber?: string | null, notifyCustomer?: boolean | null, notifySalesChannel?: boolean | null } | null };

export type ShipStationCreateLabelForOrderMutationVariables = Exact<{
  input: CreateLabelInput;
}>;


export type ShipStationCreateLabelForOrderMutation = { __typename?: 'Mutation', createLabelForOrder?: { __typename?: 'ShipStationLabel', shipmentId?: number | null, shipmentCost?: number | null, insuranceCost?: number | null, trackingNumber?: string | null, labelData?: string | null, formData?: string | null } | null };

export type ShipStationUpdateOrderAddressMutationVariables = Exact<{
  orderId: Scalars['Float']['input'];
  input: OrderAddressInput;
}>;


export type ShipStationUpdateOrderAddressMutation = { __typename?: 'Mutation', updateOrderAddress?: { __typename?: 'ShipStationOrder', id?: number | null, orderId?: number | null, orderNumber?: string | null, orderKey?: string | null, orderDate?: string | null, createDate?: string | null, modifyDate?: string | null, paymentDate?: string | null, shipByDate?: string | null, orderStatus?: ShipStationOrderStatus | null, customerId?: number | null, customerUsername?: string | null, customerEmail?: string | null, orderTotal?: number | null, amountPaid?: number | null, taxAmount?: number | null, shippingAmount?: number | null, customerNotes?: string | null, internalNotes?: string | null, gift?: boolean | null, giftMessage?: string | null, paymentMethod?: string | null, requestedShippingService?: string | null, carrierCode?: string | null, serviceCode?: string | null, packageCode?: string | null, confirmation?: ShipStationConfirmation | null, shipDate?: string | null, holdUntilDate?: string | null, tagIds?: Array<number | null> | null, userId?: string | null, externallyFulfilled?: boolean | null, externallyFulfilledBy?: string | null, billTo?: { __typename?: 'ShipStationAddress', name?: string | null, company?: string | null, street1?: string | null, street2?: string | null, street3?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, country?: string | null, phone?: string | null, residential?: boolean | null, addressVerified?: string | null } | null, shipTo?: { __typename?: 'ShipStationAddress', name?: string | null, company?: string | null, street1?: string | null, street2?: string | null, street3?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, country?: string | null, phone?: string | null, residential?: boolean | null, addressVerified?: string | null } | null, items?: Array<{ __typename?: 'ShipStationOrderItem', orderItemId?: number | null, lineItemKey?: string | null, sku?: string | null, name?: string | null, imageUrl?: string | null, quantity?: number | null, unitPrice?: number | null, taxAmount?: number | null, shippingAmount?: number | null, warehouseLocation?: string | null, productId?: number | null, fulfillmentSku?: string | null, adjustment?: boolean | null, upc?: string | null, createDate?: string | null, modifyDate?: string | null, weight?: { __typename?: 'ShipStationWeight', value?: number | null, units?: ShipStationWeightUnit | null } | null, options?: Array<{ __typename?: 'ShipStationOrderItemOption', name?: string | null, value?: string | null } | null> | null } | null> | null, weight?: { __typename?: 'ShipStationWeight', value?: number | null, units?: ShipStationWeightUnit | null } | null, dimensions?: { __typename?: 'ShipStationDimensions', length?: number | null, width?: number | null, height?: number | null, units?: ShipStationDimensionUnit | null } | null, insuranceOptions?: { __typename?: 'ShipStationInsuranceOptions', provider?: string | null, insureShipment?: boolean | null, insuredValue?: number | null } | null, internationalOptions?: { __typename?: 'ShipStationInternationalOptions', contents?: ShipStationInternationalContents | null, nonDelivery?: ShipStationInternationalNonDelivery | null, customsItems?: Array<{ __typename?: 'ShipStationCustomsItem', customsItemId?: string | null, description?: string | null, quantity?: number | null, value?: number | null, harmonizedTariffCode?: string | null, countryOfOrigin?: string | null } | null> | null } | null, advancedOptions?: { __typename?: 'ShipStationAdvancedOptions', warehouseId?: number | null, nonMachinable?: boolean | null, saturdayDelivery?: boolean | null, containsAlcohol?: boolean | null, storeId?: number | null, customField1?: string | null, customField2?: string | null, customField3?: string | null, source?: string | null, mergedOrSplit?: boolean | null, mergedIds?: Array<number | null> | null, parentId?: number | null, billToParty?: string | null, billToAccount?: string | null, billToPostalCode?: string | null, billToCountryCode?: string | null, billToMyOtherAccount?: string | null } | null } | null };

export type ShipStationUpdateOrderItemsMutationVariables = Exact<{
  orderId: Scalars['Float']['input'];
  items: Array<OrderItemInput> | OrderItemInput;
}>;


export type ShipStationUpdateOrderItemsMutation = { __typename?: 'Mutation', updateOrderItems?: { __typename?: 'ShipStationOrder', id?: number | null, orderId?: number | null, orderNumber?: string | null, orderKey?: string | null, orderDate?: string | null, createDate?: string | null, modifyDate?: string | null, paymentDate?: string | null, shipByDate?: string | null, orderStatus?: ShipStationOrderStatus | null, customerId?: number | null, customerUsername?: string | null, customerEmail?: string | null, orderTotal?: number | null, amountPaid?: number | null, taxAmount?: number | null, shippingAmount?: number | null, customerNotes?: string | null, internalNotes?: string | null, gift?: boolean | null, giftMessage?: string | null, paymentMethod?: string | null, requestedShippingService?: string | null, carrierCode?: string | null, serviceCode?: string | null, packageCode?: string | null, confirmation?: ShipStationConfirmation | null, shipDate?: string | null, holdUntilDate?: string | null, tagIds?: Array<number | null> | null, userId?: string | null, externallyFulfilled?: boolean | null, externallyFulfilledBy?: string | null, billTo?: { __typename?: 'ShipStationAddress', name?: string | null, company?: string | null, street1?: string | null, street2?: string | null, street3?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, country?: string | null, phone?: string | null, residential?: boolean | null, addressVerified?: string | null } | null, shipTo?: { __typename?: 'ShipStationAddress', name?: string | null, company?: string | null, street1?: string | null, street2?: string | null, street3?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, country?: string | null, phone?: string | null, residential?: boolean | null, addressVerified?: string | null } | null, items?: Array<{ __typename?: 'ShipStationOrderItem', orderItemId?: number | null, lineItemKey?: string | null, sku?: string | null, name?: string | null, imageUrl?: string | null, quantity?: number | null, unitPrice?: number | null, taxAmount?: number | null, shippingAmount?: number | null, warehouseLocation?: string | null, productId?: number | null, fulfillmentSku?: string | null, adjustment?: boolean | null, upc?: string | null, createDate?: string | null, modifyDate?: string | null, weight?: { __typename?: 'ShipStationWeight', value?: number | null, units?: ShipStationWeightUnit | null } | null, options?: Array<{ __typename?: 'ShipStationOrderItemOption', name?: string | null, value?: string | null } | null> | null } | null> | null, weight?: { __typename?: 'ShipStationWeight', value?: number | null, units?: ShipStationWeightUnit | null } | null, dimensions?: { __typename?: 'ShipStationDimensions', length?: number | null, width?: number | null, height?: number | null, units?: ShipStationDimensionUnit | null } | null, insuranceOptions?: { __typename?: 'ShipStationInsuranceOptions', provider?: string | null, insureShipment?: boolean | null, insuredValue?: number | null } | null, internationalOptions?: { __typename?: 'ShipStationInternationalOptions', contents?: ShipStationInternationalContents | null, nonDelivery?: ShipStationInternationalNonDelivery | null, customsItems?: Array<{ __typename?: 'ShipStationCustomsItem', customsItemId?: string | null, description?: string | null, quantity?: number | null, value?: number | null, harmonizedTariffCode?: string | null, countryOfOrigin?: string | null } | null> | null } | null, advancedOptions?: { __typename?: 'ShipStationAdvancedOptions', warehouseId?: number | null, nonMachinable?: boolean | null, saturdayDelivery?: boolean | null, containsAlcohol?: boolean | null, storeId?: number | null, customField1?: string | null, customField2?: string | null, customField3?: string | null, source?: string | null, mergedOrSplit?: boolean | null, mergedIds?: Array<number | null> | null, parentId?: number | null, billToParty?: string | null, billToAccount?: string | null, billToPostalCode?: string | null, billToCountryCode?: string | null, billToMyOtherAccount?: string | null } | null } | null };

export type ShipStationUpdateOrderNotesMutationVariables = Exact<{
  orderId: Scalars['Float']['input'];
  input: OrderNotesInput;
}>;


export type ShipStationUpdateOrderNotesMutation = { __typename?: 'Mutation', updateOrderNotes?: { __typename?: 'ShipStationOrder', id?: number | null, orderId?: number | null, orderNumber?: string | null, orderKey?: string | null, orderDate?: string | null, createDate?: string | null, modifyDate?: string | null, paymentDate?: string | null, shipByDate?: string | null, orderStatus?: ShipStationOrderStatus | null, customerId?: number | null, customerUsername?: string | null, customerEmail?: string | null, orderTotal?: number | null, amountPaid?: number | null, taxAmount?: number | null, shippingAmount?: number | null, customerNotes?: string | null, internalNotes?: string | null, gift?: boolean | null, giftMessage?: string | null, paymentMethod?: string | null, requestedShippingService?: string | null, carrierCode?: string | null, serviceCode?: string | null, packageCode?: string | null, confirmation?: ShipStationConfirmation | null, shipDate?: string | null, holdUntilDate?: string | null, tagIds?: Array<number | null> | null, userId?: string | null, externallyFulfilled?: boolean | null, externallyFulfilledBy?: string | null, billTo?: { __typename?: 'ShipStationAddress', name?: string | null, company?: string | null, street1?: string | null, street2?: string | null, street3?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, country?: string | null, phone?: string | null, residential?: boolean | null, addressVerified?: string | null } | null, shipTo?: { __typename?: 'ShipStationAddress', name?: string | null, company?: string | null, street1?: string | null, street2?: string | null, street3?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, country?: string | null, phone?: string | null, residential?: boolean | null, addressVerified?: string | null } | null, items?: Array<{ __typename?: 'ShipStationOrderItem', orderItemId?: number | null, lineItemKey?: string | null, sku?: string | null, name?: string | null, imageUrl?: string | null, quantity?: number | null, unitPrice?: number | null, taxAmount?: number | null, shippingAmount?: number | null, warehouseLocation?: string | null, productId?: number | null, fulfillmentSku?: string | null, adjustment?: boolean | null, upc?: string | null, createDate?: string | null, modifyDate?: string | null, weight?: { __typename?: 'ShipStationWeight', value?: number | null, units?: ShipStationWeightUnit | null } | null, options?: Array<{ __typename?: 'ShipStationOrderItemOption', name?: string | null, value?: string | null } | null> | null } | null> | null, weight?: { __typename?: 'ShipStationWeight', value?: number | null, units?: ShipStationWeightUnit | null } | null, dimensions?: { __typename?: 'ShipStationDimensions', length?: number | null, width?: number | null, height?: number | null, units?: ShipStationDimensionUnit | null } | null, insuranceOptions?: { __typename?: 'ShipStationInsuranceOptions', provider?: string | null, insureShipment?: boolean | null, insuredValue?: number | null } | null, internationalOptions?: { __typename?: 'ShipStationInternationalOptions', contents?: ShipStationInternationalContents | null, nonDelivery?: ShipStationInternationalNonDelivery | null, customsItems?: Array<{ __typename?: 'ShipStationCustomsItem', customsItemId?: string | null, description?: string | null, quantity?: number | null, value?: number | null, harmonizedTariffCode?: string | null, countryOfOrigin?: string | null } | null> | null } | null, advancedOptions?: { __typename?: 'ShipStationAdvancedOptions', warehouseId?: number | null, nonMachinable?: boolean | null, saturdayDelivery?: boolean | null, containsAlcohol?: boolean | null, storeId?: number | null, customField1?: string | null, customField2?: string | null, customField3?: string | null, source?: string | null, mergedOrSplit?: boolean | null, mergedIds?: Array<number | null> | null, parentId?: number | null, billToParty?: string | null, billToAccount?: string | null, billToPostalCode?: string | null, billToCountryCode?: string | null, billToMyOtherAccount?: string | null } | null } | null };

export type CreateSendCloudLabelsForOrderMutationVariables = Exact<{
  orderNumbers: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type CreateSendCloudLabelsForOrderMutation = { __typename?: 'Mutation', createSendCloudLabelsForOrder?: Array<{ __typename?: 'SendCloudLabelWithParcel', error?: string | null, parcelId?: number | null, normal_printer?: Array<string | null> | null, label_printer?: string | null, parcel?: { __typename?: 'SendCloudParcel', name?: string | null, order_number?: string | null, tracking_number?: string | null, country?: { __typename?: 'SendCloudCountry', name?: string | null } | null } | null } | null> | null };

export type BatchCreateSendCloudLabelsForOrderMutationVariables = Exact<{
  orderNumbers: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type BatchCreateSendCloudLabelsForOrderMutation = { __typename?: 'Mutation', batchCreateSendCloudLabelsForOrder?: { __typename?: 'BatchSendCloudLabelWithParcel', batch?: string | null, labels?: Array<{ __typename?: 'SendCloudLabelWithParcel', error?: string | null, parcelId?: number | null, normal_printer?: Array<string | null> | null, label_printer?: string | null, parcel?: { __typename?: 'SendCloudParcel', name?: string | null, order_number?: string | null, tracking_number?: string | null, country?: { __typename?: 'SendCloudCountry', name?: string | null } | null } | null } | null> | null } | null };

export type SendToSendCloudMutationVariables = Exact<{
  orderId: Scalars['Float']['input'];
}>;


export type SendToSendCloudMutation = { __typename?: 'Mutation', sendToSendCloud?: { __typename?: 'SendToSendCloudResult', orderId?: number | null, order?: { __typename?: 'ShipStationOrder', id?: number | null, orderId?: number | null, orderNumber?: string | null, orderKey?: string | null, orderDate?: string | null, createDate?: string | null, modifyDate?: string | null, paymentDate?: string | null, shipByDate?: string | null, orderStatus?: ShipStationOrderStatus | null, customerId?: number | null, customerUsername?: string | null, customerEmail?: string | null, orderTotal?: number | null, amountPaid?: number | null, taxAmount?: number | null, shippingAmount?: number | null, customerNotes?: string | null, internalNotes?: string | null, gift?: boolean | null, giftMessage?: string | null, paymentMethod?: string | null, requestedShippingService?: string | null, carrierCode?: string | null, serviceCode?: string | null, packageCode?: string | null, confirmation?: ShipStationConfirmation | null, shipDate?: string | null, holdUntilDate?: string | null, tagIds?: Array<number | null> | null, userId?: string | null, externallyFulfilled?: boolean | null, externallyFulfilledBy?: string | null, billTo?: { __typename?: 'ShipStationAddress', name?: string | null, company?: string | null, street1?: string | null, street2?: string | null, street3?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, country?: string | null, phone?: string | null, residential?: boolean | null, addressVerified?: string | null } | null, shipTo?: { __typename?: 'ShipStationAddress', name?: string | null, company?: string | null, street1?: string | null, street2?: string | null, street3?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, country?: string | null, phone?: string | null, residential?: boolean | null, addressVerified?: string | null } | null, items?: Array<{ __typename?: 'ShipStationOrderItem', orderItemId?: number | null, lineItemKey?: string | null, sku?: string | null, name?: string | null, imageUrl?: string | null, quantity?: number | null, unitPrice?: number | null, taxAmount?: number | null, shippingAmount?: number | null, warehouseLocation?: string | null, productId?: number | null, fulfillmentSku?: string | null, adjustment?: boolean | null, upc?: string | null, createDate?: string | null, modifyDate?: string | null, weight?: { __typename?: 'ShipStationWeight', value?: number | null, units?: ShipStationWeightUnit | null } | null, options?: Array<{ __typename?: 'ShipStationOrderItemOption', name?: string | null, value?: string | null } | null> | null } | null> | null, weight?: { __typename?: 'ShipStationWeight', value?: number | null, units?: ShipStationWeightUnit | null } | null, dimensions?: { __typename?: 'ShipStationDimensions', length?: number | null, width?: number | null, height?: number | null, units?: ShipStationDimensionUnit | null } | null, insuranceOptions?: { __typename?: 'ShipStationInsuranceOptions', provider?: string | null, insureShipment?: boolean | null, insuredValue?: number | null } | null, internationalOptions?: { __typename?: 'ShipStationInternationalOptions', contents?: ShipStationInternationalContents | null, nonDelivery?: ShipStationInternationalNonDelivery | null, customsItems?: Array<{ __typename?: 'ShipStationCustomsItem', customsItemId?: string | null, description?: string | null, quantity?: number | null, value?: number | null, harmonizedTariffCode?: string | null, countryOfOrigin?: string | null } | null> | null } | null, advancedOptions?: { __typename?: 'ShipStationAdvancedOptions', warehouseId?: number | null, nonMachinable?: boolean | null, saturdayDelivery?: boolean | null, containsAlcohol?: boolean | null, storeId?: number | null, customField1?: string | null, customField2?: string | null, customField3?: string | null, source?: string | null, mergedOrSplit?: boolean | null, mergedIds?: Array<number | null> | null, parentId?: number | null, billToParty?: string | null, billToAccount?: string | null, billToPostalCode?: string | null, billToCountryCode?: string | null, billToMyOtherAccount?: string | null } | null } | null, parcel?: { __typename?: 'SendCloudParcel', id?: number | null, name?: string | null, company_name?: string | null, address?: string | null, address2?: string | null, city?: string | null, postal_code?: string | null, telephone?: string | null, email?: string | null, date_created?: string | null, tracking_number?: string | null, tracking_url?: string | null, weight?: string | null, customs_declaration?: any | null, data?: any | null, order_number?: string | null, shipment_uuid?: string | null, external_order_id?: string | null, external_shipment_id?: string | null, external_reference?: string | null, address_divided?: { __typename?: 'SendCloudAddressDivided', street?: string | null, house_number?: string | null } | null, label?: { __typename?: 'SendCloudLabel', normal_printer?: Array<string | null> | null, label_printer?: string | null } | null, status?: { __typename?: 'SendCloudStatus', id?: number | null, message?: string | null } | null, country?: { __typename?: 'SendCloudCountry', iso_3?: string | null, iso_2?: string | null, name?: string | null } | null, shipment?: { __typename?: 'SendCloudShipment', id?: number | null, name?: string | null } | null, parcel_items?: Array<{ __typename?: 'SendCloudParcelItem', description?: string | null, hs_code?: string | null, origin_country?: string | null, product_id?: string | null, properties?: any | null, quantity?: number | null, sku?: string | null, value?: string | null, weight?: string | null } | null> | null } | null } | null };

export type ShipStationGetOrderQueryVariables = Exact<{
  orderId: Scalars['Float']['input'];
}>;


export type ShipStationGetOrderQuery = { __typename?: 'Query', getOrder?: { __typename?: 'ShipStationOrder', id?: number | null, orderId?: number | null, orderNumber?: string | null, orderKey?: string | null, orderDate?: string | null, createDate?: string | null, modifyDate?: string | null, paymentDate?: string | null, shipByDate?: string | null, orderStatus?: ShipStationOrderStatus | null, customerId?: number | null, customerUsername?: string | null, customerEmail?: string | null, orderTotal?: number | null, amountPaid?: number | null, taxAmount?: number | null, shippingAmount?: number | null, customerNotes?: string | null, internalNotes?: string | null, gift?: boolean | null, giftMessage?: string | null, paymentMethod?: string | null, requestedShippingService?: string | null, carrierCode?: string | null, serviceCode?: string | null, packageCode?: string | null, confirmation?: ShipStationConfirmation | null, shipDate?: string | null, holdUntilDate?: string | null, tagIds?: Array<number | null> | null, userId?: string | null, externallyFulfilled?: boolean | null, externallyFulfilledBy?: string | null, billTo?: { __typename?: 'ShipStationAddress', name?: string | null, company?: string | null, street1?: string | null, street2?: string | null, street3?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, country?: string | null, phone?: string | null, residential?: boolean | null, addressVerified?: string | null } | null, shipTo?: { __typename?: 'ShipStationAddress', name?: string | null, company?: string | null, street1?: string | null, street2?: string | null, street3?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, country?: string | null, phone?: string | null, residential?: boolean | null, addressVerified?: string | null } | null, items?: Array<{ __typename?: 'ShipStationOrderItem', orderItemId?: number | null, lineItemKey?: string | null, sku?: string | null, name?: string | null, imageUrl?: string | null, quantity?: number | null, unitPrice?: number | null, taxAmount?: number | null, shippingAmount?: number | null, warehouseLocation?: string | null, productId?: number | null, fulfillmentSku?: string | null, adjustment?: boolean | null, upc?: string | null, createDate?: string | null, modifyDate?: string | null, weight?: { __typename?: 'ShipStationWeight', value?: number | null, units?: ShipStationWeightUnit | null } | null, options?: Array<{ __typename?: 'ShipStationOrderItemOption', name?: string | null, value?: string | null } | null> | null } | null> | null, weight?: { __typename?: 'ShipStationWeight', value?: number | null, units?: ShipStationWeightUnit | null } | null, dimensions?: { __typename?: 'ShipStationDimensions', length?: number | null, width?: number | null, height?: number | null, units?: ShipStationDimensionUnit | null } | null, insuranceOptions?: { __typename?: 'ShipStationInsuranceOptions', provider?: string | null, insureShipment?: boolean | null, insuredValue?: number | null } | null, internationalOptions?: { __typename?: 'ShipStationInternationalOptions', contents?: ShipStationInternationalContents | null, nonDelivery?: ShipStationInternationalNonDelivery | null, customsItems?: Array<{ __typename?: 'ShipStationCustomsItem', customsItemId?: string | null, description?: string | null, quantity?: number | null, value?: number | null, harmonizedTariffCode?: string | null, countryOfOrigin?: string | null } | null> | null } | null, advancedOptions?: { __typename?: 'ShipStationAdvancedOptions', warehouseId?: number | null, nonMachinable?: boolean | null, saturdayDelivery?: boolean | null, containsAlcohol?: boolean | null, storeId?: number | null, customField1?: string | null, customField2?: string | null, customField3?: string | null, source?: string | null, mergedOrSplit?: boolean | null, mergedIds?: Array<number | null> | null, parentId?: number | null, billToParty?: string | null, billToAccount?: string | null, billToPostalCode?: string | null, billToCountryCode?: string | null, billToMyOtherAccount?: string | null } | null } | null };

export type SendCloudGetParcelQueryVariables = Exact<{
  parcelId?: InputMaybe<Scalars['Float']['input']>;
  trackingNumber?: InputMaybe<Scalars['String']['input']>;
}>;


export type SendCloudGetParcelQuery = { __typename?: 'Query', getParcel?: { __typename?: 'SendCloudParcel', id?: number | null, name?: string | null, company_name?: string | null, address?: string | null, address2?: string | null, city?: string | null, postal_code?: string | null, telephone?: string | null, email?: string | null, date_created?: string | null, tracking_number?: string | null, tracking_url?: string | null, weight?: string | null, customs_declaration?: any | null, data?: any | null, order_number?: string | null, shipment_uuid?: string | null, external_order_id?: string | null, external_shipment_id?: string | null, external_reference?: string | null, address_divided?: { __typename?: 'SendCloudAddressDivided', street?: string | null, house_number?: string | null } | null, label?: { __typename?: 'SendCloudLabel', normal_printer?: Array<string | null> | null, label_printer?: string | null } | null, status?: { __typename?: 'SendCloudStatus', id?: number | null, message?: string | null } | null, country?: { __typename?: 'SendCloudCountry', iso_3?: string | null, iso_2?: string | null, name?: string | null } | null, shipment?: { __typename?: 'SendCloudShipment', id?: number | null, name?: string | null } | null, parcel_items?: Array<{ __typename?: 'SendCloudParcelItem', description?: string | null, hs_code?: string | null, origin_country?: string | null, product_id?: string | null, properties?: any | null, quantity?: number | null, sku?: string | null, value?: string | null, weight?: string | null } | null> | null } | null };

export type ShipStationListOrdersQueryVariables = Exact<{
  filter?: InputMaybe<ShipStationOrderFilter>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<Sort>;
}>;


export type ShipStationListOrdersQuery = { __typename?: 'Query', listOrders?: { __typename?: 'ShipStationOrderPage', total?: number | null, data?: Array<{ __typename?: 'ShipStationOrder', id?: number | null, orderId?: number | null, orderNumber?: string | null, orderKey?: string | null, orderDate?: string | null, createDate?: string | null, modifyDate?: string | null, paymentDate?: string | null, shipByDate?: string | null, orderStatus?: ShipStationOrderStatus | null, customerId?: number | null, customerUsername?: string | null, customerEmail?: string | null, orderTotal?: number | null, amountPaid?: number | null, taxAmount?: number | null, shippingAmount?: number | null, customerNotes?: string | null, internalNotes?: string | null, gift?: boolean | null, giftMessage?: string | null, paymentMethod?: string | null, requestedShippingService?: string | null, carrierCode?: string | null, serviceCode?: string | null, packageCode?: string | null, confirmation?: ShipStationConfirmation | null, shipDate?: string | null, holdUntilDate?: string | null, tagIds?: Array<number | null> | null, userId?: string | null, externallyFulfilled?: boolean | null, externallyFulfilledBy?: string | null, billTo?: { __typename?: 'ShipStationAddress', name?: string | null, company?: string | null, street1?: string | null, street2?: string | null, street3?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, country?: string | null, phone?: string | null, residential?: boolean | null, addressVerified?: string | null } | null, shipTo?: { __typename?: 'ShipStationAddress', name?: string | null, company?: string | null, street1?: string | null, street2?: string | null, street3?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, country?: string | null, phone?: string | null, residential?: boolean | null, addressVerified?: string | null } | null, items?: Array<{ __typename?: 'ShipStationOrderItem', orderItemId?: number | null, lineItemKey?: string | null, sku?: string | null, name?: string | null, imageUrl?: string | null, quantity?: number | null, unitPrice?: number | null, taxAmount?: number | null, shippingAmount?: number | null, warehouseLocation?: string | null, productId?: number | null, fulfillmentSku?: string | null, adjustment?: boolean | null, upc?: string | null, createDate?: string | null, modifyDate?: string | null, weight?: { __typename?: 'ShipStationWeight', value?: number | null, units?: ShipStationWeightUnit | null } | null, options?: Array<{ __typename?: 'ShipStationOrderItemOption', name?: string | null, value?: string | null } | null> | null } | null> | null, weight?: { __typename?: 'ShipStationWeight', value?: number | null, units?: ShipStationWeightUnit | null } | null, dimensions?: { __typename?: 'ShipStationDimensions', length?: number | null, width?: number | null, height?: number | null, units?: ShipStationDimensionUnit | null } | null, insuranceOptions?: { __typename?: 'ShipStationInsuranceOptions', provider?: string | null, insureShipment?: boolean | null, insuredValue?: number | null } | null, internationalOptions?: { __typename?: 'ShipStationInternationalOptions', contents?: ShipStationInternationalContents | null, nonDelivery?: ShipStationInternationalNonDelivery | null, customsItems?: Array<{ __typename?: 'ShipStationCustomsItem', customsItemId?: string | null, description?: string | null, quantity?: number | null, value?: number | null, harmonizedTariffCode?: string | null, countryOfOrigin?: string | null } | null> | null } | null, advancedOptions?: { __typename?: 'ShipStationAdvancedOptions', warehouseId?: number | null, nonMachinable?: boolean | null, saturdayDelivery?: boolean | null, containsAlcohol?: boolean | null, storeId?: number | null, customField1?: string | null, customField2?: string | null, customField3?: string | null, source?: string | null, mergedOrSplit?: boolean | null, mergedIds?: Array<number | null> | null, parentId?: number | null, billToParty?: string | null, billToAccount?: string | null, billToPostalCode?: string | null, billToCountryCode?: string | null, billToMyOtherAccount?: string | null } | null } | null> | null } | null };

export type ShipStationListOrdersByTagQueryVariables = Exact<{
  filter: ShipStationOrderByTagFilter;
  pagination?: InputMaybe<Pagination>;
}>;


export type ShipStationListOrdersByTagQuery = { __typename?: 'Query', listOrdersByTag?: { __typename?: 'ShipStationOrderPage', total?: number | null, data?: Array<{ __typename?: 'ShipStationOrder', id?: number | null, orderId?: number | null, orderNumber?: string | null, orderKey?: string | null, orderDate?: string | null, createDate?: string | null, modifyDate?: string | null, paymentDate?: string | null, shipByDate?: string | null, orderStatus?: ShipStationOrderStatus | null, customerId?: number | null, customerUsername?: string | null, customerEmail?: string | null, orderTotal?: number | null, amountPaid?: number | null, taxAmount?: number | null, shippingAmount?: number | null, customerNotes?: string | null, internalNotes?: string | null, gift?: boolean | null, giftMessage?: string | null, paymentMethod?: string | null, requestedShippingService?: string | null, carrierCode?: string | null, serviceCode?: string | null, packageCode?: string | null, confirmation?: ShipStationConfirmation | null, shipDate?: string | null, holdUntilDate?: string | null, tagIds?: Array<number | null> | null, userId?: string | null, externallyFulfilled?: boolean | null, externallyFulfilledBy?: string | null, billTo?: { __typename?: 'ShipStationAddress', name?: string | null, company?: string | null, street1?: string | null, street2?: string | null, street3?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, country?: string | null, phone?: string | null, residential?: boolean | null, addressVerified?: string | null } | null, shipTo?: { __typename?: 'ShipStationAddress', name?: string | null, company?: string | null, street1?: string | null, street2?: string | null, street3?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, country?: string | null, phone?: string | null, residential?: boolean | null, addressVerified?: string | null } | null, items?: Array<{ __typename?: 'ShipStationOrderItem', orderItemId?: number | null, lineItemKey?: string | null, sku?: string | null, name?: string | null, imageUrl?: string | null, quantity?: number | null, unitPrice?: number | null, taxAmount?: number | null, shippingAmount?: number | null, warehouseLocation?: string | null, productId?: number | null, fulfillmentSku?: string | null, adjustment?: boolean | null, upc?: string | null, createDate?: string | null, modifyDate?: string | null, weight?: { __typename?: 'ShipStationWeight', value?: number | null, units?: ShipStationWeightUnit | null } | null, options?: Array<{ __typename?: 'ShipStationOrderItemOption', name?: string | null, value?: string | null } | null> | null } | null> | null, weight?: { __typename?: 'ShipStationWeight', value?: number | null, units?: ShipStationWeightUnit | null } | null, dimensions?: { __typename?: 'ShipStationDimensions', length?: number | null, width?: number | null, height?: number | null, units?: ShipStationDimensionUnit | null } | null, insuranceOptions?: { __typename?: 'ShipStationInsuranceOptions', provider?: string | null, insureShipment?: boolean | null, insuredValue?: number | null } | null, internationalOptions?: { __typename?: 'ShipStationInternationalOptions', contents?: ShipStationInternationalContents | null, nonDelivery?: ShipStationInternationalNonDelivery | null, customsItems?: Array<{ __typename?: 'ShipStationCustomsItem', customsItemId?: string | null, description?: string | null, quantity?: number | null, value?: number | null, harmonizedTariffCode?: string | null, countryOfOrigin?: string | null } | null> | null } | null, advancedOptions?: { __typename?: 'ShipStationAdvancedOptions', warehouseId?: number | null, nonMachinable?: boolean | null, saturdayDelivery?: boolean | null, containsAlcohol?: boolean | null, storeId?: number | null, customField1?: string | null, customField2?: string | null, customField3?: string | null, source?: string | null, mergedOrSplit?: boolean | null, mergedIds?: Array<number | null> | null, parentId?: number | null, billToParty?: string | null, billToAccount?: string | null, billToPostalCode?: string | null, billToCountryCode?: string | null, billToMyOtherAccount?: string | null } | null } | null> | null } | null };

export type ShipStationListShipmentsQueryVariables = Exact<{
  filter?: InputMaybe<ShipStationShipmentsFilter>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<Sort>;
}>;


export type ShipStationListShipmentsQuery = { __typename?: 'Query', listShipments?: { __typename?: 'ShipStationShipmentPage', total?: number | null, data?: Array<{ __typename?: 'ShipStationShipment', id?: number | null, shipmentId?: number | null, orderId?: number | null, orderKey?: string | null, userId?: string | null, orderNumber?: string | null, createDate?: string | null, shipDate?: string | null, shipmentCost?: number | null, insuranceCost?: number | null, trackingNumber?: string | null, isReturnLabel?: boolean | null, customerEmail?: string | null, batchNumber?: string | null, carrierCode?: string | null, serviceCode?: string | null, packageCode?: string | null, confirmation?: ShipStationConfirmation | null, warehouseId?: number | null, voided?: boolean | null, voidDate?: string | null, marketplaceNotified?: boolean | null, notifyErrorMessage?: string | null, labelData?: string | null, formData?: string | null, shipTo?: { __typename?: 'ShipStationAddress', name?: string | null, company?: string | null, street1?: string | null, street2?: string | null, street3?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, country?: string | null, phone?: string | null, residential?: boolean | null, addressVerified?: string | null } | null, weight?: { __typename?: 'ShipStationWeight', value?: number | null, units?: ShipStationWeightUnit | null } | null, dimensions?: { __typename?: 'ShipStationDimensions', length?: number | null, width?: number | null, height?: number | null, units?: ShipStationDimensionUnit | null } | null, insuranceOptions?: { __typename?: 'ShipStationInsuranceOptions', provider?: string | null, insureShipment?: boolean | null, insuredValue?: number | null } | null, advancedOptions?: { __typename?: 'ShipStationAdvancedOptions', warehouseId?: number | null, nonMachinable?: boolean | null, saturdayDelivery?: boolean | null, containsAlcohol?: boolean | null, storeId?: number | null, customField1?: string | null, customField2?: string | null, customField3?: string | null, source?: string | null, mergedOrSplit?: boolean | null, mergedIds?: Array<number | null> | null, parentId?: number | null, billToParty?: string | null, billToAccount?: string | null, billToPostalCode?: string | null, billToCountryCode?: string | null, billToMyOtherAccount?: string | null } | null, shipmentItems?: Array<{ __typename?: 'ShipStationOrderItem', orderItemId?: number | null, lineItemKey?: string | null, sku?: string | null, name?: string | null, imageUrl?: string | null, quantity?: number | null, unitPrice?: number | null, taxAmount?: number | null, shippingAmount?: number | null, warehouseLocation?: string | null, productId?: number | null, fulfillmentSku?: string | null, adjustment?: boolean | null, upc?: string | null, createDate?: string | null, modifyDate?: string | null, weight?: { __typename?: 'ShipStationWeight', value?: number | null, units?: ShipStationWeightUnit | null } | null, options?: Array<{ __typename?: 'ShipStationOrderItemOption', name?: string | null, value?: string | null } | null> | null } | null> | null } | null> | null } | null };

export type ShipStationListFulfillmentsQueryVariables = Exact<{
  filter?: InputMaybe<ShipStationFulfillmentsFilter>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<Sort>;
}>;


export type ShipStationListFulfillmentsQuery = { __typename?: 'Query', listFulfillments?: { __typename?: 'ShipStationFulfillmentPage', total?: number | null, data?: Array<{ __typename?: 'ShipStationFulfillment', id?: number | null, fulfillmentId?: number | null, orderId?: number | null, orderNumber?: string | null, userId?: string | null, customerEmail?: string | null, trackingNumber?: string | null, createDate?: string | null, shipDate?: string | null, voidDate?: string | null, deliveryDate?: string | null, carrierCode?: string | null, fulfillmentProviderCode?: string | null, fulfillmentServiceCode?: string | null, fulfillmentFee?: number | null, voidRequested?: boolean | null, voided?: boolean | null, marketplaceNotified?: boolean | null, notifyErrorMessage?: string | null, shipTo?: { __typename?: 'ShipStationAddress', name?: string | null, company?: string | null, street1?: string | null, street2?: string | null, street3?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, country?: string | null, phone?: string | null, residential?: boolean | null, addressVerified?: string | null } | null } | null> | null } | null };

export type ShipStationListProductsQueryVariables = Exact<{
  filter?: InputMaybe<ShipStationProductFilter>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<Sort>;
}>;


export type ShipStationListProductsQuery = { __typename?: 'Query', listProducts?: { __typename?: 'ShipStationProductPage', total?: number | null, data?: Array<{ __typename?: 'ShipStationProduct', id?: number | null, productId?: number | null, sku?: string | null, name?: string | null, price?: number | null, defaultCost?: number | null, length?: number | null, width?: number | null, height?: number | null, weightOz?: number | null, internalNotes?: string | null, fulfillmentSku?: string | null, createDate?: string | null, modifyDate?: string | null, active?: boolean | null, productType?: string | null, warehouseLocation?: string | null, defaultCarrierCode?: string | null, defaultServiceCode?: string | null, defaultPackageCode?: string | null, defaultIntlCarrierCode?: string | null, defaultIntlServiceCode?: string | null, defaultIntlPackageCode?: string | null, defaultConfirmation?: string | null, defaultIntlConfirmation?: string | null, customsDescription?: string | null, customsValue?: number | null, customsTariffNo?: string | null, customsCountryCode?: string | null, noCustoms?: boolean | null, productCategory?: { __typename?: 'ShipStationProductCategory', categoryId?: number | null, name?: string | null } | null, tags?: { __typename?: 'ShipStationProductTag', tagId?: number | null, name?: string | null } | null } | null> | null } | null };

export type ShipStationListTagsQueryVariables = Exact<{ [key: string]: never; }>;


export type ShipStationListTagsQuery = { __typename?: 'Query', listTags?: { __typename?: 'ShipStationTagPage', total?: number | null, data?: Array<{ __typename?: 'ShipStationTag', id?: number | null, tagId?: number | null, name?: string | null, color?: string | null } | null> | null } | null };

export type ShipStationListStoresQueryVariables = Exact<{ [key: string]: never; }>;


export type ShipStationListStoresQuery = { __typename?: 'Query', listStores?: { __typename?: 'ShipStationStorePage', total?: number | null, data?: Array<{ __typename?: 'ShipStationStore', id?: number | null, storeId?: number | null, storeName?: string | null, marketplaceId?: number | null, marketplaceName?: string | null, accountName?: string | null, email?: string | null, integrationUrl?: string | null, active?: boolean | null, companyName?: string | null, phone?: string | null, publicEmail?: string | null, website?: string | null, refreshDate?: string | null, lastRefreshAttempt?: string | null, createDate?: string | null, modifyDate?: string | null, autoRefresh?: boolean | null } | null> | null } | null };

export type ShipStationListCarriersQueryVariables = Exact<{ [key: string]: never; }>;


export type ShipStationListCarriersQuery = { __typename?: 'Query', listCarriers?: { __typename?: 'ShipStationCarrierPage', total?: number | null, data?: Array<{ __typename?: 'ShipStationCarrier', id?: string | null, name?: string | null, code?: string | null, accountNumber?: string | null, requiresFundedAccount?: boolean | null, balance?: number | null, nickname?: string | null, shippingProviderId?: number | null, primary?: boolean | null } | null> | null } | null };

export type ShipStationGetCarrierQueryVariables = Exact<{
  carrierCode: Scalars['String']['input'];
}>;


export type ShipStationGetCarrierQuery = { __typename?: 'Query', getCarrier?: { __typename?: 'ShipStationCarrier', id?: string | null, name?: string | null, code?: string | null, accountNumber?: string | null, requiresFundedAccount?: boolean | null, balance?: number | null, nickname?: string | null, shippingProviderId?: number | null, primary?: boolean | null, packages?: Array<{ __typename?: 'ShipStationCarrierPackage', carrierCode?: string | null, code?: string | null, name?: string | null, domestic?: boolean | null, international?: boolean | null } | null> | null, services?: Array<{ __typename?: 'ShipStationCarrierService', carrierCode?: string | null, code?: string | null, name?: string | null, domestic?: boolean | null, international?: boolean | null } | null> | null } | null };

export type ShipStationListWarehousesQueryVariables = Exact<{ [key: string]: never; }>;


export type ShipStationListWarehousesQuery = { __typename?: 'Query', listWarehouses?: { __typename?: 'ShipStationWarehousePage', total?: number | null, data?: Array<{ __typename?: 'ShipStationWarehouse', id?: number | null, warehouseId?: number | null, warehouseName?: string | null, createDate?: string | null, isDefault?: boolean | null, originAddress?: { __typename?: 'ShipStationAddress', name?: string | null, company?: string | null, street1?: string | null, street2?: string | null, street3?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, country?: string | null, phone?: string | null, residential?: boolean | null, addressVerified?: string | null } | null, returnAddress?: { __typename?: 'ShipStationAddress', name?: string | null, company?: string | null, street1?: string | null, street2?: string | null, street3?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, country?: string | null, phone?: string | null, residential?: boolean | null, addressVerified?: string | null } | null } | null> | null } | null };

export type AddressFragment = { __typename?: 'Address', firstName?: string | null, lastName?: string | null, country?: string | null, address?: string | null, emails?: Array<{ __typename?: 'Email', value?: string | null } | null> | null };

export type UserInfoFragment = { __typename?: 'UserInfo', lastMaphash?: string | null, xyoRedeemed?: number | null, xyoPending?: number | null, xyoRedeemPending?: number | null, xyoDropped?: number | null, xyoCollected?: number | null, xyoGifted?: number | null, xyoGeomined?: number | null, xyoSurveys?: number | null, xyoInbrainRevoked?: number | null, xyoPickedUp?: number | null, xyoGeoclaimed?: number | null, xyoHodlRewards?: number | null, xyoBossBalance?: number | null, xyoBossGifted?: number | null, xyoExpired?: number | null, xyoRestored?: number | null, xyoSweepstakes?: number | null, xyoEnabled?: boolean | null, hodlLastCollectedYYYYMMDD?: string | null, recordVersion?: number | null, remineMarker?: string | null, recentCount?: number | null, color?: string | null, referrer?: string | null, checkInDate?: any | null, created?: any | null, appVersion?: string | null, nfcScanCount?: number | null, referrerUid?: string | null, addedToDrip?: number | null, mineCountNoSentinel?: number | null, ibeacons?: Array<string | null> | null, lastMinedWithSentinelBle?: any | null, remineCount?: number | null, subscriptionInfo?: any | null, osDevMode?: boolean | null, ownerUID?: string | null, osVersion?: string | null, mineCount?: number | null, recentMarker?: string | null, mineCountSentinel?: number | null, direction?: string | null, activeSubscription?: string | null, activeSubscriptionLock?: boolean | null, subActive?: boolean | null, suspended?: string | null, ip?: string | null, lastMinedYYYYMMDD?: number | null, verifiedAddressesTotal?: number | null, sentinels?: number | null, random?: number | null, liteOk?: boolean | null, masterOk?: boolean | null, kycComplete?: boolean | null, username?: string | null, ethAddress?: string | null, nftAddress?: string | null, lastKnownAddress?: string | null, coinbaseEmail?: string | null, shipStreetAddress?: string | null, webDropsAllowed?: boolean | null, webDropsAmountMax?: number | null, webDropsQuantityMax?: number | null, lastMined?: any | null, profileImageExists?: boolean | null, profileImageUpdated?: string | null, subOrder?: string | null, customerId?: string | null, lastSync?: string | null, ssid?: string | null, os?: string | null, deviceId?: string | null, deviceIds?: Array<string | null> | null, deviceName?: string | null, speed?: number | null, appsflyerId?: string | null, didReceiveReturningUserGift?: boolean | null, driveAnalysisQualified?: boolean | null, didReceiveZendrizeDrop?: boolean | null, phoneNumber?: string | null, profileMultiplier?: number | null };

export type CustomerFragment = { __typename?: 'Customer', id: string, email?: string | null, paymentCount?: string | null, defaultPaymentInstrument?: { __typename?: 'PaymentInstrumentId', paymentCardId?: string | null } | null, primaryAddress?: { __typename?: 'Address', firstName?: string | null, lastName?: string | null, country?: string | null, address?: string | null, emails?: Array<{ __typename?: 'Email', value?: string | null } | null> | null } | null };

export type RebillyTransactionFragment = { __typename?: 'Transaction', id: string, amount?: string | null, status?: string | null, result?: string | null, createdTime?: string | null, gateway?: any | null, currency?: string | null };

export type RebillySubscriptionFragment = { __typename?: 'RebillySubscription', id: string, planType?: string | null, planId?: string | null, status?: string | null, billingStatus?: string | null, activationTime?: string | null, canceledTime?: string | null, renewalTime?: string | null, startTime?: string | null, upcomingInvoice?: { __typename?: 'Invoice', id: string, dueTime?: string | null, issuedTime?: string | null, abandonedTime?: string | null, voidedTime?: string | null, paidTime?: string | null, currency?: string | null, invoiceNumber?: number | null, customerId?: string | null, websiteId?: string | null, organizationId?: string | null, subscriptionId?: string | null, amount?: number | null, subtotalAmount?: number | null, shippingAmount?: number | null, poNumber?: number | null, notes?: string | null, discountAmount?: number | null, discounts?: any | null, taxAmount?: number | null, taxes?: any | null, autopayScheduledTime?: string | null, autopayRetryNumber?: number | null, status?: string | null, delinquentCollectionPeriod?: number | null, collectionPeriod?: number | null, createdTime?: string | null, updatedTime?: string | null, billingAddress?: { __typename?: 'Address', firstName?: string | null, lastName?: string | null, country?: string | null, address?: string | null, emails?: Array<{ __typename?: 'Email', value?: string | null } | null> | null } | null, deliveryAddress?: { __typename?: 'Address', firstName?: string | null, lastName?: string | null, country?: string | null, address?: string | null, emails?: Array<{ __typename?: 'Email', value?: string | null } | null> | null } | null, items?: Array<{ __typename?: 'InvoiceItem', id?: string | null, type?: string | null, description?: string | null, unitPrice?: number | null } | null> | null, transactions?: Array<{ __typename?: 'Transaction', id: string, amount?: string | null, status?: string | null, result?: string | null, createdTime?: string | null, gateway?: any | null, currency?: string | null } | null> | null } | null, recentInvoice?: { __typename?: 'Invoice', id: string, dueTime?: string | null, issuedTime?: string | null, abandonedTime?: string | null, voidedTime?: string | null, paidTime?: string | null, currency?: string | null, invoiceNumber?: number | null, customerId?: string | null, websiteId?: string | null, organizationId?: string | null, subscriptionId?: string | null, amount?: number | null, subtotalAmount?: number | null, shippingAmount?: number | null, poNumber?: number | null, notes?: string | null, discountAmount?: number | null, discounts?: any | null, taxAmount?: number | null, taxes?: any | null, autopayScheduledTime?: string | null, autopayRetryNumber?: number | null, status?: string | null, delinquentCollectionPeriod?: number | null, collectionPeriod?: number | null, createdTime?: string | null, updatedTime?: string | null, billingAddress?: { __typename?: 'Address', firstName?: string | null, lastName?: string | null, country?: string | null, address?: string | null, emails?: Array<{ __typename?: 'Email', value?: string | null } | null> | null } | null, deliveryAddress?: { __typename?: 'Address', firstName?: string | null, lastName?: string | null, country?: string | null, address?: string | null, emails?: Array<{ __typename?: 'Email', value?: string | null } | null> | null } | null, items?: Array<{ __typename?: 'InvoiceItem', id?: string | null, type?: string | null, description?: string | null, unitPrice?: number | null } | null> | null, transactions?: Array<{ __typename?: 'Transaction', id: string, amount?: string | null, status?: string | null, result?: string | null, createdTime?: string | null, gateway?: any | null, currency?: string | null } | null> | null } | null, initialInvoice?: { __typename?: 'Invoice', id: string, dueTime?: string | null, issuedTime?: string | null, abandonedTime?: string | null, voidedTime?: string | null, paidTime?: string | null, currency?: string | null, invoiceNumber?: number | null, customerId?: string | null, websiteId?: string | null, organizationId?: string | null, subscriptionId?: string | null, amount?: number | null, subtotalAmount?: number | null, shippingAmount?: number | null, poNumber?: number | null, notes?: string | null, discountAmount?: number | null, discounts?: any | null, taxAmount?: number | null, taxes?: any | null, autopayScheduledTime?: string | null, autopayRetryNumber?: number | null, status?: string | null, delinquentCollectionPeriod?: number | null, collectionPeriod?: number | null, createdTime?: string | null, updatedTime?: string | null, billingAddress?: { __typename?: 'Address', firstName?: string | null, lastName?: string | null, country?: string | null, address?: string | null, emails?: Array<{ __typename?: 'Email', value?: string | null } | null> | null } | null, deliveryAddress?: { __typename?: 'Address', firstName?: string | null, lastName?: string | null, country?: string | null, address?: string | null, emails?: Array<{ __typename?: 'Email', value?: string | null } | null> | null } | null, items?: Array<{ __typename?: 'InvoiceItem', id?: string | null, type?: string | null, description?: string | null, unitPrice?: number | null } | null> | null, transactions?: Array<{ __typename?: 'Transaction', id: string, amount?: string | null, status?: string | null, result?: string | null, createdTime?: string | null, gateway?: any | null, currency?: string | null } | null> | null } | null };

export type CardFragment = { __typename?: 'PaymentCard', id?: string | null, bankCountry?: string | null, last4?: string | null, expYear?: number | null, expMonth?: number | null, brand?: string | null, status?: string | null };

export type KycFragment = { __typename?: 'KycDocument', id: string, fileId?: string | null, customerId?: string | null, documentType?: string | null, status?: string | null, createdTime?: string | null, updatedTime?: string | null, processedTime?: string | null, rejectionReason?: { __typename?: 'RejectionReason', type?: string | null, message?: string | null } | null, documentMatches?: { __typename?: 'DocumentMatches', score?: number | null, data?: any | null } | null };

export type KycMaxAttemptsFragment = { __typename?: 'KycMaxAttempts', attempts?: number | null, attemptsToday?: number | null, maxAttempts?: number | null, maxAttemptsToday?: number | null };

export type InvoiceFragment = { __typename?: 'Invoice', id: string, dueTime?: string | null, issuedTime?: string | null, abandonedTime?: string | null, voidedTime?: string | null, paidTime?: string | null, currency?: string | null, invoiceNumber?: number | null, customerId?: string | null, websiteId?: string | null, organizationId?: string | null, subscriptionId?: string | null, amount?: number | null, subtotalAmount?: number | null, shippingAmount?: number | null, poNumber?: number | null, notes?: string | null, discountAmount?: number | null, discounts?: any | null, taxAmount?: number | null, taxes?: any | null, autopayScheduledTime?: string | null, autopayRetryNumber?: number | null, status?: string | null, delinquentCollectionPeriod?: number | null, collectionPeriod?: number | null, createdTime?: string | null, updatedTime?: string | null, billingAddress?: { __typename?: 'Address', firstName?: string | null, lastName?: string | null, country?: string | null, address?: string | null, emails?: Array<{ __typename?: 'Email', value?: string | null } | null> | null } | null, deliveryAddress?: { __typename?: 'Address', firstName?: string | null, lastName?: string | null, country?: string | null, address?: string | null, emails?: Array<{ __typename?: 'Email', value?: string | null } | null> | null } | null, items?: Array<{ __typename?: 'InvoiceItem', id?: string | null, type?: string | null, description?: string | null, unitPrice?: number | null } | null> | null, transactions?: Array<{ __typename?: 'Transaction', id: string, amount?: string | null, status?: string | null, result?: string | null, createdTime?: string | null, gateway?: any | null, currency?: string | null } | null> | null };

export type UserInfoPageQueryVariables = Exact<{
  filter?: InputMaybe<UserInfoFilter>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<Sort>;
}>;


export type UserInfoPageQuery = { __typename?: 'Query', userInfoPage?: { __typename?: 'UserInfoPage', total?: number | null, data?: Array<{ __typename?: 'UserInfo', lastMaphash?: string | null, xyoRedeemed?: number | null, xyoPending?: number | null, xyoRedeemPending?: number | null, xyoDropped?: number | null, xyoCollected?: number | null, xyoGifted?: number | null, xyoGeomined?: number | null, xyoSurveys?: number | null, xyoInbrainRevoked?: number | null, xyoPickedUp?: number | null, xyoGeoclaimed?: number | null, xyoHodlRewards?: number | null, xyoBossBalance?: number | null, xyoBossGifted?: number | null, xyoExpired?: number | null, xyoRestored?: number | null, xyoSweepstakes?: number | null, xyoEnabled?: boolean | null, hodlLastCollectedYYYYMMDD?: string | null, recordVersion?: number | null, remineMarker?: string | null, recentCount?: number | null, color?: string | null, referrer?: string | null, checkInDate?: any | null, created?: any | null, appVersion?: string | null, nfcScanCount?: number | null, referrerUid?: string | null, addedToDrip?: number | null, mineCountNoSentinel?: number | null, ibeacons?: Array<string | null> | null, lastMinedWithSentinelBle?: any | null, remineCount?: number | null, subscriptionInfo?: any | null, osDevMode?: boolean | null, ownerUID?: string | null, osVersion?: string | null, mineCount?: number | null, recentMarker?: string | null, mineCountSentinel?: number | null, direction?: string | null, activeSubscription?: string | null, activeSubscriptionLock?: boolean | null, subActive?: boolean | null, suspended?: string | null, ip?: string | null, lastMinedYYYYMMDD?: number | null, verifiedAddressesTotal?: number | null, sentinels?: number | null, random?: number | null, liteOk?: boolean | null, masterOk?: boolean | null, kycComplete?: boolean | null, username?: string | null, ethAddress?: string | null, nftAddress?: string | null, lastKnownAddress?: string | null, coinbaseEmail?: string | null, shipStreetAddress?: string | null, webDropsAllowed?: boolean | null, webDropsAmountMax?: number | null, webDropsQuantityMax?: number | null, lastMined?: any | null, profileImageExists?: boolean | null, profileImageUpdated?: string | null, subOrder?: string | null, customerId?: string | null, lastSync?: string | null, ssid?: string | null, os?: string | null, deviceId?: string | null, deviceIds?: Array<string | null> | null, deviceName?: string | null, speed?: number | null, appsflyerId?: string | null, didReceiveReturningUserGift?: boolean | null, driveAnalysisQualified?: boolean | null, didReceiveZendrizeDrop?: boolean | null, phoneNumber?: string | null, profileMultiplier?: number | null } | null> | null } | null };

export type AccountQueryVariables = Exact<{ [key: string]: never; }>;


export type AccountQuery = { __typename?: 'Query', account?: { __typename?: 'Account', uid?: string | null, email?: string | null, customerId?: string | null, customer?: { __typename?: 'Customer', id: string, email?: string | null, paymentCount?: string | null, mainSubscription?: { __typename?: 'RebillySubscription', id: string, planType?: string | null, planId?: string | null, status?: string | null, billingStatus?: string | null, activationTime?: string | null, canceledTime?: string | null, renewalTime?: string | null, startTime?: string | null, upcomingInvoice?: { __typename?: 'Invoice', id: string, dueTime?: string | null, issuedTime?: string | null, abandonedTime?: string | null, voidedTime?: string | null, paidTime?: string | null, currency?: string | null, invoiceNumber?: number | null, customerId?: string | null, websiteId?: string | null, organizationId?: string | null, subscriptionId?: string | null, amount?: number | null, subtotalAmount?: number | null, shippingAmount?: number | null, poNumber?: number | null, notes?: string | null, discountAmount?: number | null, discounts?: any | null, taxAmount?: number | null, taxes?: any | null, autopayScheduledTime?: string | null, autopayRetryNumber?: number | null, status?: string | null, delinquentCollectionPeriod?: number | null, collectionPeriod?: number | null, createdTime?: string | null, updatedTime?: string | null, billingAddress?: { __typename?: 'Address', firstName?: string | null, lastName?: string | null, country?: string | null, address?: string | null, emails?: Array<{ __typename?: 'Email', value?: string | null } | null> | null } | null, deliveryAddress?: { __typename?: 'Address', firstName?: string | null, lastName?: string | null, country?: string | null, address?: string | null, emails?: Array<{ __typename?: 'Email', value?: string | null } | null> | null } | null, items?: Array<{ __typename?: 'InvoiceItem', id?: string | null, type?: string | null, description?: string | null, unitPrice?: number | null } | null> | null, transactions?: Array<{ __typename?: 'Transaction', id: string, amount?: string | null, status?: string | null, result?: string | null, createdTime?: string | null, gateway?: any | null, currency?: string | null } | null> | null } | null, recentInvoice?: { __typename?: 'Invoice', id: string, dueTime?: string | null, issuedTime?: string | null, abandonedTime?: string | null, voidedTime?: string | null, paidTime?: string | null, currency?: string | null, invoiceNumber?: number | null, customerId?: string | null, websiteId?: string | null, organizationId?: string | null, subscriptionId?: string | null, amount?: number | null, subtotalAmount?: number | null, shippingAmount?: number | null, poNumber?: number | null, notes?: string | null, discountAmount?: number | null, discounts?: any | null, taxAmount?: number | null, taxes?: any | null, autopayScheduledTime?: string | null, autopayRetryNumber?: number | null, status?: string | null, delinquentCollectionPeriod?: number | null, collectionPeriod?: number | null, createdTime?: string | null, updatedTime?: string | null, billingAddress?: { __typename?: 'Address', firstName?: string | null, lastName?: string | null, country?: string | null, address?: string | null, emails?: Array<{ __typename?: 'Email', value?: string | null } | null> | null } | null, deliveryAddress?: { __typename?: 'Address', firstName?: string | null, lastName?: string | null, country?: string | null, address?: string | null, emails?: Array<{ __typename?: 'Email', value?: string | null } | null> | null } | null, items?: Array<{ __typename?: 'InvoiceItem', id?: string | null, type?: string | null, description?: string | null, unitPrice?: number | null } | null> | null, transactions?: Array<{ __typename?: 'Transaction', id: string, amount?: string | null, status?: string | null, result?: string | null, createdTime?: string | null, gateway?: any | null, currency?: string | null } | null> | null } | null, initialInvoice?: { __typename?: 'Invoice', id: string, dueTime?: string | null, issuedTime?: string | null, abandonedTime?: string | null, voidedTime?: string | null, paidTime?: string | null, currency?: string | null, invoiceNumber?: number | null, customerId?: string | null, websiteId?: string | null, organizationId?: string | null, subscriptionId?: string | null, amount?: number | null, subtotalAmount?: number | null, shippingAmount?: number | null, poNumber?: number | null, notes?: string | null, discountAmount?: number | null, discounts?: any | null, taxAmount?: number | null, taxes?: any | null, autopayScheduledTime?: string | null, autopayRetryNumber?: number | null, status?: string | null, delinquentCollectionPeriod?: number | null, collectionPeriod?: number | null, createdTime?: string | null, updatedTime?: string | null, billingAddress?: { __typename?: 'Address', firstName?: string | null, lastName?: string | null, country?: string | null, address?: string | null, emails?: Array<{ __typename?: 'Email', value?: string | null } | null> | null } | null, deliveryAddress?: { __typename?: 'Address', firstName?: string | null, lastName?: string | null, country?: string | null, address?: string | null, emails?: Array<{ __typename?: 'Email', value?: string | null } | null> | null } | null, items?: Array<{ __typename?: 'InvoiceItem', id?: string | null, type?: string | null, description?: string | null, unitPrice?: number | null } | null> | null, transactions?: Array<{ __typename?: 'Transaction', id: string, amount?: string | null, status?: string | null, result?: string | null, createdTime?: string | null, gateway?: any | null, currency?: string | null } | null> | null } | null } | null, subscriptions?: Array<{ __typename?: 'RebillySubscription', id: string, planType?: string | null, planId?: string | null, status?: string | null, billingStatus?: string | null, activationTime?: string | null, canceledTime?: string | null, renewalTime?: string | null, startTime?: string | null, upcomingInvoice?: { __typename?: 'Invoice', id: string, dueTime?: string | null, issuedTime?: string | null, abandonedTime?: string | null, voidedTime?: string | null, paidTime?: string | null, currency?: string | null, invoiceNumber?: number | null, customerId?: string | null, websiteId?: string | null, organizationId?: string | null, subscriptionId?: string | null, amount?: number | null, subtotalAmount?: number | null, shippingAmount?: number | null, poNumber?: number | null, notes?: string | null, discountAmount?: number | null, discounts?: any | null, taxAmount?: number | null, taxes?: any | null, autopayScheduledTime?: string | null, autopayRetryNumber?: number | null, status?: string | null, delinquentCollectionPeriod?: number | null, collectionPeriod?: number | null, createdTime?: string | null, updatedTime?: string | null, billingAddress?: { __typename?: 'Address', firstName?: string | null, lastName?: string | null, country?: string | null, address?: string | null, emails?: Array<{ __typename?: 'Email', value?: string | null } | null> | null } | null, deliveryAddress?: { __typename?: 'Address', firstName?: string | null, lastName?: string | null, country?: string | null, address?: string | null, emails?: Array<{ __typename?: 'Email', value?: string | null } | null> | null } | null, items?: Array<{ __typename?: 'InvoiceItem', id?: string | null, type?: string | null, description?: string | null, unitPrice?: number | null } | null> | null, transactions?: Array<{ __typename?: 'Transaction', id: string, amount?: string | null, status?: string | null, result?: string | null, createdTime?: string | null, gateway?: any | null, currency?: string | null } | null> | null } | null, recentInvoice?: { __typename?: 'Invoice', id: string, dueTime?: string | null, issuedTime?: string | null, abandonedTime?: string | null, voidedTime?: string | null, paidTime?: string | null, currency?: string | null, invoiceNumber?: number | null, customerId?: string | null, websiteId?: string | null, organizationId?: string | null, subscriptionId?: string | null, amount?: number | null, subtotalAmount?: number | null, shippingAmount?: number | null, poNumber?: number | null, notes?: string | null, discountAmount?: number | null, discounts?: any | null, taxAmount?: number | null, taxes?: any | null, autopayScheduledTime?: string | null, autopayRetryNumber?: number | null, status?: string | null, delinquentCollectionPeriod?: number | null, collectionPeriod?: number | null, createdTime?: string | null, updatedTime?: string | null, billingAddress?: { __typename?: 'Address', firstName?: string | null, lastName?: string | null, country?: string | null, address?: string | null, emails?: Array<{ __typename?: 'Email', value?: string | null } | null> | null } | null, deliveryAddress?: { __typename?: 'Address', firstName?: string | null, lastName?: string | null, country?: string | null, address?: string | null, emails?: Array<{ __typename?: 'Email', value?: string | null } | null> | null } | null, items?: Array<{ __typename?: 'InvoiceItem', id?: string | null, type?: string | null, description?: string | null, unitPrice?: number | null } | null> | null, transactions?: Array<{ __typename?: 'Transaction', id: string, amount?: string | null, status?: string | null, result?: string | null, createdTime?: string | null, gateway?: any | null, currency?: string | null } | null> | null } | null, initialInvoice?: { __typename?: 'Invoice', id: string, dueTime?: string | null, issuedTime?: string | null, abandonedTime?: string | null, voidedTime?: string | null, paidTime?: string | null, currency?: string | null, invoiceNumber?: number | null, customerId?: string | null, websiteId?: string | null, organizationId?: string | null, subscriptionId?: string | null, amount?: number | null, subtotalAmount?: number | null, shippingAmount?: number | null, poNumber?: number | null, notes?: string | null, discountAmount?: number | null, discounts?: any | null, taxAmount?: number | null, taxes?: any | null, autopayScheduledTime?: string | null, autopayRetryNumber?: number | null, status?: string | null, delinquentCollectionPeriod?: number | null, collectionPeriod?: number | null, createdTime?: string | null, updatedTime?: string | null, billingAddress?: { __typename?: 'Address', firstName?: string | null, lastName?: string | null, country?: string | null, address?: string | null, emails?: Array<{ __typename?: 'Email', value?: string | null } | null> | null } | null, deliveryAddress?: { __typename?: 'Address', firstName?: string | null, lastName?: string | null, country?: string | null, address?: string | null, emails?: Array<{ __typename?: 'Email', value?: string | null } | null> | null } | null, items?: Array<{ __typename?: 'InvoiceItem', id?: string | null, type?: string | null, description?: string | null, unitPrice?: number | null } | null> | null, transactions?: Array<{ __typename?: 'Transaction', id: string, amount?: string | null, status?: string | null, result?: string | null, createdTime?: string | null, gateway?: any | null, currency?: string | null } | null> | null } | null } | null> | null, paymentCards?: Array<{ __typename?: 'PaymentCard', id?: string | null, bankCountry?: string | null, last4?: string | null, expYear?: number | null, expMonth?: number | null, brand?: string | null, status?: string | null } | null> | null, defaultPaymentInstrument?: { __typename?: 'PaymentInstrumentId', paymentCardId?: string | null } | null, primaryAddress?: { __typename?: 'Address', firstName?: string | null, lastName?: string | null, country?: string | null, address?: string | null, emails?: Array<{ __typename?: 'Email', value?: string | null } | null> | null } | null } | null, userInfo?: { __typename?: 'UserInfo', lastMaphash?: string | null, xyoRedeemed?: number | null, xyoPending?: number | null, xyoRedeemPending?: number | null, xyoDropped?: number | null, xyoCollected?: number | null, xyoGifted?: number | null, xyoGeomined?: number | null, xyoSurveys?: number | null, xyoInbrainRevoked?: number | null, xyoPickedUp?: number | null, xyoGeoclaimed?: number | null, xyoHodlRewards?: number | null, xyoBossBalance?: number | null, xyoBossGifted?: number | null, xyoExpired?: number | null, xyoRestored?: number | null, xyoSweepstakes?: number | null, xyoEnabled?: boolean | null, hodlLastCollectedYYYYMMDD?: string | null, recordVersion?: number | null, remineMarker?: string | null, recentCount?: number | null, color?: string | null, referrer?: string | null, checkInDate?: any | null, created?: any | null, appVersion?: string | null, nfcScanCount?: number | null, referrerUid?: string | null, addedToDrip?: number | null, mineCountNoSentinel?: number | null, ibeacons?: Array<string | null> | null, lastMinedWithSentinelBle?: any | null, remineCount?: number | null, subscriptionInfo?: any | null, osDevMode?: boolean | null, ownerUID?: string | null, osVersion?: string | null, mineCount?: number | null, recentMarker?: string | null, mineCountSentinel?: number | null, direction?: string | null, activeSubscription?: string | null, activeSubscriptionLock?: boolean | null, subActive?: boolean | null, suspended?: string | null, ip?: string | null, lastMinedYYYYMMDD?: number | null, verifiedAddressesTotal?: number | null, sentinels?: number | null, random?: number | null, liteOk?: boolean | null, masterOk?: boolean | null, kycComplete?: boolean | null, username?: string | null, ethAddress?: string | null, nftAddress?: string | null, lastKnownAddress?: string | null, coinbaseEmail?: string | null, shipStreetAddress?: string | null, webDropsAllowed?: boolean | null, webDropsAmountMax?: number | null, webDropsQuantityMax?: number | null, lastMined?: any | null, profileImageExists?: boolean | null, profileImageUpdated?: string | null, subOrder?: string | null, customerId?: string | null, lastSync?: string | null, ssid?: string | null, os?: string | null, deviceId?: string | null, deviceIds?: Array<string | null> | null, deviceName?: string | null, speed?: number | null, appsflyerId?: string | null, didReceiveReturningUserGift?: boolean | null, driveAnalysisQualified?: boolean | null, didReceiveZendrizeDrop?: boolean | null, phoneNumber?: string | null, profileMultiplier?: number | null } | null } | null };

export type AccountsQueryVariables = Exact<{
  uids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  emails?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type AccountsQuery = { __typename?: 'Query', accounts?: Array<{ __typename?: 'Account', uid?: string | null, email?: string | null, customerId?: string | null, customer?: { __typename?: 'Customer', id: string, email?: string | null, paymentCount?: string | null, mainSubscription?: { __typename?: 'RebillySubscription', id: string, planType?: string | null, planId?: string | null, status?: string | null, billingStatus?: string | null, activationTime?: string | null, canceledTime?: string | null, renewalTime?: string | null, startTime?: string | null, upcomingInvoice?: { __typename?: 'Invoice', id: string, dueTime?: string | null, issuedTime?: string | null, abandonedTime?: string | null, voidedTime?: string | null, paidTime?: string | null, currency?: string | null, invoiceNumber?: number | null, customerId?: string | null, websiteId?: string | null, organizationId?: string | null, subscriptionId?: string | null, amount?: number | null, subtotalAmount?: number | null, shippingAmount?: number | null, poNumber?: number | null, notes?: string | null, discountAmount?: number | null, discounts?: any | null, taxAmount?: number | null, taxes?: any | null, autopayScheduledTime?: string | null, autopayRetryNumber?: number | null, status?: string | null, delinquentCollectionPeriod?: number | null, collectionPeriod?: number | null, createdTime?: string | null, updatedTime?: string | null, billingAddress?: { __typename?: 'Address', firstName?: string | null, lastName?: string | null, country?: string | null, address?: string | null, emails?: Array<{ __typename?: 'Email', value?: string | null } | null> | null } | null, deliveryAddress?: { __typename?: 'Address', firstName?: string | null, lastName?: string | null, country?: string | null, address?: string | null, emails?: Array<{ __typename?: 'Email', value?: string | null } | null> | null } | null, items?: Array<{ __typename?: 'InvoiceItem', id?: string | null, type?: string | null, description?: string | null, unitPrice?: number | null } | null> | null, transactions?: Array<{ __typename?: 'Transaction', id: string, amount?: string | null, status?: string | null, result?: string | null, createdTime?: string | null, gateway?: any | null, currency?: string | null } | null> | null } | null, recentInvoice?: { __typename?: 'Invoice', id: string, dueTime?: string | null, issuedTime?: string | null, abandonedTime?: string | null, voidedTime?: string | null, paidTime?: string | null, currency?: string | null, invoiceNumber?: number | null, customerId?: string | null, websiteId?: string | null, organizationId?: string | null, subscriptionId?: string | null, amount?: number | null, subtotalAmount?: number | null, shippingAmount?: number | null, poNumber?: number | null, notes?: string | null, discountAmount?: number | null, discounts?: any | null, taxAmount?: number | null, taxes?: any | null, autopayScheduledTime?: string | null, autopayRetryNumber?: number | null, status?: string | null, delinquentCollectionPeriod?: number | null, collectionPeriod?: number | null, createdTime?: string | null, updatedTime?: string | null, billingAddress?: { __typename?: 'Address', firstName?: string | null, lastName?: string | null, country?: string | null, address?: string | null, emails?: Array<{ __typename?: 'Email', value?: string | null } | null> | null } | null, deliveryAddress?: { __typename?: 'Address', firstName?: string | null, lastName?: string | null, country?: string | null, address?: string | null, emails?: Array<{ __typename?: 'Email', value?: string | null } | null> | null } | null, items?: Array<{ __typename?: 'InvoiceItem', id?: string | null, type?: string | null, description?: string | null, unitPrice?: number | null } | null> | null, transactions?: Array<{ __typename?: 'Transaction', id: string, amount?: string | null, status?: string | null, result?: string | null, createdTime?: string | null, gateway?: any | null, currency?: string | null } | null> | null } | null, initialInvoice?: { __typename?: 'Invoice', id: string, dueTime?: string | null, issuedTime?: string | null, abandonedTime?: string | null, voidedTime?: string | null, paidTime?: string | null, currency?: string | null, invoiceNumber?: number | null, customerId?: string | null, websiteId?: string | null, organizationId?: string | null, subscriptionId?: string | null, amount?: number | null, subtotalAmount?: number | null, shippingAmount?: number | null, poNumber?: number | null, notes?: string | null, discountAmount?: number | null, discounts?: any | null, taxAmount?: number | null, taxes?: any | null, autopayScheduledTime?: string | null, autopayRetryNumber?: number | null, status?: string | null, delinquentCollectionPeriod?: number | null, collectionPeriod?: number | null, createdTime?: string | null, updatedTime?: string | null, billingAddress?: { __typename?: 'Address', firstName?: string | null, lastName?: string | null, country?: string | null, address?: string | null, emails?: Array<{ __typename?: 'Email', value?: string | null } | null> | null } | null, deliveryAddress?: { __typename?: 'Address', firstName?: string | null, lastName?: string | null, country?: string | null, address?: string | null, emails?: Array<{ __typename?: 'Email', value?: string | null } | null> | null } | null, items?: Array<{ __typename?: 'InvoiceItem', id?: string | null, type?: string | null, description?: string | null, unitPrice?: number | null } | null> | null, transactions?: Array<{ __typename?: 'Transaction', id: string, amount?: string | null, status?: string | null, result?: string | null, createdTime?: string | null, gateway?: any | null, currency?: string | null } | null> | null } | null } | null, subscriptions?: Array<{ __typename?: 'RebillySubscription', id: string, planType?: string | null, planId?: string | null, status?: string | null, billingStatus?: string | null, activationTime?: string | null, canceledTime?: string | null, renewalTime?: string | null, startTime?: string | null, upcomingInvoice?: { __typename?: 'Invoice', id: string, dueTime?: string | null, issuedTime?: string | null, abandonedTime?: string | null, voidedTime?: string | null, paidTime?: string | null, currency?: string | null, invoiceNumber?: number | null, customerId?: string | null, websiteId?: string | null, organizationId?: string | null, subscriptionId?: string | null, amount?: number | null, subtotalAmount?: number | null, shippingAmount?: number | null, poNumber?: number | null, notes?: string | null, discountAmount?: number | null, discounts?: any | null, taxAmount?: number | null, taxes?: any | null, autopayScheduledTime?: string | null, autopayRetryNumber?: number | null, status?: string | null, delinquentCollectionPeriod?: number | null, collectionPeriod?: number | null, createdTime?: string | null, updatedTime?: string | null, billingAddress?: { __typename?: 'Address', firstName?: string | null, lastName?: string | null, country?: string | null, address?: string | null, emails?: Array<{ __typename?: 'Email', value?: string | null } | null> | null } | null, deliveryAddress?: { __typename?: 'Address', firstName?: string | null, lastName?: string | null, country?: string | null, address?: string | null, emails?: Array<{ __typename?: 'Email', value?: string | null } | null> | null } | null, items?: Array<{ __typename?: 'InvoiceItem', id?: string | null, type?: string | null, description?: string | null, unitPrice?: number | null } | null> | null, transactions?: Array<{ __typename?: 'Transaction', id: string, amount?: string | null, status?: string | null, result?: string | null, createdTime?: string | null, gateway?: any | null, currency?: string | null } | null> | null } | null, recentInvoice?: { __typename?: 'Invoice', id: string, dueTime?: string | null, issuedTime?: string | null, abandonedTime?: string | null, voidedTime?: string | null, paidTime?: string | null, currency?: string | null, invoiceNumber?: number | null, customerId?: string | null, websiteId?: string | null, organizationId?: string | null, subscriptionId?: string | null, amount?: number | null, subtotalAmount?: number | null, shippingAmount?: number | null, poNumber?: number | null, notes?: string | null, discountAmount?: number | null, discounts?: any | null, taxAmount?: number | null, taxes?: any | null, autopayScheduledTime?: string | null, autopayRetryNumber?: number | null, status?: string | null, delinquentCollectionPeriod?: number | null, collectionPeriod?: number | null, createdTime?: string | null, updatedTime?: string | null, billingAddress?: { __typename?: 'Address', firstName?: string | null, lastName?: string | null, country?: string | null, address?: string | null, emails?: Array<{ __typename?: 'Email', value?: string | null } | null> | null } | null, deliveryAddress?: { __typename?: 'Address', firstName?: string | null, lastName?: string | null, country?: string | null, address?: string | null, emails?: Array<{ __typename?: 'Email', value?: string | null } | null> | null } | null, items?: Array<{ __typename?: 'InvoiceItem', id?: string | null, type?: string | null, description?: string | null, unitPrice?: number | null } | null> | null, transactions?: Array<{ __typename?: 'Transaction', id: string, amount?: string | null, status?: string | null, result?: string | null, createdTime?: string | null, gateway?: any | null, currency?: string | null } | null> | null } | null, initialInvoice?: { __typename?: 'Invoice', id: string, dueTime?: string | null, issuedTime?: string | null, abandonedTime?: string | null, voidedTime?: string | null, paidTime?: string | null, currency?: string | null, invoiceNumber?: number | null, customerId?: string | null, websiteId?: string | null, organizationId?: string | null, subscriptionId?: string | null, amount?: number | null, subtotalAmount?: number | null, shippingAmount?: number | null, poNumber?: number | null, notes?: string | null, discountAmount?: number | null, discounts?: any | null, taxAmount?: number | null, taxes?: any | null, autopayScheduledTime?: string | null, autopayRetryNumber?: number | null, status?: string | null, delinquentCollectionPeriod?: number | null, collectionPeriod?: number | null, createdTime?: string | null, updatedTime?: string | null, billingAddress?: { __typename?: 'Address', firstName?: string | null, lastName?: string | null, country?: string | null, address?: string | null, emails?: Array<{ __typename?: 'Email', value?: string | null } | null> | null } | null, deliveryAddress?: { __typename?: 'Address', firstName?: string | null, lastName?: string | null, country?: string | null, address?: string | null, emails?: Array<{ __typename?: 'Email', value?: string | null } | null> | null } | null, items?: Array<{ __typename?: 'InvoiceItem', id?: string | null, type?: string | null, description?: string | null, unitPrice?: number | null } | null> | null, transactions?: Array<{ __typename?: 'Transaction', id: string, amount?: string | null, status?: string | null, result?: string | null, createdTime?: string | null, gateway?: any | null, currency?: string | null } | null> | null } | null } | null> | null, paymentCards?: Array<{ __typename?: 'PaymentCard', id?: string | null, bankCountry?: string | null, last4?: string | null, expYear?: number | null, expMonth?: number | null, brand?: string | null, status?: string | null } | null> | null, defaultPaymentInstrument?: { __typename?: 'PaymentInstrumentId', paymentCardId?: string | null } | null, primaryAddress?: { __typename?: 'Address', firstName?: string | null, lastName?: string | null, country?: string | null, address?: string | null, emails?: Array<{ __typename?: 'Email', value?: string | null } | null> | null } | null } | null, userInfo?: { __typename?: 'UserInfo', lastMaphash?: string | null, xyoRedeemed?: number | null, xyoPending?: number | null, xyoRedeemPending?: number | null, xyoDropped?: number | null, xyoCollected?: number | null, xyoGifted?: number | null, xyoGeomined?: number | null, xyoSurveys?: number | null, xyoInbrainRevoked?: number | null, xyoPickedUp?: number | null, xyoGeoclaimed?: number | null, xyoHodlRewards?: number | null, xyoBossBalance?: number | null, xyoBossGifted?: number | null, xyoExpired?: number | null, xyoRestored?: number | null, xyoSweepstakes?: number | null, xyoEnabled?: boolean | null, hodlLastCollectedYYYYMMDD?: string | null, recordVersion?: number | null, remineMarker?: string | null, recentCount?: number | null, color?: string | null, referrer?: string | null, checkInDate?: any | null, created?: any | null, appVersion?: string | null, nfcScanCount?: number | null, referrerUid?: string | null, addedToDrip?: number | null, mineCountNoSentinel?: number | null, ibeacons?: Array<string | null> | null, lastMinedWithSentinelBle?: any | null, remineCount?: number | null, subscriptionInfo?: any | null, osDevMode?: boolean | null, ownerUID?: string | null, osVersion?: string | null, mineCount?: number | null, recentMarker?: string | null, mineCountSentinel?: number | null, direction?: string | null, activeSubscription?: string | null, activeSubscriptionLock?: boolean | null, subActive?: boolean | null, suspended?: string | null, ip?: string | null, lastMinedYYYYMMDD?: number | null, verifiedAddressesTotal?: number | null, sentinels?: number | null, random?: number | null, liteOk?: boolean | null, masterOk?: boolean | null, kycComplete?: boolean | null, username?: string | null, ethAddress?: string | null, nftAddress?: string | null, lastKnownAddress?: string | null, coinbaseEmail?: string | null, shipStreetAddress?: string | null, webDropsAllowed?: boolean | null, webDropsAmountMax?: number | null, webDropsQuantityMax?: number | null, lastMined?: any | null, profileImageExists?: boolean | null, profileImageUpdated?: string | null, subOrder?: string | null, customerId?: string | null, lastSync?: string | null, ssid?: string | null, os?: string | null, deviceId?: string | null, deviceIds?: Array<string | null> | null, deviceName?: string | null, speed?: number | null, appsflyerId?: string | null, didReceiveReturningUserGift?: boolean | null, driveAnalysisQualified?: boolean | null, didReceiveZendrizeDrop?: boolean | null, phoneNumber?: string | null, profileMultiplier?: number | null } | null } | null> | null };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'Query', me?: { __typename?: 'Customer', id: string, email?: string | null, paymentCount?: string | null, mainSubscription?: { __typename?: 'RebillySubscription', id: string, planType?: string | null, planId?: string | null, status?: string | null, billingStatus?: string | null, activationTime?: string | null, canceledTime?: string | null, renewalTime?: string | null, startTime?: string | null, upcomingInvoice?: { __typename?: 'Invoice', id: string, dueTime?: string | null, issuedTime?: string | null, abandonedTime?: string | null, voidedTime?: string | null, paidTime?: string | null, currency?: string | null, invoiceNumber?: number | null, customerId?: string | null, websiteId?: string | null, organizationId?: string | null, subscriptionId?: string | null, amount?: number | null, subtotalAmount?: number | null, shippingAmount?: number | null, poNumber?: number | null, notes?: string | null, discountAmount?: number | null, discounts?: any | null, taxAmount?: number | null, taxes?: any | null, autopayScheduledTime?: string | null, autopayRetryNumber?: number | null, status?: string | null, delinquentCollectionPeriod?: number | null, collectionPeriod?: number | null, createdTime?: string | null, updatedTime?: string | null, billingAddress?: { __typename?: 'Address', firstName?: string | null, lastName?: string | null, country?: string | null, address?: string | null, emails?: Array<{ __typename?: 'Email', value?: string | null } | null> | null } | null, deliveryAddress?: { __typename?: 'Address', firstName?: string | null, lastName?: string | null, country?: string | null, address?: string | null, emails?: Array<{ __typename?: 'Email', value?: string | null } | null> | null } | null, items?: Array<{ __typename?: 'InvoiceItem', id?: string | null, type?: string | null, description?: string | null, unitPrice?: number | null } | null> | null, transactions?: Array<{ __typename?: 'Transaction', id: string, amount?: string | null, status?: string | null, result?: string | null, createdTime?: string | null, gateway?: any | null, currency?: string | null } | null> | null } | null, recentInvoice?: { __typename?: 'Invoice', id: string, dueTime?: string | null, issuedTime?: string | null, abandonedTime?: string | null, voidedTime?: string | null, paidTime?: string | null, currency?: string | null, invoiceNumber?: number | null, customerId?: string | null, websiteId?: string | null, organizationId?: string | null, subscriptionId?: string | null, amount?: number | null, subtotalAmount?: number | null, shippingAmount?: number | null, poNumber?: number | null, notes?: string | null, discountAmount?: number | null, discounts?: any | null, taxAmount?: number | null, taxes?: any | null, autopayScheduledTime?: string | null, autopayRetryNumber?: number | null, status?: string | null, delinquentCollectionPeriod?: number | null, collectionPeriod?: number | null, createdTime?: string | null, updatedTime?: string | null, billingAddress?: { __typename?: 'Address', firstName?: string | null, lastName?: string | null, country?: string | null, address?: string | null, emails?: Array<{ __typename?: 'Email', value?: string | null } | null> | null } | null, deliveryAddress?: { __typename?: 'Address', firstName?: string | null, lastName?: string | null, country?: string | null, address?: string | null, emails?: Array<{ __typename?: 'Email', value?: string | null } | null> | null } | null, items?: Array<{ __typename?: 'InvoiceItem', id?: string | null, type?: string | null, description?: string | null, unitPrice?: number | null } | null> | null, transactions?: Array<{ __typename?: 'Transaction', id: string, amount?: string | null, status?: string | null, result?: string | null, createdTime?: string | null, gateway?: any | null, currency?: string | null } | null> | null } | null, initialInvoice?: { __typename?: 'Invoice', id: string, dueTime?: string | null, issuedTime?: string | null, abandonedTime?: string | null, voidedTime?: string | null, paidTime?: string | null, currency?: string | null, invoiceNumber?: number | null, customerId?: string | null, websiteId?: string | null, organizationId?: string | null, subscriptionId?: string | null, amount?: number | null, subtotalAmount?: number | null, shippingAmount?: number | null, poNumber?: number | null, notes?: string | null, discountAmount?: number | null, discounts?: any | null, taxAmount?: number | null, taxes?: any | null, autopayScheduledTime?: string | null, autopayRetryNumber?: number | null, status?: string | null, delinquentCollectionPeriod?: number | null, collectionPeriod?: number | null, createdTime?: string | null, updatedTime?: string | null, billingAddress?: { __typename?: 'Address', firstName?: string | null, lastName?: string | null, country?: string | null, address?: string | null, emails?: Array<{ __typename?: 'Email', value?: string | null } | null> | null } | null, deliveryAddress?: { __typename?: 'Address', firstName?: string | null, lastName?: string | null, country?: string | null, address?: string | null, emails?: Array<{ __typename?: 'Email', value?: string | null } | null> | null } | null, items?: Array<{ __typename?: 'InvoiceItem', id?: string | null, type?: string | null, description?: string | null, unitPrice?: number | null } | null> | null, transactions?: Array<{ __typename?: 'Transaction', id: string, amount?: string | null, status?: string | null, result?: string | null, createdTime?: string | null, gateway?: any | null, currency?: string | null } | null> | null } | null } | null, subscriptions?: Array<{ __typename?: 'RebillySubscription', id: string, planType?: string | null, planId?: string | null, status?: string | null, billingStatus?: string | null, activationTime?: string | null, canceledTime?: string | null, renewalTime?: string | null, startTime?: string | null, upcomingInvoice?: { __typename?: 'Invoice', id: string, dueTime?: string | null, issuedTime?: string | null, abandonedTime?: string | null, voidedTime?: string | null, paidTime?: string | null, currency?: string | null, invoiceNumber?: number | null, customerId?: string | null, websiteId?: string | null, organizationId?: string | null, subscriptionId?: string | null, amount?: number | null, subtotalAmount?: number | null, shippingAmount?: number | null, poNumber?: number | null, notes?: string | null, discountAmount?: number | null, discounts?: any | null, taxAmount?: number | null, taxes?: any | null, autopayScheduledTime?: string | null, autopayRetryNumber?: number | null, status?: string | null, delinquentCollectionPeriod?: number | null, collectionPeriod?: number | null, createdTime?: string | null, updatedTime?: string | null, billingAddress?: { __typename?: 'Address', firstName?: string | null, lastName?: string | null, country?: string | null, address?: string | null, emails?: Array<{ __typename?: 'Email', value?: string | null } | null> | null } | null, deliveryAddress?: { __typename?: 'Address', firstName?: string | null, lastName?: string | null, country?: string | null, address?: string | null, emails?: Array<{ __typename?: 'Email', value?: string | null } | null> | null } | null, items?: Array<{ __typename?: 'InvoiceItem', id?: string | null, type?: string | null, description?: string | null, unitPrice?: number | null } | null> | null, transactions?: Array<{ __typename?: 'Transaction', id: string, amount?: string | null, status?: string | null, result?: string | null, createdTime?: string | null, gateway?: any | null, currency?: string | null } | null> | null } | null, recentInvoice?: { __typename?: 'Invoice', id: string, dueTime?: string | null, issuedTime?: string | null, abandonedTime?: string | null, voidedTime?: string | null, paidTime?: string | null, currency?: string | null, invoiceNumber?: number | null, customerId?: string | null, websiteId?: string | null, organizationId?: string | null, subscriptionId?: string | null, amount?: number | null, subtotalAmount?: number | null, shippingAmount?: number | null, poNumber?: number | null, notes?: string | null, discountAmount?: number | null, discounts?: any | null, taxAmount?: number | null, taxes?: any | null, autopayScheduledTime?: string | null, autopayRetryNumber?: number | null, status?: string | null, delinquentCollectionPeriod?: number | null, collectionPeriod?: number | null, createdTime?: string | null, updatedTime?: string | null, billingAddress?: { __typename?: 'Address', firstName?: string | null, lastName?: string | null, country?: string | null, address?: string | null, emails?: Array<{ __typename?: 'Email', value?: string | null } | null> | null } | null, deliveryAddress?: { __typename?: 'Address', firstName?: string | null, lastName?: string | null, country?: string | null, address?: string | null, emails?: Array<{ __typename?: 'Email', value?: string | null } | null> | null } | null, items?: Array<{ __typename?: 'InvoiceItem', id?: string | null, type?: string | null, description?: string | null, unitPrice?: number | null } | null> | null, transactions?: Array<{ __typename?: 'Transaction', id: string, amount?: string | null, status?: string | null, result?: string | null, createdTime?: string | null, gateway?: any | null, currency?: string | null } | null> | null } | null, initialInvoice?: { __typename?: 'Invoice', id: string, dueTime?: string | null, issuedTime?: string | null, abandonedTime?: string | null, voidedTime?: string | null, paidTime?: string | null, currency?: string | null, invoiceNumber?: number | null, customerId?: string | null, websiteId?: string | null, organizationId?: string | null, subscriptionId?: string | null, amount?: number | null, subtotalAmount?: number | null, shippingAmount?: number | null, poNumber?: number | null, notes?: string | null, discountAmount?: number | null, discounts?: any | null, taxAmount?: number | null, taxes?: any | null, autopayScheduledTime?: string | null, autopayRetryNumber?: number | null, status?: string | null, delinquentCollectionPeriod?: number | null, collectionPeriod?: number | null, createdTime?: string | null, updatedTime?: string | null, billingAddress?: { __typename?: 'Address', firstName?: string | null, lastName?: string | null, country?: string | null, address?: string | null, emails?: Array<{ __typename?: 'Email', value?: string | null } | null> | null } | null, deliveryAddress?: { __typename?: 'Address', firstName?: string | null, lastName?: string | null, country?: string | null, address?: string | null, emails?: Array<{ __typename?: 'Email', value?: string | null } | null> | null } | null, items?: Array<{ __typename?: 'InvoiceItem', id?: string | null, type?: string | null, description?: string | null, unitPrice?: number | null } | null> | null, transactions?: Array<{ __typename?: 'Transaction', id: string, amount?: string | null, status?: string | null, result?: string | null, createdTime?: string | null, gateway?: any | null, currency?: string | null } | null> | null } | null } | null> | null, paymentCards?: Array<{ __typename?: 'PaymentCard', id?: string | null, bankCountry?: string | null, last4?: string | null, expYear?: number | null, expMonth?: number | null, brand?: string | null, status?: string | null } | null> | null, userInfo?: { __typename?: 'UserInfo', lastMaphash?: string | null, xyoRedeemed?: number | null, xyoPending?: number | null, xyoRedeemPending?: number | null, xyoDropped?: number | null, xyoCollected?: number | null, xyoGifted?: number | null, xyoGeomined?: number | null, xyoSurveys?: number | null, xyoInbrainRevoked?: number | null, xyoPickedUp?: number | null, xyoGeoclaimed?: number | null, xyoHodlRewards?: number | null, xyoBossBalance?: number | null, xyoBossGifted?: number | null, xyoExpired?: number | null, xyoRestored?: number | null, xyoSweepstakes?: number | null, xyoEnabled?: boolean | null, hodlLastCollectedYYYYMMDD?: string | null, recordVersion?: number | null, remineMarker?: string | null, recentCount?: number | null, color?: string | null, referrer?: string | null, checkInDate?: any | null, created?: any | null, appVersion?: string | null, nfcScanCount?: number | null, referrerUid?: string | null, addedToDrip?: number | null, mineCountNoSentinel?: number | null, ibeacons?: Array<string | null> | null, lastMinedWithSentinelBle?: any | null, remineCount?: number | null, subscriptionInfo?: any | null, osDevMode?: boolean | null, ownerUID?: string | null, osVersion?: string | null, mineCount?: number | null, recentMarker?: string | null, mineCountSentinel?: number | null, direction?: string | null, activeSubscription?: string | null, activeSubscriptionLock?: boolean | null, subActive?: boolean | null, suspended?: string | null, ip?: string | null, lastMinedYYYYMMDD?: number | null, verifiedAddressesTotal?: number | null, sentinels?: number | null, random?: number | null, liteOk?: boolean | null, masterOk?: boolean | null, kycComplete?: boolean | null, username?: string | null, ethAddress?: string | null, nftAddress?: string | null, lastKnownAddress?: string | null, coinbaseEmail?: string | null, shipStreetAddress?: string | null, webDropsAllowed?: boolean | null, webDropsAmountMax?: number | null, webDropsQuantityMax?: number | null, lastMined?: any | null, profileImageExists?: boolean | null, profileImageUpdated?: string | null, subOrder?: string | null, customerId?: string | null, lastSync?: string | null, ssid?: string | null, os?: string | null, deviceId?: string | null, deviceIds?: Array<string | null> | null, deviceName?: string | null, speed?: number | null, appsflyerId?: string | null, didReceiveReturningUserGift?: boolean | null, driveAnalysisQualified?: boolean | null, didReceiveZendrizeDrop?: boolean | null, phoneNumber?: string | null, profileMultiplier?: number | null } | null, defaultPaymentInstrument?: { __typename?: 'PaymentInstrumentId', paymentCardId?: string | null } | null, primaryAddress?: { __typename?: 'Address', firstName?: string | null, lastName?: string | null, country?: string | null, address?: string | null, emails?: Array<{ __typename?: 'Email', value?: string | null } | null> | null } | null } | null };

export type KycQueryVariables = Exact<{ [key: string]: never; }>;


export type KycQuery = { __typename?: 'Query', me?: { __typename?: 'Customer', id: string, firstName?: string | null, lastName?: string | null, kycDocuments?: Array<{ __typename?: 'KycDocument', id: string, fileId?: string | null, customerId?: string | null, documentType?: string | null, status?: string | null, createdTime?: string | null, updatedTime?: string | null, processedTime?: string | null, rejectionReason?: { __typename?: 'RejectionReason', type?: string | null, message?: string | null } | null, documentMatches?: { __typename?: 'DocumentMatches', score?: number | null, data?: any | null } | null } | null> | null, kycMaxAttempts?: { __typename?: 'KycMaxAttempts', attempts?: number | null, attemptsToday?: number | null, maxAttempts?: number | null, maxAttemptsToday?: number | null } | null } | null };

export type KycByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type KycByIdQuery = { __typename?: 'Query', kycDocumentById?: { __typename?: 'KycDocument', download?: any | null, id: string, fileId?: string | null, customerId?: string | null, documentType?: string | null, status?: string | null, createdTime?: string | null, updatedTime?: string | null, processedTime?: string | null, rejectionReason?: { __typename?: 'RejectionReason', type?: string | null, message?: string | null } | null, documentMatches?: { __typename?: 'DocumentMatches', score?: number | null, data?: any | null } | null } | null };

export type CreateKycMutationVariables = Exact<{
  input: KycDocumentInput;
}>;


export type CreateKycMutation = { __typename?: 'Mutation', createKycDocument?: { __typename?: 'KycDocumentResult', customerId?: string | null, kycDocument?: { __typename?: 'KycDocument', id: string, fileId?: string | null, customerId?: string | null, documentType?: string | null, status?: string | null, createdTime?: string | null, updatedTime?: string | null, processedTime?: string | null, rejectionReason?: { __typename?: 'RejectionReason', type?: string | null, message?: string | null } | null, documentMatches?: { __typename?: 'DocumentMatches', score?: number | null, data?: any | null } | null } | null, kycMaxAttempts?: { __typename?: 'KycMaxAttempts', attempts?: number | null, attemptsToday?: number | null, maxAttempts?: number | null, maxAttemptsToday?: number | null } | null } | null };

export type UpdateKycMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: KycDocumentInput;
}>;


export type UpdateKycMutation = { __typename?: 'Mutation', updateKycDocument?: { __typename?: 'KycDocumentResult', customerId?: string | null, kycDocument?: { __typename?: 'KycDocument', id: string, fileId?: string | null, customerId?: string | null, documentType?: string | null, status?: string | null, createdTime?: string | null, updatedTime?: string | null, processedTime?: string | null, rejectionReason?: { __typename?: 'RejectionReason', type?: string | null, message?: string | null } | null, documentMatches?: { __typename?: 'DocumentMatches', score?: number | null, data?: any | null } | null } | null, kycMaxAttempts?: { __typename?: 'KycMaxAttempts', attempts?: number | null, attemptsToday?: number | null, maxAttempts?: number | null, maxAttemptsToday?: number | null } | null } | null };

export type AcceptKycMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type AcceptKycMutation = { __typename?: 'Mutation', acceptKycDocument?: { __typename?: 'KycDocument', id: string, fileId?: string | null, customerId?: string | null, documentType?: string | null, status?: string | null, createdTime?: string | null, updatedTime?: string | null, processedTime?: string | null, rejectionReason?: { __typename?: 'RejectionReason', type?: string | null, message?: string | null } | null, documentMatches?: { __typename?: 'DocumentMatches', score?: number | null, data?: any | null } | null } | null };

export type RejectKycMutationVariables = Exact<{
  id: Scalars['String']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
}>;


export type RejectKycMutation = { __typename?: 'Mutation', rejectKycDocument?: { __typename?: 'KycDocument', id: string, fileId?: string | null, customerId?: string | null, documentType?: string | null, status?: string | null, createdTime?: string | null, updatedTime?: string | null, processedTime?: string | null, rejectionReason?: { __typename?: 'RejectionReason', type?: string | null, message?: string | null } | null, documentMatches?: { __typename?: 'DocumentMatches', score?: number | null, data?: any | null } | null } | null };

export type CustomerProfileQueryVariables = Exact<{
  uid: Scalars['String']['input'];
}>;


export type CustomerProfileQuery = { __typename?: 'Query', customerProfileByUid?: { __typename?: 'Profile', uid?: string | null, email?: string | null, photoURL?: string | null } | null };

export type CustomerQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
}>;


export type CustomerQuery = { __typename?: 'Query', customer?: { __typename?: 'Customer', id: string, email?: string | null, paymentCount?: string | null, mainSubscription?: { __typename?: 'RebillySubscription', id: string, planType?: string | null, planId?: string | null, status?: string | null, billingStatus?: string | null, activationTime?: string | null, canceledTime?: string | null, renewalTime?: string | null, startTime?: string | null, upcomingInvoice?: { __typename?: 'Invoice', id: string, dueTime?: string | null, issuedTime?: string | null, abandonedTime?: string | null, voidedTime?: string | null, paidTime?: string | null, currency?: string | null, invoiceNumber?: number | null, customerId?: string | null, websiteId?: string | null, organizationId?: string | null, subscriptionId?: string | null, amount?: number | null, subtotalAmount?: number | null, shippingAmount?: number | null, poNumber?: number | null, notes?: string | null, discountAmount?: number | null, discounts?: any | null, taxAmount?: number | null, taxes?: any | null, autopayScheduledTime?: string | null, autopayRetryNumber?: number | null, status?: string | null, delinquentCollectionPeriod?: number | null, collectionPeriod?: number | null, createdTime?: string | null, updatedTime?: string | null, billingAddress?: { __typename?: 'Address', firstName?: string | null, lastName?: string | null, country?: string | null, address?: string | null, emails?: Array<{ __typename?: 'Email', value?: string | null } | null> | null } | null, deliveryAddress?: { __typename?: 'Address', firstName?: string | null, lastName?: string | null, country?: string | null, address?: string | null, emails?: Array<{ __typename?: 'Email', value?: string | null } | null> | null } | null, items?: Array<{ __typename?: 'InvoiceItem', id?: string | null, type?: string | null, description?: string | null, unitPrice?: number | null } | null> | null, transactions?: Array<{ __typename?: 'Transaction', id: string, amount?: string | null, status?: string | null, result?: string | null, createdTime?: string | null, gateway?: any | null, currency?: string | null } | null> | null } | null, recentInvoice?: { __typename?: 'Invoice', id: string, dueTime?: string | null, issuedTime?: string | null, abandonedTime?: string | null, voidedTime?: string | null, paidTime?: string | null, currency?: string | null, invoiceNumber?: number | null, customerId?: string | null, websiteId?: string | null, organizationId?: string | null, subscriptionId?: string | null, amount?: number | null, subtotalAmount?: number | null, shippingAmount?: number | null, poNumber?: number | null, notes?: string | null, discountAmount?: number | null, discounts?: any | null, taxAmount?: number | null, taxes?: any | null, autopayScheduledTime?: string | null, autopayRetryNumber?: number | null, status?: string | null, delinquentCollectionPeriod?: number | null, collectionPeriod?: number | null, createdTime?: string | null, updatedTime?: string | null, billingAddress?: { __typename?: 'Address', firstName?: string | null, lastName?: string | null, country?: string | null, address?: string | null, emails?: Array<{ __typename?: 'Email', value?: string | null } | null> | null } | null, deliveryAddress?: { __typename?: 'Address', firstName?: string | null, lastName?: string | null, country?: string | null, address?: string | null, emails?: Array<{ __typename?: 'Email', value?: string | null } | null> | null } | null, items?: Array<{ __typename?: 'InvoiceItem', id?: string | null, type?: string | null, description?: string | null, unitPrice?: number | null } | null> | null, transactions?: Array<{ __typename?: 'Transaction', id: string, amount?: string | null, status?: string | null, result?: string | null, createdTime?: string | null, gateway?: any | null, currency?: string | null } | null> | null } | null, initialInvoice?: { __typename?: 'Invoice', id: string, dueTime?: string | null, issuedTime?: string | null, abandonedTime?: string | null, voidedTime?: string | null, paidTime?: string | null, currency?: string | null, invoiceNumber?: number | null, customerId?: string | null, websiteId?: string | null, organizationId?: string | null, subscriptionId?: string | null, amount?: number | null, subtotalAmount?: number | null, shippingAmount?: number | null, poNumber?: number | null, notes?: string | null, discountAmount?: number | null, discounts?: any | null, taxAmount?: number | null, taxes?: any | null, autopayScheduledTime?: string | null, autopayRetryNumber?: number | null, status?: string | null, delinquentCollectionPeriod?: number | null, collectionPeriod?: number | null, createdTime?: string | null, updatedTime?: string | null, billingAddress?: { __typename?: 'Address', firstName?: string | null, lastName?: string | null, country?: string | null, address?: string | null, emails?: Array<{ __typename?: 'Email', value?: string | null } | null> | null } | null, deliveryAddress?: { __typename?: 'Address', firstName?: string | null, lastName?: string | null, country?: string | null, address?: string | null, emails?: Array<{ __typename?: 'Email', value?: string | null } | null> | null } | null, items?: Array<{ __typename?: 'InvoiceItem', id?: string | null, type?: string | null, description?: string | null, unitPrice?: number | null } | null> | null, transactions?: Array<{ __typename?: 'Transaction', id: string, amount?: string | null, status?: string | null, result?: string | null, createdTime?: string | null, gateway?: any | null, currency?: string | null } | null> | null } | null } | null, subscriptions?: Array<{ __typename?: 'RebillySubscription', id: string, planType?: string | null, planId?: string | null, status?: string | null, billingStatus?: string | null, activationTime?: string | null, canceledTime?: string | null, renewalTime?: string | null, startTime?: string | null, upcomingInvoice?: { __typename?: 'Invoice', id: string, dueTime?: string | null, issuedTime?: string | null, abandonedTime?: string | null, voidedTime?: string | null, paidTime?: string | null, currency?: string | null, invoiceNumber?: number | null, customerId?: string | null, websiteId?: string | null, organizationId?: string | null, subscriptionId?: string | null, amount?: number | null, subtotalAmount?: number | null, shippingAmount?: number | null, poNumber?: number | null, notes?: string | null, discountAmount?: number | null, discounts?: any | null, taxAmount?: number | null, taxes?: any | null, autopayScheduledTime?: string | null, autopayRetryNumber?: number | null, status?: string | null, delinquentCollectionPeriod?: number | null, collectionPeriod?: number | null, createdTime?: string | null, updatedTime?: string | null, billingAddress?: { __typename?: 'Address', firstName?: string | null, lastName?: string | null, country?: string | null, address?: string | null, emails?: Array<{ __typename?: 'Email', value?: string | null } | null> | null } | null, deliveryAddress?: { __typename?: 'Address', firstName?: string | null, lastName?: string | null, country?: string | null, address?: string | null, emails?: Array<{ __typename?: 'Email', value?: string | null } | null> | null } | null, items?: Array<{ __typename?: 'InvoiceItem', id?: string | null, type?: string | null, description?: string | null, unitPrice?: number | null } | null> | null, transactions?: Array<{ __typename?: 'Transaction', id: string, amount?: string | null, status?: string | null, result?: string | null, createdTime?: string | null, gateway?: any | null, currency?: string | null } | null> | null } | null, recentInvoice?: { __typename?: 'Invoice', id: string, dueTime?: string | null, issuedTime?: string | null, abandonedTime?: string | null, voidedTime?: string | null, paidTime?: string | null, currency?: string | null, invoiceNumber?: number | null, customerId?: string | null, websiteId?: string | null, organizationId?: string | null, subscriptionId?: string | null, amount?: number | null, subtotalAmount?: number | null, shippingAmount?: number | null, poNumber?: number | null, notes?: string | null, discountAmount?: number | null, discounts?: any | null, taxAmount?: number | null, taxes?: any | null, autopayScheduledTime?: string | null, autopayRetryNumber?: number | null, status?: string | null, delinquentCollectionPeriod?: number | null, collectionPeriod?: number | null, createdTime?: string | null, updatedTime?: string | null, billingAddress?: { __typename?: 'Address', firstName?: string | null, lastName?: string | null, country?: string | null, address?: string | null, emails?: Array<{ __typename?: 'Email', value?: string | null } | null> | null } | null, deliveryAddress?: { __typename?: 'Address', firstName?: string | null, lastName?: string | null, country?: string | null, address?: string | null, emails?: Array<{ __typename?: 'Email', value?: string | null } | null> | null } | null, items?: Array<{ __typename?: 'InvoiceItem', id?: string | null, type?: string | null, description?: string | null, unitPrice?: number | null } | null> | null, transactions?: Array<{ __typename?: 'Transaction', id: string, amount?: string | null, status?: string | null, result?: string | null, createdTime?: string | null, gateway?: any | null, currency?: string | null } | null> | null } | null, initialInvoice?: { __typename?: 'Invoice', id: string, dueTime?: string | null, issuedTime?: string | null, abandonedTime?: string | null, voidedTime?: string | null, paidTime?: string | null, currency?: string | null, invoiceNumber?: number | null, customerId?: string | null, websiteId?: string | null, organizationId?: string | null, subscriptionId?: string | null, amount?: number | null, subtotalAmount?: number | null, shippingAmount?: number | null, poNumber?: number | null, notes?: string | null, discountAmount?: number | null, discounts?: any | null, taxAmount?: number | null, taxes?: any | null, autopayScheduledTime?: string | null, autopayRetryNumber?: number | null, status?: string | null, delinquentCollectionPeriod?: number | null, collectionPeriod?: number | null, createdTime?: string | null, updatedTime?: string | null, billingAddress?: { __typename?: 'Address', firstName?: string | null, lastName?: string | null, country?: string | null, address?: string | null, emails?: Array<{ __typename?: 'Email', value?: string | null } | null> | null } | null, deliveryAddress?: { __typename?: 'Address', firstName?: string | null, lastName?: string | null, country?: string | null, address?: string | null, emails?: Array<{ __typename?: 'Email', value?: string | null } | null> | null } | null, items?: Array<{ __typename?: 'InvoiceItem', id?: string | null, type?: string | null, description?: string | null, unitPrice?: number | null } | null> | null, transactions?: Array<{ __typename?: 'Transaction', id: string, amount?: string | null, status?: string | null, result?: string | null, createdTime?: string | null, gateway?: any | null, currency?: string | null } | null> | null } | null } | null> | null, pastSubscriptions?: Array<{ __typename?: 'RebillySubscription', id: string, planType?: string | null, planId?: string | null, status?: string | null, billingStatus?: string | null, activationTime?: string | null, canceledTime?: string | null, renewalTime?: string | null, startTime?: string | null, upcomingInvoice?: { __typename?: 'Invoice', id: string, dueTime?: string | null, issuedTime?: string | null, abandonedTime?: string | null, voidedTime?: string | null, paidTime?: string | null, currency?: string | null, invoiceNumber?: number | null, customerId?: string | null, websiteId?: string | null, organizationId?: string | null, subscriptionId?: string | null, amount?: number | null, subtotalAmount?: number | null, shippingAmount?: number | null, poNumber?: number | null, notes?: string | null, discountAmount?: number | null, discounts?: any | null, taxAmount?: number | null, taxes?: any | null, autopayScheduledTime?: string | null, autopayRetryNumber?: number | null, status?: string | null, delinquentCollectionPeriod?: number | null, collectionPeriod?: number | null, createdTime?: string | null, updatedTime?: string | null, billingAddress?: { __typename?: 'Address', firstName?: string | null, lastName?: string | null, country?: string | null, address?: string | null, emails?: Array<{ __typename?: 'Email', value?: string | null } | null> | null } | null, deliveryAddress?: { __typename?: 'Address', firstName?: string | null, lastName?: string | null, country?: string | null, address?: string | null, emails?: Array<{ __typename?: 'Email', value?: string | null } | null> | null } | null, items?: Array<{ __typename?: 'InvoiceItem', id?: string | null, type?: string | null, description?: string | null, unitPrice?: number | null } | null> | null, transactions?: Array<{ __typename?: 'Transaction', id: string, amount?: string | null, status?: string | null, result?: string | null, createdTime?: string | null, gateway?: any | null, currency?: string | null } | null> | null } | null, recentInvoice?: { __typename?: 'Invoice', id: string, dueTime?: string | null, issuedTime?: string | null, abandonedTime?: string | null, voidedTime?: string | null, paidTime?: string | null, currency?: string | null, invoiceNumber?: number | null, customerId?: string | null, websiteId?: string | null, organizationId?: string | null, subscriptionId?: string | null, amount?: number | null, subtotalAmount?: number | null, shippingAmount?: number | null, poNumber?: number | null, notes?: string | null, discountAmount?: number | null, discounts?: any | null, taxAmount?: number | null, taxes?: any | null, autopayScheduledTime?: string | null, autopayRetryNumber?: number | null, status?: string | null, delinquentCollectionPeriod?: number | null, collectionPeriod?: number | null, createdTime?: string | null, updatedTime?: string | null, billingAddress?: { __typename?: 'Address', firstName?: string | null, lastName?: string | null, country?: string | null, address?: string | null, emails?: Array<{ __typename?: 'Email', value?: string | null } | null> | null } | null, deliveryAddress?: { __typename?: 'Address', firstName?: string | null, lastName?: string | null, country?: string | null, address?: string | null, emails?: Array<{ __typename?: 'Email', value?: string | null } | null> | null } | null, items?: Array<{ __typename?: 'InvoiceItem', id?: string | null, type?: string | null, description?: string | null, unitPrice?: number | null } | null> | null, transactions?: Array<{ __typename?: 'Transaction', id: string, amount?: string | null, status?: string | null, result?: string | null, createdTime?: string | null, gateway?: any | null, currency?: string | null } | null> | null } | null, initialInvoice?: { __typename?: 'Invoice', id: string, dueTime?: string | null, issuedTime?: string | null, abandonedTime?: string | null, voidedTime?: string | null, paidTime?: string | null, currency?: string | null, invoiceNumber?: number | null, customerId?: string | null, websiteId?: string | null, organizationId?: string | null, subscriptionId?: string | null, amount?: number | null, subtotalAmount?: number | null, shippingAmount?: number | null, poNumber?: number | null, notes?: string | null, discountAmount?: number | null, discounts?: any | null, taxAmount?: number | null, taxes?: any | null, autopayScheduledTime?: string | null, autopayRetryNumber?: number | null, status?: string | null, delinquentCollectionPeriod?: number | null, collectionPeriod?: number | null, createdTime?: string | null, updatedTime?: string | null, billingAddress?: { __typename?: 'Address', firstName?: string | null, lastName?: string | null, country?: string | null, address?: string | null, emails?: Array<{ __typename?: 'Email', value?: string | null } | null> | null } | null, deliveryAddress?: { __typename?: 'Address', firstName?: string | null, lastName?: string | null, country?: string | null, address?: string | null, emails?: Array<{ __typename?: 'Email', value?: string | null } | null> | null } | null, items?: Array<{ __typename?: 'InvoiceItem', id?: string | null, type?: string | null, description?: string | null, unitPrice?: number | null } | null> | null, transactions?: Array<{ __typename?: 'Transaction', id: string, amount?: string | null, status?: string | null, result?: string | null, createdTime?: string | null, gateway?: any | null, currency?: string | null } | null> | null } | null } | null> | null, paymentCards?: Array<{ __typename?: 'PaymentCard', id?: string | null, bankCountry?: string | null, last4?: string | null, expYear?: number | null, expMonth?: number | null, brand?: string | null, status?: string | null } | null> | null, defaultPaymentInstrument?: { __typename?: 'PaymentInstrumentId', paymentCardId?: string | null } | null, primaryAddress?: { __typename?: 'Address', firstName?: string | null, lastName?: string | null, country?: string | null, address?: string | null, emails?: Array<{ __typename?: 'Email', value?: string | null } | null> | null } | null } | null };

export type PlansQueryVariables = Exact<{ [key: string]: never; }>;


export type PlansQuery = { __typename?: 'Query', plans?: Array<{ __typename?: 'Plan', id: string } | null> | null };

export type InvoiceQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type InvoiceQuery = { __typename?: 'Query', invoice?: { __typename?: 'Invoice', id: string, dueTime?: string | null, issuedTime?: string | null, abandonedTime?: string | null, voidedTime?: string | null, paidTime?: string | null, currency?: string | null, invoiceNumber?: number | null, customerId?: string | null, websiteId?: string | null, organizationId?: string | null, subscriptionId?: string | null, amount?: number | null, subtotalAmount?: number | null, shippingAmount?: number | null, poNumber?: number | null, notes?: string | null, discountAmount?: number | null, discounts?: any | null, taxAmount?: number | null, taxes?: any | null, autopayScheduledTime?: string | null, autopayRetryNumber?: number | null, status?: string | null, delinquentCollectionPeriod?: number | null, collectionPeriod?: number | null, createdTime?: string | null, updatedTime?: string | null, billingAddress?: { __typename?: 'Address', firstName?: string | null, lastName?: string | null, country?: string | null, address?: string | null, emails?: Array<{ __typename?: 'Email', value?: string | null } | null> | null } | null, deliveryAddress?: { __typename?: 'Address', firstName?: string | null, lastName?: string | null, country?: string | null, address?: string | null, emails?: Array<{ __typename?: 'Email', value?: string | null } | null> | null } | null, items?: Array<{ __typename?: 'InvoiceItem', id?: string | null, type?: string | null, description?: string | null, unitPrice?: number | null } | null> | null, transactions?: Array<{ __typename?: 'Transaction', id: string, amount?: string | null, status?: string | null, result?: string | null, createdTime?: string | null, gateway?: any | null, currency?: string | null } | null> | null } | null };

export type CheckoutMutationVariables = Exact<{
  planId: Scalars['String']['input'];
  paymentCardId: Scalars['String']['input'];
  customer?: InputMaybe<CustomerInput>;
  shipping?: InputMaybe<AddressInput>;
  billing?: InputMaybe<AddressInput>;
  customJson?: InputMaybe<Scalars['JSON']['input']>;
  stickyGatewayId?: InputMaybe<Scalars['String']['input']>;
}>;


export type CheckoutMutation = { __typename?: 'Mutation', checkout: { __typename?: 'CheckoutResponse', transaction?: { __typename?: 'Transaction', id: string, amount?: string | null, status?: string | null, result?: string | null } | null, customer?: { __typename?: 'Customer', id: string, email?: string | null, paymentCount?: string | null, mainSubscription?: { __typename?: 'RebillySubscription', id: string, planType?: string | null, planId?: string | null, status?: string | null, billingStatus?: string | null, activationTime?: string | null, canceledTime?: string | null, renewalTime?: string | null, startTime?: string | null, upcomingInvoice?: { __typename?: 'Invoice', id: string, dueTime?: string | null, issuedTime?: string | null, abandonedTime?: string | null, voidedTime?: string | null, paidTime?: string | null, currency?: string | null, invoiceNumber?: number | null, customerId?: string | null, websiteId?: string | null, organizationId?: string | null, subscriptionId?: string | null, amount?: number | null, subtotalAmount?: number | null, shippingAmount?: number | null, poNumber?: number | null, notes?: string | null, discountAmount?: number | null, discounts?: any | null, taxAmount?: number | null, taxes?: any | null, autopayScheduledTime?: string | null, autopayRetryNumber?: number | null, status?: string | null, delinquentCollectionPeriod?: number | null, collectionPeriod?: number | null, createdTime?: string | null, updatedTime?: string | null, billingAddress?: { __typename?: 'Address', firstName?: string | null, lastName?: string | null, country?: string | null, address?: string | null, emails?: Array<{ __typename?: 'Email', value?: string | null } | null> | null } | null, deliveryAddress?: { __typename?: 'Address', firstName?: string | null, lastName?: string | null, country?: string | null, address?: string | null, emails?: Array<{ __typename?: 'Email', value?: string | null } | null> | null } | null, items?: Array<{ __typename?: 'InvoiceItem', id?: string | null, type?: string | null, description?: string | null, unitPrice?: number | null } | null> | null, transactions?: Array<{ __typename?: 'Transaction', id: string, amount?: string | null, status?: string | null, result?: string | null, createdTime?: string | null, gateway?: any | null, currency?: string | null } | null> | null } | null, recentInvoice?: { __typename?: 'Invoice', id: string, dueTime?: string | null, issuedTime?: string | null, abandonedTime?: string | null, voidedTime?: string | null, paidTime?: string | null, currency?: string | null, invoiceNumber?: number | null, customerId?: string | null, websiteId?: string | null, organizationId?: string | null, subscriptionId?: string | null, amount?: number | null, subtotalAmount?: number | null, shippingAmount?: number | null, poNumber?: number | null, notes?: string | null, discountAmount?: number | null, discounts?: any | null, taxAmount?: number | null, taxes?: any | null, autopayScheduledTime?: string | null, autopayRetryNumber?: number | null, status?: string | null, delinquentCollectionPeriod?: number | null, collectionPeriod?: number | null, createdTime?: string | null, updatedTime?: string | null, billingAddress?: { __typename?: 'Address', firstName?: string | null, lastName?: string | null, country?: string | null, address?: string | null, emails?: Array<{ __typename?: 'Email', value?: string | null } | null> | null } | null, deliveryAddress?: { __typename?: 'Address', firstName?: string | null, lastName?: string | null, country?: string | null, address?: string | null, emails?: Array<{ __typename?: 'Email', value?: string | null } | null> | null } | null, items?: Array<{ __typename?: 'InvoiceItem', id?: string | null, type?: string | null, description?: string | null, unitPrice?: number | null } | null> | null, transactions?: Array<{ __typename?: 'Transaction', id: string, amount?: string | null, status?: string | null, result?: string | null, createdTime?: string | null, gateway?: any | null, currency?: string | null } | null> | null } | null, initialInvoice?: { __typename?: 'Invoice', id: string, dueTime?: string | null, issuedTime?: string | null, abandonedTime?: string | null, voidedTime?: string | null, paidTime?: string | null, currency?: string | null, invoiceNumber?: number | null, customerId?: string | null, websiteId?: string | null, organizationId?: string | null, subscriptionId?: string | null, amount?: number | null, subtotalAmount?: number | null, shippingAmount?: number | null, poNumber?: number | null, notes?: string | null, discountAmount?: number | null, discounts?: any | null, taxAmount?: number | null, taxes?: any | null, autopayScheduledTime?: string | null, autopayRetryNumber?: number | null, status?: string | null, delinquentCollectionPeriod?: number | null, collectionPeriod?: number | null, createdTime?: string | null, updatedTime?: string | null, billingAddress?: { __typename?: 'Address', firstName?: string | null, lastName?: string | null, country?: string | null, address?: string | null, emails?: Array<{ __typename?: 'Email', value?: string | null } | null> | null } | null, deliveryAddress?: { __typename?: 'Address', firstName?: string | null, lastName?: string | null, country?: string | null, address?: string | null, emails?: Array<{ __typename?: 'Email', value?: string | null } | null> | null } | null, items?: Array<{ __typename?: 'InvoiceItem', id?: string | null, type?: string | null, description?: string | null, unitPrice?: number | null } | null> | null, transactions?: Array<{ __typename?: 'Transaction', id: string, amount?: string | null, status?: string | null, result?: string | null, createdTime?: string | null, gateway?: any | null, currency?: string | null } | null> | null } | null } | null, subscriptions?: Array<{ __typename?: 'RebillySubscription', id: string, planType?: string | null, planId?: string | null, status?: string | null, billingStatus?: string | null, activationTime?: string | null, canceledTime?: string | null, renewalTime?: string | null, startTime?: string | null, upcomingInvoice?: { __typename?: 'Invoice', id: string, dueTime?: string | null, issuedTime?: string | null, abandonedTime?: string | null, voidedTime?: string | null, paidTime?: string | null, currency?: string | null, invoiceNumber?: number | null, customerId?: string | null, websiteId?: string | null, organizationId?: string | null, subscriptionId?: string | null, amount?: number | null, subtotalAmount?: number | null, shippingAmount?: number | null, poNumber?: number | null, notes?: string | null, discountAmount?: number | null, discounts?: any | null, taxAmount?: number | null, taxes?: any | null, autopayScheduledTime?: string | null, autopayRetryNumber?: number | null, status?: string | null, delinquentCollectionPeriod?: number | null, collectionPeriod?: number | null, createdTime?: string | null, updatedTime?: string | null, billingAddress?: { __typename?: 'Address', firstName?: string | null, lastName?: string | null, country?: string | null, address?: string | null, emails?: Array<{ __typename?: 'Email', value?: string | null } | null> | null } | null, deliveryAddress?: { __typename?: 'Address', firstName?: string | null, lastName?: string | null, country?: string | null, address?: string | null, emails?: Array<{ __typename?: 'Email', value?: string | null } | null> | null } | null, items?: Array<{ __typename?: 'InvoiceItem', id?: string | null, type?: string | null, description?: string | null, unitPrice?: number | null } | null> | null, transactions?: Array<{ __typename?: 'Transaction', id: string, amount?: string | null, status?: string | null, result?: string | null, createdTime?: string | null, gateway?: any | null, currency?: string | null } | null> | null } | null, recentInvoice?: { __typename?: 'Invoice', id: string, dueTime?: string | null, issuedTime?: string | null, abandonedTime?: string | null, voidedTime?: string | null, paidTime?: string | null, currency?: string | null, invoiceNumber?: number | null, customerId?: string | null, websiteId?: string | null, organizationId?: string | null, subscriptionId?: string | null, amount?: number | null, subtotalAmount?: number | null, shippingAmount?: number | null, poNumber?: number | null, notes?: string | null, discountAmount?: number | null, discounts?: any | null, taxAmount?: number | null, taxes?: any | null, autopayScheduledTime?: string | null, autopayRetryNumber?: number | null, status?: string | null, delinquentCollectionPeriod?: number | null, collectionPeriod?: number | null, createdTime?: string | null, updatedTime?: string | null, billingAddress?: { __typename?: 'Address', firstName?: string | null, lastName?: string | null, country?: string | null, address?: string | null, emails?: Array<{ __typename?: 'Email', value?: string | null } | null> | null } | null, deliveryAddress?: { __typename?: 'Address', firstName?: string | null, lastName?: string | null, country?: string | null, address?: string | null, emails?: Array<{ __typename?: 'Email', value?: string | null } | null> | null } | null, items?: Array<{ __typename?: 'InvoiceItem', id?: string | null, type?: string | null, description?: string | null, unitPrice?: number | null } | null> | null, transactions?: Array<{ __typename?: 'Transaction', id: string, amount?: string | null, status?: string | null, result?: string | null, createdTime?: string | null, gateway?: any | null, currency?: string | null } | null> | null } | null, initialInvoice?: { __typename?: 'Invoice', id: string, dueTime?: string | null, issuedTime?: string | null, abandonedTime?: string | null, voidedTime?: string | null, paidTime?: string | null, currency?: string | null, invoiceNumber?: number | null, customerId?: string | null, websiteId?: string | null, organizationId?: string | null, subscriptionId?: string | null, amount?: number | null, subtotalAmount?: number | null, shippingAmount?: number | null, poNumber?: number | null, notes?: string | null, discountAmount?: number | null, discounts?: any | null, taxAmount?: number | null, taxes?: any | null, autopayScheduledTime?: string | null, autopayRetryNumber?: number | null, status?: string | null, delinquentCollectionPeriod?: number | null, collectionPeriod?: number | null, createdTime?: string | null, updatedTime?: string | null, billingAddress?: { __typename?: 'Address', firstName?: string | null, lastName?: string | null, country?: string | null, address?: string | null, emails?: Array<{ __typename?: 'Email', value?: string | null } | null> | null } | null, deliveryAddress?: { __typename?: 'Address', firstName?: string | null, lastName?: string | null, country?: string | null, address?: string | null, emails?: Array<{ __typename?: 'Email', value?: string | null } | null> | null } | null, items?: Array<{ __typename?: 'InvoiceItem', id?: string | null, type?: string | null, description?: string | null, unitPrice?: number | null } | null> | null, transactions?: Array<{ __typename?: 'Transaction', id: string, amount?: string | null, status?: string | null, result?: string | null, createdTime?: string | null, gateway?: any | null, currency?: string | null } | null> | null } | null } | null> | null, paymentCards?: Array<{ __typename?: 'PaymentCard', id?: string | null, bankCountry?: string | null, last4?: string | null, expYear?: number | null, expMonth?: number | null, brand?: string | null, status?: string | null } | null> | null, defaultPaymentInstrument?: { __typename?: 'PaymentInstrumentId', paymentCardId?: string | null } | null, primaryAddress?: { __typename?: 'Address', firstName?: string | null, lastName?: string | null, country?: string | null, address?: string | null, emails?: Array<{ __typename?: 'Email', value?: string | null } | null> | null } | null } | null } };

export type CheckoutV2MutationVariables = Exact<{
  planId: Scalars['String']['input'];
  paymentCardId: Scalars['String']['input'];
  customer?: InputMaybe<CustomerInput>;
  shipping?: InputMaybe<AddressInput>;
  billing?: InputMaybe<AddressInput>;
  customJson?: InputMaybe<Scalars['JSON']['input']>;
  stickyGatewayId?: InputMaybe<Scalars['String']['input']>;
}>;


export type CheckoutV2Mutation = { __typename?: 'Mutation', checkout: { __typename?: 'CheckoutResponse', transaction?: { __typename?: 'Transaction', id: string, amount?: string | null, status?: string | null, result?: string | null } | null, customer?: { __typename?: 'Customer', id: string, email?: string | null, paymentCount?: string | null, mainSubscription?: { __typename?: 'RebillySubscription', id: string, planType?: string | null, planId?: string | null, status?: string | null, billingStatus?: string | null, activationTime?: string | null, canceledTime?: string | null, renewalTime?: string | null, startTime?: string | null, upcomingInvoice?: { __typename?: 'Invoice', id: string, dueTime?: string | null, issuedTime?: string | null, abandonedTime?: string | null, voidedTime?: string | null, paidTime?: string | null, currency?: string | null, invoiceNumber?: number | null, customerId?: string | null, websiteId?: string | null, organizationId?: string | null, subscriptionId?: string | null, amount?: number | null, subtotalAmount?: number | null, shippingAmount?: number | null, poNumber?: number | null, notes?: string | null, discountAmount?: number | null, discounts?: any | null, taxAmount?: number | null, taxes?: any | null, autopayScheduledTime?: string | null, autopayRetryNumber?: number | null, status?: string | null, delinquentCollectionPeriod?: number | null, collectionPeriod?: number | null, createdTime?: string | null, updatedTime?: string | null, billingAddress?: { __typename?: 'Address', firstName?: string | null, lastName?: string | null, country?: string | null, address?: string | null, emails?: Array<{ __typename?: 'Email', value?: string | null } | null> | null } | null, deliveryAddress?: { __typename?: 'Address', firstName?: string | null, lastName?: string | null, country?: string | null, address?: string | null, emails?: Array<{ __typename?: 'Email', value?: string | null } | null> | null } | null, items?: Array<{ __typename?: 'InvoiceItem', id?: string | null, type?: string | null, description?: string | null, unitPrice?: number | null } | null> | null, transactions?: Array<{ __typename?: 'Transaction', id: string, amount?: string | null, status?: string | null, result?: string | null, createdTime?: string | null, gateway?: any | null, currency?: string | null } | null> | null } | null, recentInvoice?: { __typename?: 'Invoice', id: string, dueTime?: string | null, issuedTime?: string | null, abandonedTime?: string | null, voidedTime?: string | null, paidTime?: string | null, currency?: string | null, invoiceNumber?: number | null, customerId?: string | null, websiteId?: string | null, organizationId?: string | null, subscriptionId?: string | null, amount?: number | null, subtotalAmount?: number | null, shippingAmount?: number | null, poNumber?: number | null, notes?: string | null, discountAmount?: number | null, discounts?: any | null, taxAmount?: number | null, taxes?: any | null, autopayScheduledTime?: string | null, autopayRetryNumber?: number | null, status?: string | null, delinquentCollectionPeriod?: number | null, collectionPeriod?: number | null, createdTime?: string | null, updatedTime?: string | null, billingAddress?: { __typename?: 'Address', firstName?: string | null, lastName?: string | null, country?: string | null, address?: string | null, emails?: Array<{ __typename?: 'Email', value?: string | null } | null> | null } | null, deliveryAddress?: { __typename?: 'Address', firstName?: string | null, lastName?: string | null, country?: string | null, address?: string | null, emails?: Array<{ __typename?: 'Email', value?: string | null } | null> | null } | null, items?: Array<{ __typename?: 'InvoiceItem', id?: string | null, type?: string | null, description?: string | null, unitPrice?: number | null } | null> | null, transactions?: Array<{ __typename?: 'Transaction', id: string, amount?: string | null, status?: string | null, result?: string | null, createdTime?: string | null, gateway?: any | null, currency?: string | null } | null> | null } | null, initialInvoice?: { __typename?: 'Invoice', id: string, dueTime?: string | null, issuedTime?: string | null, abandonedTime?: string | null, voidedTime?: string | null, paidTime?: string | null, currency?: string | null, invoiceNumber?: number | null, customerId?: string | null, websiteId?: string | null, organizationId?: string | null, subscriptionId?: string | null, amount?: number | null, subtotalAmount?: number | null, shippingAmount?: number | null, poNumber?: number | null, notes?: string | null, discountAmount?: number | null, discounts?: any | null, taxAmount?: number | null, taxes?: any | null, autopayScheduledTime?: string | null, autopayRetryNumber?: number | null, status?: string | null, delinquentCollectionPeriod?: number | null, collectionPeriod?: number | null, createdTime?: string | null, updatedTime?: string | null, billingAddress?: { __typename?: 'Address', firstName?: string | null, lastName?: string | null, country?: string | null, address?: string | null, emails?: Array<{ __typename?: 'Email', value?: string | null } | null> | null } | null, deliveryAddress?: { __typename?: 'Address', firstName?: string | null, lastName?: string | null, country?: string | null, address?: string | null, emails?: Array<{ __typename?: 'Email', value?: string | null } | null> | null } | null, items?: Array<{ __typename?: 'InvoiceItem', id?: string | null, type?: string | null, description?: string | null, unitPrice?: number | null } | null> | null, transactions?: Array<{ __typename?: 'Transaction', id: string, amount?: string | null, status?: string | null, result?: string | null, createdTime?: string | null, gateway?: any | null, currency?: string | null } | null> | null } | null } | null, subscriptions?: Array<{ __typename?: 'RebillySubscription', id: string, planType?: string | null, planId?: string | null, status?: string | null, billingStatus?: string | null, activationTime?: string | null, canceledTime?: string | null, renewalTime?: string | null, startTime?: string | null, upcomingInvoice?: { __typename?: 'Invoice', id: string, dueTime?: string | null, issuedTime?: string | null, abandonedTime?: string | null, voidedTime?: string | null, paidTime?: string | null, currency?: string | null, invoiceNumber?: number | null, customerId?: string | null, websiteId?: string | null, organizationId?: string | null, subscriptionId?: string | null, amount?: number | null, subtotalAmount?: number | null, shippingAmount?: number | null, poNumber?: number | null, notes?: string | null, discountAmount?: number | null, discounts?: any | null, taxAmount?: number | null, taxes?: any | null, autopayScheduledTime?: string | null, autopayRetryNumber?: number | null, status?: string | null, delinquentCollectionPeriod?: number | null, collectionPeriod?: number | null, createdTime?: string | null, updatedTime?: string | null, billingAddress?: { __typename?: 'Address', firstName?: string | null, lastName?: string | null, country?: string | null, address?: string | null, emails?: Array<{ __typename?: 'Email', value?: string | null } | null> | null } | null, deliveryAddress?: { __typename?: 'Address', firstName?: string | null, lastName?: string | null, country?: string | null, address?: string | null, emails?: Array<{ __typename?: 'Email', value?: string | null } | null> | null } | null, items?: Array<{ __typename?: 'InvoiceItem', id?: string | null, type?: string | null, description?: string | null, unitPrice?: number | null } | null> | null, transactions?: Array<{ __typename?: 'Transaction', id: string, amount?: string | null, status?: string | null, result?: string | null, createdTime?: string | null, gateway?: any | null, currency?: string | null } | null> | null } | null, recentInvoice?: { __typename?: 'Invoice', id: string, dueTime?: string | null, issuedTime?: string | null, abandonedTime?: string | null, voidedTime?: string | null, paidTime?: string | null, currency?: string | null, invoiceNumber?: number | null, customerId?: string | null, websiteId?: string | null, organizationId?: string | null, subscriptionId?: string | null, amount?: number | null, subtotalAmount?: number | null, shippingAmount?: number | null, poNumber?: number | null, notes?: string | null, discountAmount?: number | null, discounts?: any | null, taxAmount?: number | null, taxes?: any | null, autopayScheduledTime?: string | null, autopayRetryNumber?: number | null, status?: string | null, delinquentCollectionPeriod?: number | null, collectionPeriod?: number | null, createdTime?: string | null, updatedTime?: string | null, billingAddress?: { __typename?: 'Address', firstName?: string | null, lastName?: string | null, country?: string | null, address?: string | null, emails?: Array<{ __typename?: 'Email', value?: string | null } | null> | null } | null, deliveryAddress?: { __typename?: 'Address', firstName?: string | null, lastName?: string | null, country?: string | null, address?: string | null, emails?: Array<{ __typename?: 'Email', value?: string | null } | null> | null } | null, items?: Array<{ __typename?: 'InvoiceItem', id?: string | null, type?: string | null, description?: string | null, unitPrice?: number | null } | null> | null, transactions?: Array<{ __typename?: 'Transaction', id: string, amount?: string | null, status?: string | null, result?: string | null, createdTime?: string | null, gateway?: any | null, currency?: string | null } | null> | null } | null, initialInvoice?: { __typename?: 'Invoice', id: string, dueTime?: string | null, issuedTime?: string | null, abandonedTime?: string | null, voidedTime?: string | null, paidTime?: string | null, currency?: string | null, invoiceNumber?: number | null, customerId?: string | null, websiteId?: string | null, organizationId?: string | null, subscriptionId?: string | null, amount?: number | null, subtotalAmount?: number | null, shippingAmount?: number | null, poNumber?: number | null, notes?: string | null, discountAmount?: number | null, discounts?: any | null, taxAmount?: number | null, taxes?: any | null, autopayScheduledTime?: string | null, autopayRetryNumber?: number | null, status?: string | null, delinquentCollectionPeriod?: number | null, collectionPeriod?: number | null, createdTime?: string | null, updatedTime?: string | null, billingAddress?: { __typename?: 'Address', firstName?: string | null, lastName?: string | null, country?: string | null, address?: string | null, emails?: Array<{ __typename?: 'Email', value?: string | null } | null> | null } | null, deliveryAddress?: { __typename?: 'Address', firstName?: string | null, lastName?: string | null, country?: string | null, address?: string | null, emails?: Array<{ __typename?: 'Email', value?: string | null } | null> | null } | null, items?: Array<{ __typename?: 'InvoiceItem', id?: string | null, type?: string | null, description?: string | null, unitPrice?: number | null } | null> | null, transactions?: Array<{ __typename?: 'Transaction', id: string, amount?: string | null, status?: string | null, result?: string | null, createdTime?: string | null, gateway?: any | null, currency?: string | null } | null> | null } | null } | null> | null, paymentCards?: Array<{ __typename?: 'PaymentCard', id?: string | null, bankCountry?: string | null, last4?: string | null, expYear?: number | null, expMonth?: number | null, brand?: string | null, status?: string | null } | null> | null, defaultPaymentInstrument?: { __typename?: 'PaymentInstrumentId', paymentCardId?: string | null } | null, primaryAddress?: { __typename?: 'Address', firstName?: string | null, lastName?: string | null, country?: string | null, address?: string | null, emails?: Array<{ __typename?: 'Email', value?: string | null } | null> | null } | null } | null } };

export type CheckoutV3MutationVariables = Exact<{
  paymentToken?: InputMaybe<Scalars['String']['input']>;
  paymentInstrument?: InputMaybe<PaymentInstrumentInput>;
  customer?: InputMaybe<CustomerInput>;
  shipping?: InputMaybe<AddressInput>;
  billing?: InputMaybe<AddressInput>;
  customJson?: InputMaybe<Scalars['JSON']['input']>;
  items?: InputMaybe<Array<ItemInput> | ItemInput>;
  shippingAmount?: InputMaybe<Scalars['Float']['input']>;
}>;


export type CheckoutV3Mutation = { __typename?: 'Mutation', checkout: { __typename?: 'CheckoutResponse', transaction?: { __typename?: 'Transaction', id: string, amount?: string | null, status?: string | null, result?: string | null, planIds?: Array<string | null> | null, paymentInstrument?: { __typename?: 'PaymentInstrumentId', paymentCardId?: string | null, method?: string | null } | null } | null, customer?: { __typename?: 'Customer', id: string, email?: string | null } | null } };

export type TransactionMutationVariables = Exact<{
  invoiceId: Scalars['String']['input'];
  paymentCardId: Scalars['String']['input'];
}>;


export type TransactionMutation = { __typename?: 'Mutation', createTransaction?: { __typename?: 'Transaction', id: string, status?: string | null, result?: string | null } | null };

export type TransactionV2MutationVariables = Exact<{
  invoiceId: Scalars['String']['input'];
  paymentCardId: Scalars['String']['input'];
}>;


export type TransactionV2Mutation = { __typename?: 'Mutation', createTransaction?: { __typename?: 'Transaction', id: string, status?: string | null, result?: string | null } | null };

export type CancelSubscriptionMutationVariables = Exact<{
  subscriptionId: Scalars['String']['input'];
}>;


export type CancelSubscriptionMutation = { __typename?: 'Mutation', cancelSubscription?: { __typename?: 'RebillySubscription', id: string, planType?: string | null, planId?: string | null, status?: string | null, billingStatus?: string | null, activationTime?: string | null, canceledTime?: string | null, renewalTime?: string | null, startTime?: string | null, upcomingInvoice?: { __typename?: 'Invoice', id: string, dueTime?: string | null, issuedTime?: string | null, abandonedTime?: string | null, voidedTime?: string | null, paidTime?: string | null, currency?: string | null, invoiceNumber?: number | null, customerId?: string | null, websiteId?: string | null, organizationId?: string | null, subscriptionId?: string | null, amount?: number | null, subtotalAmount?: number | null, shippingAmount?: number | null, poNumber?: number | null, notes?: string | null, discountAmount?: number | null, discounts?: any | null, taxAmount?: number | null, taxes?: any | null, autopayScheduledTime?: string | null, autopayRetryNumber?: number | null, status?: string | null, delinquentCollectionPeriod?: number | null, collectionPeriod?: number | null, createdTime?: string | null, updatedTime?: string | null, billingAddress?: { __typename?: 'Address', firstName?: string | null, lastName?: string | null, country?: string | null, address?: string | null, emails?: Array<{ __typename?: 'Email', value?: string | null } | null> | null } | null, deliveryAddress?: { __typename?: 'Address', firstName?: string | null, lastName?: string | null, country?: string | null, address?: string | null, emails?: Array<{ __typename?: 'Email', value?: string | null } | null> | null } | null, items?: Array<{ __typename?: 'InvoiceItem', id?: string | null, type?: string | null, description?: string | null, unitPrice?: number | null } | null> | null, transactions?: Array<{ __typename?: 'Transaction', id: string, amount?: string | null, status?: string | null, result?: string | null, createdTime?: string | null, gateway?: any | null, currency?: string | null } | null> | null } | null, recentInvoice?: { __typename?: 'Invoice', id: string, dueTime?: string | null, issuedTime?: string | null, abandonedTime?: string | null, voidedTime?: string | null, paidTime?: string | null, currency?: string | null, invoiceNumber?: number | null, customerId?: string | null, websiteId?: string | null, organizationId?: string | null, subscriptionId?: string | null, amount?: number | null, subtotalAmount?: number | null, shippingAmount?: number | null, poNumber?: number | null, notes?: string | null, discountAmount?: number | null, discounts?: any | null, taxAmount?: number | null, taxes?: any | null, autopayScheduledTime?: string | null, autopayRetryNumber?: number | null, status?: string | null, delinquentCollectionPeriod?: number | null, collectionPeriod?: number | null, createdTime?: string | null, updatedTime?: string | null, billingAddress?: { __typename?: 'Address', firstName?: string | null, lastName?: string | null, country?: string | null, address?: string | null, emails?: Array<{ __typename?: 'Email', value?: string | null } | null> | null } | null, deliveryAddress?: { __typename?: 'Address', firstName?: string | null, lastName?: string | null, country?: string | null, address?: string | null, emails?: Array<{ __typename?: 'Email', value?: string | null } | null> | null } | null, items?: Array<{ __typename?: 'InvoiceItem', id?: string | null, type?: string | null, description?: string | null, unitPrice?: number | null } | null> | null, transactions?: Array<{ __typename?: 'Transaction', id: string, amount?: string | null, status?: string | null, result?: string | null, createdTime?: string | null, gateway?: any | null, currency?: string | null } | null> | null } | null, initialInvoice?: { __typename?: 'Invoice', id: string, dueTime?: string | null, issuedTime?: string | null, abandonedTime?: string | null, voidedTime?: string | null, paidTime?: string | null, currency?: string | null, invoiceNumber?: number | null, customerId?: string | null, websiteId?: string | null, organizationId?: string | null, subscriptionId?: string | null, amount?: number | null, subtotalAmount?: number | null, shippingAmount?: number | null, poNumber?: number | null, notes?: string | null, discountAmount?: number | null, discounts?: any | null, taxAmount?: number | null, taxes?: any | null, autopayScheduledTime?: string | null, autopayRetryNumber?: number | null, status?: string | null, delinquentCollectionPeriod?: number | null, collectionPeriod?: number | null, createdTime?: string | null, updatedTime?: string | null, billingAddress?: { __typename?: 'Address', firstName?: string | null, lastName?: string | null, country?: string | null, address?: string | null, emails?: Array<{ __typename?: 'Email', value?: string | null } | null> | null } | null, deliveryAddress?: { __typename?: 'Address', firstName?: string | null, lastName?: string | null, country?: string | null, address?: string | null, emails?: Array<{ __typename?: 'Email', value?: string | null } | null> | null } | null, items?: Array<{ __typename?: 'InvoiceItem', id?: string | null, type?: string | null, description?: string | null, unitPrice?: number | null } | null> | null, transactions?: Array<{ __typename?: 'Transaction', id: string, amount?: string | null, status?: string | null, result?: string | null, createdTime?: string | null, gateway?: any | null, currency?: string | null } | null> | null } | null } | null };

export type ReactivateSubscriptionMutationVariables = Exact<{
  subscriptionId: Scalars['String']['input'];
}>;


export type ReactivateSubscriptionMutation = { __typename?: 'Mutation', reactivateSubscription?: { __typename?: 'RebillySubscription', id: string, planType?: string | null, planId?: string | null, status?: string | null, billingStatus?: string | null, activationTime?: string | null, canceledTime?: string | null, renewalTime?: string | null, startTime?: string | null, upcomingInvoice?: { __typename?: 'Invoice', id: string, dueTime?: string | null, issuedTime?: string | null, abandonedTime?: string | null, voidedTime?: string | null, paidTime?: string | null, currency?: string | null, invoiceNumber?: number | null, customerId?: string | null, websiteId?: string | null, organizationId?: string | null, subscriptionId?: string | null, amount?: number | null, subtotalAmount?: number | null, shippingAmount?: number | null, poNumber?: number | null, notes?: string | null, discountAmount?: number | null, discounts?: any | null, taxAmount?: number | null, taxes?: any | null, autopayScheduledTime?: string | null, autopayRetryNumber?: number | null, status?: string | null, delinquentCollectionPeriod?: number | null, collectionPeriod?: number | null, createdTime?: string | null, updatedTime?: string | null, billingAddress?: { __typename?: 'Address', firstName?: string | null, lastName?: string | null, country?: string | null, address?: string | null, emails?: Array<{ __typename?: 'Email', value?: string | null } | null> | null } | null, deliveryAddress?: { __typename?: 'Address', firstName?: string | null, lastName?: string | null, country?: string | null, address?: string | null, emails?: Array<{ __typename?: 'Email', value?: string | null } | null> | null } | null, items?: Array<{ __typename?: 'InvoiceItem', id?: string | null, type?: string | null, description?: string | null, unitPrice?: number | null } | null> | null, transactions?: Array<{ __typename?: 'Transaction', id: string, amount?: string | null, status?: string | null, result?: string | null, createdTime?: string | null, gateway?: any | null, currency?: string | null } | null> | null } | null, recentInvoice?: { __typename?: 'Invoice', id: string, dueTime?: string | null, issuedTime?: string | null, abandonedTime?: string | null, voidedTime?: string | null, paidTime?: string | null, currency?: string | null, invoiceNumber?: number | null, customerId?: string | null, websiteId?: string | null, organizationId?: string | null, subscriptionId?: string | null, amount?: number | null, subtotalAmount?: number | null, shippingAmount?: number | null, poNumber?: number | null, notes?: string | null, discountAmount?: number | null, discounts?: any | null, taxAmount?: number | null, taxes?: any | null, autopayScheduledTime?: string | null, autopayRetryNumber?: number | null, status?: string | null, delinquentCollectionPeriod?: number | null, collectionPeriod?: number | null, createdTime?: string | null, updatedTime?: string | null, billingAddress?: { __typename?: 'Address', firstName?: string | null, lastName?: string | null, country?: string | null, address?: string | null, emails?: Array<{ __typename?: 'Email', value?: string | null } | null> | null } | null, deliveryAddress?: { __typename?: 'Address', firstName?: string | null, lastName?: string | null, country?: string | null, address?: string | null, emails?: Array<{ __typename?: 'Email', value?: string | null } | null> | null } | null, items?: Array<{ __typename?: 'InvoiceItem', id?: string | null, type?: string | null, description?: string | null, unitPrice?: number | null } | null> | null, transactions?: Array<{ __typename?: 'Transaction', id: string, amount?: string | null, status?: string | null, result?: string | null, createdTime?: string | null, gateway?: any | null, currency?: string | null } | null> | null } | null, initialInvoice?: { __typename?: 'Invoice', id: string, dueTime?: string | null, issuedTime?: string | null, abandonedTime?: string | null, voidedTime?: string | null, paidTime?: string | null, currency?: string | null, invoiceNumber?: number | null, customerId?: string | null, websiteId?: string | null, organizationId?: string | null, subscriptionId?: string | null, amount?: number | null, subtotalAmount?: number | null, shippingAmount?: number | null, poNumber?: number | null, notes?: string | null, discountAmount?: number | null, discounts?: any | null, taxAmount?: number | null, taxes?: any | null, autopayScheduledTime?: string | null, autopayRetryNumber?: number | null, status?: string | null, delinquentCollectionPeriod?: number | null, collectionPeriod?: number | null, createdTime?: string | null, updatedTime?: string | null, billingAddress?: { __typename?: 'Address', firstName?: string | null, lastName?: string | null, country?: string | null, address?: string | null, emails?: Array<{ __typename?: 'Email', value?: string | null } | null> | null } | null, deliveryAddress?: { __typename?: 'Address', firstName?: string | null, lastName?: string | null, country?: string | null, address?: string | null, emails?: Array<{ __typename?: 'Email', value?: string | null } | null> | null } | null, items?: Array<{ __typename?: 'InvoiceItem', id?: string | null, type?: string | null, description?: string | null, unitPrice?: number | null } | null> | null, transactions?: Array<{ __typename?: 'Transaction', id: string, amount?: string | null, status?: string | null, result?: string | null, createdTime?: string | null, gateway?: any | null, currency?: string | null } | null> | null } | null } | null };

export type ChangeSubscriptionPreviewMutationVariables = Exact<{
  subscriptionId: Scalars['String']['input'];
  planId: Scalars['String']['input'];
}>;


export type ChangeSubscriptionPreviewMutation = { __typename?: 'Mutation', changeSubscriptionPreview?: { __typename?: 'ChangeSubscription', status?: string | null, billingStatus?: string | null, lineItemSubtotal: number, items: Array<{ __typename?: 'Item', planId: string }>, lineItems: Array<{ __typename?: 'LineItem', quantity?: number | null, unitPriceAmount?: number | null, unitPriceCurrency?: string | null, description?: string | null, type?: string | null }> } | null };

export type ChangeSubscriptionMutationVariables = Exact<{
  subscriptionId: Scalars['String']['input'];
  planId: Scalars['String']['input'];
  paymentCardId: Scalars['String']['input'];
}>;


export type ChangeSubscriptionMutation = { __typename?: 'Mutation', changeSubscription?: { __typename?: 'RebillySubscription', id: string, planType?: string | null, planId?: string | null, status?: string | null, billingStatus?: string | null, activationTime?: string | null, canceledTime?: string | null, renewalTime?: string | null, startTime?: string | null, upcomingInvoice?: { __typename?: 'Invoice', id: string, dueTime?: string | null, issuedTime?: string | null, abandonedTime?: string | null, voidedTime?: string | null, paidTime?: string | null, currency?: string | null, invoiceNumber?: number | null, customerId?: string | null, websiteId?: string | null, organizationId?: string | null, subscriptionId?: string | null, amount?: number | null, subtotalAmount?: number | null, shippingAmount?: number | null, poNumber?: number | null, notes?: string | null, discountAmount?: number | null, discounts?: any | null, taxAmount?: number | null, taxes?: any | null, autopayScheduledTime?: string | null, autopayRetryNumber?: number | null, status?: string | null, delinquentCollectionPeriod?: number | null, collectionPeriod?: number | null, createdTime?: string | null, updatedTime?: string | null, billingAddress?: { __typename?: 'Address', firstName?: string | null, lastName?: string | null, country?: string | null, address?: string | null, emails?: Array<{ __typename?: 'Email', value?: string | null } | null> | null } | null, deliveryAddress?: { __typename?: 'Address', firstName?: string | null, lastName?: string | null, country?: string | null, address?: string | null, emails?: Array<{ __typename?: 'Email', value?: string | null } | null> | null } | null, items?: Array<{ __typename?: 'InvoiceItem', id?: string | null, type?: string | null, description?: string | null, unitPrice?: number | null } | null> | null, transactions?: Array<{ __typename?: 'Transaction', id: string, amount?: string | null, status?: string | null, result?: string | null, createdTime?: string | null, gateway?: any | null, currency?: string | null } | null> | null } | null, recentInvoice?: { __typename?: 'Invoice', id: string, dueTime?: string | null, issuedTime?: string | null, abandonedTime?: string | null, voidedTime?: string | null, paidTime?: string | null, currency?: string | null, invoiceNumber?: number | null, customerId?: string | null, websiteId?: string | null, organizationId?: string | null, subscriptionId?: string | null, amount?: number | null, subtotalAmount?: number | null, shippingAmount?: number | null, poNumber?: number | null, notes?: string | null, discountAmount?: number | null, discounts?: any | null, taxAmount?: number | null, taxes?: any | null, autopayScheduledTime?: string | null, autopayRetryNumber?: number | null, status?: string | null, delinquentCollectionPeriod?: number | null, collectionPeriod?: number | null, createdTime?: string | null, updatedTime?: string | null, billingAddress?: { __typename?: 'Address', firstName?: string | null, lastName?: string | null, country?: string | null, address?: string | null, emails?: Array<{ __typename?: 'Email', value?: string | null } | null> | null } | null, deliveryAddress?: { __typename?: 'Address', firstName?: string | null, lastName?: string | null, country?: string | null, address?: string | null, emails?: Array<{ __typename?: 'Email', value?: string | null } | null> | null } | null, items?: Array<{ __typename?: 'InvoiceItem', id?: string | null, type?: string | null, description?: string | null, unitPrice?: number | null } | null> | null, transactions?: Array<{ __typename?: 'Transaction', id: string, amount?: string | null, status?: string | null, result?: string | null, createdTime?: string | null, gateway?: any | null, currency?: string | null } | null> | null } | null, initialInvoice?: { __typename?: 'Invoice', id: string, dueTime?: string | null, issuedTime?: string | null, abandonedTime?: string | null, voidedTime?: string | null, paidTime?: string | null, currency?: string | null, invoiceNumber?: number | null, customerId?: string | null, websiteId?: string | null, organizationId?: string | null, subscriptionId?: string | null, amount?: number | null, subtotalAmount?: number | null, shippingAmount?: number | null, poNumber?: number | null, notes?: string | null, discountAmount?: number | null, discounts?: any | null, taxAmount?: number | null, taxes?: any | null, autopayScheduledTime?: string | null, autopayRetryNumber?: number | null, status?: string | null, delinquentCollectionPeriod?: number | null, collectionPeriod?: number | null, createdTime?: string | null, updatedTime?: string | null, billingAddress?: { __typename?: 'Address', firstName?: string | null, lastName?: string | null, country?: string | null, address?: string | null, emails?: Array<{ __typename?: 'Email', value?: string | null } | null> | null } | null, deliveryAddress?: { __typename?: 'Address', firstName?: string | null, lastName?: string | null, country?: string | null, address?: string | null, emails?: Array<{ __typename?: 'Email', value?: string | null } | null> | null } | null, items?: Array<{ __typename?: 'InvoiceItem', id?: string | null, type?: string | null, description?: string | null, unitPrice?: number | null } | null> | null, transactions?: Array<{ __typename?: 'Transaction', id: string, amount?: string | null, status?: string | null, result?: string | null, createdTime?: string | null, gateway?: any | null, currency?: string | null } | null> | null } | null } | null };

export type CreateCustomerMutationVariables = Exact<{
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateCustomerMutation = { __typename?: 'Mutation', createCustomer?: { __typename?: 'Customer', id: string, email?: string | null, paymentCount?: string | null, defaultPaymentInstrument?: { __typename?: 'PaymentInstrumentId', paymentCardId?: string | null } | null, primaryAddress?: { __typename?: 'Address', firstName?: string | null, lastName?: string | null, country?: string | null, address?: string | null, emails?: Array<{ __typename?: 'Email', value?: string | null } | null> | null } | null } | null };

export type AddPaymentMutationVariables = Exact<{
  paymentToken: Scalars['String']['input'];
  customerId?: InputMaybe<Scalars['String']['input']>;
  customer?: InputMaybe<CustomerInput>;
  authorize?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type AddPaymentMutation = { __typename?: 'Mutation', addPayment?: { __typename?: 'Customer', id: string, email?: string | null, paymentCount?: string | null, subscriptions?: Array<{ __typename?: 'RebillySubscription', id: string, planType?: string | null, planId?: string | null, status?: string | null, billingStatus?: string | null, activationTime?: string | null, canceledTime?: string | null, renewalTime?: string | null, startTime?: string | null, upcomingInvoice?: { __typename?: 'Invoice', id: string, dueTime?: string | null, issuedTime?: string | null, abandonedTime?: string | null, voidedTime?: string | null, paidTime?: string | null, currency?: string | null, invoiceNumber?: number | null, customerId?: string | null, websiteId?: string | null, organizationId?: string | null, subscriptionId?: string | null, amount?: number | null, subtotalAmount?: number | null, shippingAmount?: number | null, poNumber?: number | null, notes?: string | null, discountAmount?: number | null, discounts?: any | null, taxAmount?: number | null, taxes?: any | null, autopayScheduledTime?: string | null, autopayRetryNumber?: number | null, status?: string | null, delinquentCollectionPeriod?: number | null, collectionPeriod?: number | null, createdTime?: string | null, updatedTime?: string | null, billingAddress?: { __typename?: 'Address', firstName?: string | null, lastName?: string | null, country?: string | null, address?: string | null, emails?: Array<{ __typename?: 'Email', value?: string | null } | null> | null } | null, deliveryAddress?: { __typename?: 'Address', firstName?: string | null, lastName?: string | null, country?: string | null, address?: string | null, emails?: Array<{ __typename?: 'Email', value?: string | null } | null> | null } | null, items?: Array<{ __typename?: 'InvoiceItem', id?: string | null, type?: string | null, description?: string | null, unitPrice?: number | null } | null> | null, transactions?: Array<{ __typename?: 'Transaction', id: string, amount?: string | null, status?: string | null, result?: string | null, createdTime?: string | null, gateway?: any | null, currency?: string | null } | null> | null } | null, recentInvoice?: { __typename?: 'Invoice', id: string, dueTime?: string | null, issuedTime?: string | null, abandonedTime?: string | null, voidedTime?: string | null, paidTime?: string | null, currency?: string | null, invoiceNumber?: number | null, customerId?: string | null, websiteId?: string | null, organizationId?: string | null, subscriptionId?: string | null, amount?: number | null, subtotalAmount?: number | null, shippingAmount?: number | null, poNumber?: number | null, notes?: string | null, discountAmount?: number | null, discounts?: any | null, taxAmount?: number | null, taxes?: any | null, autopayScheduledTime?: string | null, autopayRetryNumber?: number | null, status?: string | null, delinquentCollectionPeriod?: number | null, collectionPeriod?: number | null, createdTime?: string | null, updatedTime?: string | null, billingAddress?: { __typename?: 'Address', firstName?: string | null, lastName?: string | null, country?: string | null, address?: string | null, emails?: Array<{ __typename?: 'Email', value?: string | null } | null> | null } | null, deliveryAddress?: { __typename?: 'Address', firstName?: string | null, lastName?: string | null, country?: string | null, address?: string | null, emails?: Array<{ __typename?: 'Email', value?: string | null } | null> | null } | null, items?: Array<{ __typename?: 'InvoiceItem', id?: string | null, type?: string | null, description?: string | null, unitPrice?: number | null } | null> | null, transactions?: Array<{ __typename?: 'Transaction', id: string, amount?: string | null, status?: string | null, result?: string | null, createdTime?: string | null, gateway?: any | null, currency?: string | null } | null> | null } | null, initialInvoice?: { __typename?: 'Invoice', id: string, dueTime?: string | null, issuedTime?: string | null, abandonedTime?: string | null, voidedTime?: string | null, paidTime?: string | null, currency?: string | null, invoiceNumber?: number | null, customerId?: string | null, websiteId?: string | null, organizationId?: string | null, subscriptionId?: string | null, amount?: number | null, subtotalAmount?: number | null, shippingAmount?: number | null, poNumber?: number | null, notes?: string | null, discountAmount?: number | null, discounts?: any | null, taxAmount?: number | null, taxes?: any | null, autopayScheduledTime?: string | null, autopayRetryNumber?: number | null, status?: string | null, delinquentCollectionPeriod?: number | null, collectionPeriod?: number | null, createdTime?: string | null, updatedTime?: string | null, billingAddress?: { __typename?: 'Address', firstName?: string | null, lastName?: string | null, country?: string | null, address?: string | null, emails?: Array<{ __typename?: 'Email', value?: string | null } | null> | null } | null, deliveryAddress?: { __typename?: 'Address', firstName?: string | null, lastName?: string | null, country?: string | null, address?: string | null, emails?: Array<{ __typename?: 'Email', value?: string | null } | null> | null } | null, items?: Array<{ __typename?: 'InvoiceItem', id?: string | null, type?: string | null, description?: string | null, unitPrice?: number | null } | null> | null, transactions?: Array<{ __typename?: 'Transaction', id: string, amount?: string | null, status?: string | null, result?: string | null, createdTime?: string | null, gateway?: any | null, currency?: string | null } | null> | null } | null } | null> | null, paymentCards?: Array<{ __typename?: 'PaymentCard', id?: string | null, bankCountry?: string | null, last4?: string | null, expYear?: number | null, expMonth?: number | null, brand?: string | null, status?: string | null } | null> | null, defaultPaymentInstrument?: { __typename?: 'PaymentInstrumentId', paymentCardId?: string | null } | null, primaryAddress?: { __typename?: 'Address', firstName?: string | null, lastName?: string | null, country?: string | null, address?: string | null, emails?: Array<{ __typename?: 'Email', value?: string | null } | null> | null } | null } | null };

export type CumulativeSubscriptionCountFragment = { __typename?: 'CumulativeSubscriptionCount', day?: string | null, planId?: string | null, cumulativeCount?: number | null, newCount?: number | null, canceledCount?: number | null, netCount?: number | null };

export type CumulativeTransactionCountFragment = { __typename?: 'CumulativeTransactionCount', aggregationFieldValue?: string | null, authApprovedThroughput?: number | null, authApprovalCount?: number | null, salesAverage?: number | null, salesCount?: number | null, salesValue?: number | null, disputesRate?: number | null, disputesCount?: number | null, refundsCount?: number | null, refundsValue?: number | null, amount?: number | null, count?: number | null };

export type CumulativeSubscriptionCountQueryVariables = Exact<{
  start?: InputMaybe<Scalars['String']['input']>;
  end?: InputMaybe<Scalars['String']['input']>;
}>;


export type CumulativeSubscriptionCountQuery = { __typename?: 'Query', cumulativeSubscriptionCount?: { __typename?: 'CumulativeSubscriptionCountResult', data?: Array<{ __typename?: 'CumulativeSubscriptionCount', day?: string | null, planId?: string | null, cumulativeCount?: number | null, newCount?: number | null, canceledCount?: number | null, netCount?: number | null } | null> | null } | null };

export type CumulativeTransactionCountQueryVariables = Exact<{
  start?: InputMaybe<Scalars['String']['input']>;
  end?: InputMaybe<Scalars['String']['input']>;
}>;


export type CumulativeTransactionCountQuery = { __typename?: 'Query', cumulativeTransactionCount?: { __typename?: 'CumulativeTransactionCountResult', data?: Array<{ __typename?: 'CumulativeTransactionCount', aggregationFieldValue?: string | null, authApprovedThroughput?: number | null, authApprovalCount?: number | null, salesAverage?: number | null, salesCount?: number | null, salesValue?: number | null, disputesRate?: number | null, disputesCount?: number | null, refundsCount?: number | null, refundsValue?: number | null, amount?: number | null, count?: number | null } | null> | null } | null };

export type CumulativeStatsQueryVariables = Exact<{
  start?: InputMaybe<Scalars['String']['input']>;
  end?: InputMaybe<Scalars['String']['input']>;
}>;


export type CumulativeStatsQuery = { __typename?: 'Query', cumulativeSubscriptionCount?: { __typename?: 'CumulativeSubscriptionCountResult', data?: Array<{ __typename?: 'CumulativeSubscriptionCount', day?: string | null, planId?: string | null, cumulativeCount?: number | null, newCount?: number | null, canceledCount?: number | null, netCount?: number | null } | null> | null } | null, cumulativeTransactionCount?: { __typename?: 'CumulativeTransactionCountResult', data?: Array<{ __typename?: 'CumulativeTransactionCount', aggregationFieldValue?: string | null, authApprovedThroughput?: number | null, authApprovalCount?: number | null, salesAverage?: number | null, salesCount?: number | null, salesValue?: number | null, disputesRate?: number | null, disputesCount?: number | null, refundsCount?: number | null, refundsValue?: number | null, amount?: number | null, count?: number | null } | null> | null } | null };

export type DeactivatePaymentCardMutationVariables = Exact<{
  paymentCardId: Scalars['String']['input'];
}>;


export type DeactivatePaymentCardMutation = { __typename?: 'Mutation', deactivatePaymentCard?: { __typename?: 'PaymentCard', id?: string | null, bankCountry?: string | null, last4?: string | null, expYear?: number | null, expMonth?: number | null, brand?: string | null, status?: string | null } | null };

export type RefundRequestFragment = { __typename?: 'RefundRequest', id?: string | null, url?: string | null, uid?: string | null, email?: string | null, photoURL?: string | null, date?: string | null, expireAt?: number | null, refunded?: boolean | null, refunding?: boolean | null, accepted?: boolean | null, active?: boolean | null, error?: string | null, startTime?: string | null, activeSubscription?: string | null, iosSub?: any | null, iosErr?: string | null, androidSub?: any | null, androidErr?: string | null, rebillyErr?: string | null, eligibleMessage?: string | null, eligibleMonths?: number | null, eligibleAmount?: number | null, collectedAmount?: number | null, collectedAmountRange?: any | null, collectedCount?: number | null, droppedAmount?: number | null, dropCount?: number | null, redeemCount?: number | null, xyoCollected?: number | null, resetXyoCollectedAmount?: number | null, rebillySub?: { __typename?: 'RebillySub', subscriptionId?: string | null, transactions?: Array<{ __typename?: 'RebillyTrans', createdTime?: string | null, transactionId: string, amount: number }> | null } | null };

export type RefundRequestQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type RefundRequestQuery = { __typename?: 'Query', refundRequest?: { __typename?: 'RefundRequest', id?: string | null, url?: string | null, uid?: string | null, email?: string | null, photoURL?: string | null, date?: string | null, expireAt?: number | null, refunded?: boolean | null, refunding?: boolean | null, accepted?: boolean | null, active?: boolean | null, error?: string | null, startTime?: string | null, activeSubscription?: string | null, iosSub?: any | null, iosErr?: string | null, androidSub?: any | null, androidErr?: string | null, rebillyErr?: string | null, eligibleMessage?: string | null, eligibleMonths?: number | null, eligibleAmount?: number | null, collectedAmount?: number | null, collectedAmountRange?: any | null, collectedCount?: number | null, droppedAmount?: number | null, dropCount?: number | null, redeemCount?: number | null, xyoCollected?: number | null, resetXyoCollectedAmount?: number | null, rebillySub?: { __typename?: 'RebillySub', subscriptionId?: string | null, transactions?: Array<{ __typename?: 'RebillyTrans', createdTime?: string | null, transactionId: string, amount: number }> | null } | null } | null };

export type RefundRequestsQueryVariables = Exact<{
  filter?: InputMaybe<RefundRequestFilter>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<Sort>;
}>;


export type RefundRequestsQuery = { __typename?: 'Query', refundRequests?: { __typename?: 'RefundRequestPage', total?: number | null, data?: Array<{ __typename?: 'RefundRequest', id?: string | null, url?: string | null, uid?: string | null, email?: string | null, photoURL?: string | null, date?: string | null, expireAt?: number | null, refunded?: boolean | null, refunding?: boolean | null, accepted?: boolean | null, active?: boolean | null, error?: string | null, startTime?: string | null, activeSubscription?: string | null, iosSub?: any | null, iosErr?: string | null, androidSub?: any | null, androidErr?: string | null, rebillyErr?: string | null, eligibleMessage?: string | null, eligibleMonths?: number | null, eligibleAmount?: number | null, collectedAmount?: number | null, collectedAmountRange?: any | null, collectedCount?: number | null, droppedAmount?: number | null, dropCount?: number | null, redeemCount?: number | null, xyoCollected?: number | null, resetXyoCollectedAmount?: number | null, rebillySub?: { __typename?: 'RebillySub', subscriptionId?: string | null, transactions?: Array<{ __typename?: 'RebillyTrans', createdTime?: string | null, transactionId: string, amount: number }> | null } | null } | null> | null } | null };

export type GenerateRefundRequestMutationVariables = Exact<{
  uid: Scalars['String']['input'];
  expireSeconds?: InputMaybe<Scalars['Int']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GenerateRefundRequestMutation = { __typename?: 'Mutation', generateRefundRequest?: { __typename?: 'RefundRequest', id?: string | null, url?: string | null, uid?: string | null, email?: string | null, photoURL?: string | null, date?: string | null, expireAt?: number | null, refunded?: boolean | null, refunding?: boolean | null, accepted?: boolean | null, active?: boolean | null, error?: string | null, startTime?: string | null, activeSubscription?: string | null, iosSub?: any | null, iosErr?: string | null, androidSub?: any | null, androidErr?: string | null, rebillyErr?: string | null, eligibleMessage?: string | null, eligibleMonths?: number | null, eligibleAmount?: number | null, collectedAmount?: number | null, collectedAmountRange?: any | null, collectedCount?: number | null, droppedAmount?: number | null, dropCount?: number | null, redeemCount?: number | null, xyoCollected?: number | null, resetXyoCollectedAmount?: number | null, rebillySub?: { __typename?: 'RebillySub', subscriptionId?: string | null, transactions?: Array<{ __typename?: 'RebillyTrans', createdTime?: string | null, transactionId: string, amount: number }> | null } | null } | null };

export type ProcessRefundRequestMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ProcessRefundRequestMutation = { __typename?: 'Mutation', processRefundRequest?: { __typename?: 'RefundRequest', id?: string | null, url?: string | null, uid?: string | null, email?: string | null, photoURL?: string | null, date?: string | null, expireAt?: number | null, refunded?: boolean | null, refunding?: boolean | null, accepted?: boolean | null, active?: boolean | null, error?: string | null, startTime?: string | null, activeSubscription?: string | null, iosSub?: any | null, iosErr?: string | null, androidSub?: any | null, androidErr?: string | null, rebillyErr?: string | null, eligibleMessage?: string | null, eligibleMonths?: number | null, eligibleAmount?: number | null, collectedAmount?: number | null, collectedAmountRange?: any | null, collectedCount?: number | null, droppedAmount?: number | null, dropCount?: number | null, redeemCount?: number | null, xyoCollected?: number | null, resetXyoCollectedAmount?: number | null, rebillySub?: { __typename?: 'RebillySub', subscriptionId?: string | null, transactions?: Array<{ __typename?: 'RebillyTrans', createdTime?: string | null, transactionId: string, amount: number }> | null } | null } | null };

export type ProcessedRefundRequestMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ProcessedRefundRequestMutation = { __typename?: 'Mutation', processedRefundRequest?: { __typename?: 'RefundRequest', id?: string | null, url?: string | null, uid?: string | null, email?: string | null, photoURL?: string | null, date?: string | null, expireAt?: number | null, refunded?: boolean | null, refunding?: boolean | null, accepted?: boolean | null, active?: boolean | null, error?: string | null, startTime?: string | null, activeSubscription?: string | null, iosSub?: any | null, iosErr?: string | null, androidSub?: any | null, androidErr?: string | null, rebillyErr?: string | null, eligibleMessage?: string | null, eligibleMonths?: number | null, eligibleAmount?: number | null, collectedAmount?: number | null, collectedAmountRange?: any | null, collectedCount?: number | null, droppedAmount?: number | null, dropCount?: number | null, redeemCount?: number | null, xyoCollected?: number | null, resetXyoCollectedAmount?: number | null, rebillySub?: { __typename?: 'RebillySub', subscriptionId?: string | null, transactions?: Array<{ __typename?: 'RebillyTrans', createdTime?: string | null, transactionId: string, amount: number }> | null } | null } | null };

export type DeactivateRefundRequestMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeactivateRefundRequestMutation = { __typename?: 'Mutation', deactivateRefundRequest?: { __typename?: 'RefundRequest', id?: string | null, url?: string | null, uid?: string | null, email?: string | null, photoURL?: string | null, date?: string | null, expireAt?: number | null, refunded?: boolean | null, refunding?: boolean | null, accepted?: boolean | null, active?: boolean | null, error?: string | null, startTime?: string | null, activeSubscription?: string | null, iosSub?: any | null, iosErr?: string | null, androidSub?: any | null, androidErr?: string | null, rebillyErr?: string | null, eligibleMessage?: string | null, eligibleMonths?: number | null, eligibleAmount?: number | null, collectedAmount?: number | null, collectedAmountRange?: any | null, collectedCount?: number | null, droppedAmount?: number | null, dropCount?: number | null, redeemCount?: number | null, xyoCollected?: number | null, resetXyoCollectedAmount?: number | null, rebillySub?: { __typename?: 'RebillySub', subscriptionId?: string | null, transactions?: Array<{ __typename?: 'RebillyTrans', createdTime?: string | null, transactionId: string, amount: number }> | null } | null } | null };

export type ActivateRefundRequestMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ActivateRefundRequestMutation = { __typename?: 'Mutation', activateRefundRequest?: { __typename?: 'RefundRequest', id?: string | null, url?: string | null, uid?: string | null, email?: string | null, photoURL?: string | null, date?: string | null, expireAt?: number | null, refunded?: boolean | null, refunding?: boolean | null, accepted?: boolean | null, active?: boolean | null, error?: string | null, startTime?: string | null, activeSubscription?: string | null, iosSub?: any | null, iosErr?: string | null, androidSub?: any | null, androidErr?: string | null, rebillyErr?: string | null, eligibleMessage?: string | null, eligibleMonths?: number | null, eligibleAmount?: number | null, collectedAmount?: number | null, collectedAmountRange?: any | null, collectedCount?: number | null, droppedAmount?: number | null, dropCount?: number | null, redeemCount?: number | null, xyoCollected?: number | null, resetXyoCollectedAmount?: number | null, rebillySub?: { __typename?: 'RebillySub', subscriptionId?: string | null, transactions?: Array<{ __typename?: 'RebillyTrans', createdTime?: string | null, transactionId: string, amount: number }> | null } | null } | null };

export const ShipStationAddressFragmentDoc = gql`
    fragment ShipStationAddress on ShipStationAddress {
  name
  company
  street1
  street2
  street3
  city
  state
  postalCode
  country
  phone
  residential
  addressVerified
}
    `;
export const ShipStationOrderItemFragmentDoc = gql`
    fragment ShipStationOrderItem on ShipStationOrderItem {
  orderItemId
  lineItemKey
  sku
  name
  imageUrl
  weight {
    value
    units
  }
  quantity
  unitPrice
  taxAmount
  shippingAmount
  warehouseLocation
  options {
    name
    value
  }
  productId
  fulfillmentSku
  adjustment
  upc
  createDate
  modifyDate
}
    `;
export const ShipStationInsuranceOptionsFragmentDoc = gql`
    fragment ShipStationInsuranceOptions on ShipStationInsuranceOptions {
  provider
  insureShipment
  insuredValue
}
    `;
export const ShipStationInternationalOptionsFragmentDoc = gql`
    fragment ShipStationInternationalOptions on ShipStationInternationalOptions {
  contents
  customsItems {
    customsItemId
    description
    quantity
    value
    harmonizedTariffCode
    countryOfOrigin
  }
  nonDelivery
}
    `;
export const ShipStationAdvancedOptionsFragmentDoc = gql`
    fragment ShipStationAdvancedOptions on ShipStationAdvancedOptions {
  warehouseId
  nonMachinable
  saturdayDelivery
  containsAlcohol
  storeId
  customField1
  customField2
  customField3
  source
  mergedOrSplit
  mergedIds
  parentId
  billToParty
  billToAccount
  billToPostalCode
  billToCountryCode
  billToMyOtherAccount
}
    `;
export const ShipStationOrderFragmentDoc = gql`
    fragment ShipStationOrder on ShipStationOrder {
  id
  orderId
  orderNumber
  orderKey
  orderDate
  createDate
  modifyDate
  paymentDate
  shipByDate
  orderStatus
  customerId
  customerUsername
  customerEmail
  billTo {
    ...ShipStationAddress
  }
  shipTo {
    ...ShipStationAddress
  }
  items {
    ...ShipStationOrderItem
  }
  orderTotal
  amountPaid
  taxAmount
  shippingAmount
  customerNotes
  internalNotes
  gift
  giftMessage
  paymentMethod
  requestedShippingService
  carrierCode
  serviceCode
  packageCode
  confirmation
  shipDate
  holdUntilDate
  weight {
    value
    units
  }
  dimensions {
    length
    width
    height
    units
  }
  insuranceOptions {
    ...ShipStationInsuranceOptions
  }
  internationalOptions {
    ...ShipStationInternationalOptions
  }
  advancedOptions {
    ...ShipStationAdvancedOptions
  }
  tagIds
  userId
  externallyFulfilled
  externallyFulfilledBy
}
    ${ShipStationAddressFragmentDoc}
${ShipStationOrderItemFragmentDoc}
${ShipStationInsuranceOptionsFragmentDoc}
${ShipStationInternationalOptionsFragmentDoc}
${ShipStationAdvancedOptionsFragmentDoc}`;
export const ShipStationShipmentFragmentDoc = gql`
    fragment ShipStationShipment on ShipStationShipment {
  id
  shipmentId
  orderId
  orderKey
  userId
  orderNumber
  createDate
  shipDate
  shipmentCost
  insuranceCost
  trackingNumber
  isReturnLabel
  customerEmail
  batchNumber
  carrierCode
  serviceCode
  packageCode
  confirmation
  warehouseId
  voided
  voidDate
  marketplaceNotified
  notifyErrorMessage
  shipTo {
    ...ShipStationAddress
  }
  weight {
    value
    units
  }
  dimensions {
    length
    width
    height
    units
  }
  insuranceOptions {
    ...ShipStationInsuranceOptions
  }
  advancedOptions {
    ...ShipStationAdvancedOptions
  }
  shipmentItems {
    ...ShipStationOrderItem
  }
  labelData
  formData
}
    ${ShipStationAddressFragmentDoc}
${ShipStationInsuranceOptionsFragmentDoc}
${ShipStationAdvancedOptionsFragmentDoc}
${ShipStationOrderItemFragmentDoc}`;
export const ShipStationProductFragmentDoc = gql`
    fragment ShipStationProduct on ShipStationProduct {
  id
  productId
  sku
  name
  price
  defaultCost
  length
  width
  height
  weightOz
  internalNotes
  fulfillmentSku
  createDate
  modifyDate
  active
  productCategory {
    categoryId
    name
  }
  productType
  warehouseLocation
  defaultCarrierCode
  defaultServiceCode
  defaultPackageCode
  defaultIntlCarrierCode
  defaultIntlServiceCode
  defaultIntlPackageCode
  defaultConfirmation
  defaultIntlConfirmation
  customsDescription
  customsValue
  customsTariffNo
  customsCountryCode
  noCustoms
  tags {
    tagId
    name
  }
}
    `;
export const ShipStationFulfillmentFragmentDoc = gql`
    fragment ShipStationFulfillment on ShipStationFulfillment {
  id
  fulfillmentId
  orderId
  orderNumber
  userId
  customerEmail
  trackingNumber
  createDate
  shipDate
  voidDate
  deliveryDate
  carrierCode
  fulfillmentProviderCode
  fulfillmentServiceCode
  fulfillmentFee
  voidRequested
  voided
  marketplaceNotified
  notifyErrorMessage
  shipTo {
    ...ShipStationAddress
  }
}
    ${ShipStationAddressFragmentDoc}`;
export const ShipStationCarrierFragmentDoc = gql`
    fragment ShipStationCarrier on ShipStationCarrier {
  id
  name
  code
  accountNumber
  requiresFundedAccount
  balance
  nickname
  shippingProviderId
  primary
}
    `;
export const ShipStationCarrierPackageFragmentDoc = gql`
    fragment ShipStationCarrierPackage on ShipStationCarrierPackage {
  carrierCode
  code
  name
  domestic
  international
}
    `;
export const ShipStationCarrierServiceFragmentDoc = gql`
    fragment ShipStationCarrierService on ShipStationCarrierService {
  carrierCode
  code
  name
  domestic
  international
}
    `;
export const ShipStationStoreFragmentDoc = gql`
    fragment ShipStationStore on ShipStationStore {
  id
  storeId
  storeName
  marketplaceId
  marketplaceName
  accountName
  email
  integrationUrl
  active
  companyName
  phone
  publicEmail
  website
  refreshDate
  lastRefreshAttempt
  createDate
  modifyDate
  autoRefresh
}
    `;
export const ShipStationWarehouseFragmentDoc = gql`
    fragment ShipStationWarehouse on ShipStationWarehouse {
  id
  warehouseId
  warehouseName
  originAddress {
    ...ShipStationAddress
  }
  returnAddress {
    ...ShipStationAddress
  }
  createDate
  isDefault
}
    ${ShipStationAddressFragmentDoc}`;
export const SendCloudParcelFragmentDoc = gql`
    fragment SendCloudParcel on SendCloudParcel {
  id
  name
  company_name
  address
  address2
  address_divided {
    street
    house_number
  }
  city
  postal_code
  telephone
  email
  date_created
  tracking_number
  tracking_url
  weight
  label {
    normal_printer
    label_printer
  }
  customs_declaration
  status {
    id
    message
  }
  data
  country {
    iso_3
    iso_2
    name
  }
  shipment {
    id
    name
  }
  order_number
  shipment_uuid
  external_order_id
  external_shipment_id
  external_reference
  parcel_items {
    description
    hs_code
    origin_country
    product_id
    properties
    quantity
    sku
    value
    weight
  }
}
    `;
export const UserInfoFragmentDoc = gql`
    fragment UserInfo on UserInfo {
  lastMaphash
  xyoRedeemed
  xyoPending
  xyoRedeemPending
  xyoDropped
  xyoCollected
  xyoGifted
  xyoGeomined
  xyoSurveys
  xyoInbrainRevoked
  xyoPickedUp
  xyoGeoclaimed
  xyoHodlRewards
  xyoBossBalance
  xyoBossGifted
  xyoExpired
  xyoRestored
  xyoSweepstakes
  xyoEnabled
  hodlLastCollectedYYYYMMDD
  recordVersion
  remineMarker
  recentCount
  color
  referrer
  checkInDate
  created
  appVersion
  nfcScanCount
  referrerUid
  addedToDrip
  mineCountNoSentinel
  ibeacons
  lastMinedWithSentinelBle
  remineCount
  subscriptionInfo
  osDevMode
  ownerUID
  osVersion
  mineCount
  recentMarker
  mineCountSentinel
  direction
  activeSubscription
  activeSubscriptionLock
  subActive
  suspended
  ip
  lastMinedYYYYMMDD
  verifiedAddressesTotal
  sentinels
  random
  liteOk
  masterOk
  kycComplete
  username
  ethAddress
  nftAddress
  lastKnownAddress
  coinbaseEmail
  shipStreetAddress
  webDropsAllowed
  webDropsAmountMax
  webDropsQuantityMax
  lastMined
  profileImageExists
  profileImageUpdated
  subOrder
  customerId
  lastSync
  ssid
  os
  deviceId
  deviceIds
  deviceName
  speed
  appsflyerId
  didReceiveReturningUserGift
  driveAnalysisQualified
  didReceiveZendrizeDrop
  phoneNumber
  profileMultiplier
}
    `;
export const AddressFragmentDoc = gql`
    fragment Address on Address {
  firstName
  lastName
  country
  address
  emails {
    value
  }
}
    `;
export const CustomerFragmentDoc = gql`
    fragment Customer on Customer {
  id
  email
  defaultPaymentInstrument {
    paymentCardId
  }
  paymentCount
  primaryAddress {
    ...Address
  }
}
    ${AddressFragmentDoc}`;
export const RebillyTransactionFragmentDoc = gql`
    fragment RebillyTransaction on Transaction {
  id
  amount
  status
  result
  createdTime
  gateway
  currency
}
    `;
export const InvoiceFragmentDoc = gql`
    fragment Invoice on Invoice {
  id
  dueTime
  issuedTime
  abandonedTime
  voidedTime
  paidTime
  currency
  invoiceNumber
  customerId
  websiteId
  organizationId
  subscriptionId
  billingAddress {
    ...Address
  }
  deliveryAddress {
    ...Address
  }
  amount
  currency
  subtotalAmount
  shippingAmount
  poNumber
  notes
  items {
    id
    type
    description
    unitPrice
  }
  discountAmount
  discounts
  taxAmount
  taxes
  transactions {
    ...RebillyTransaction
  }
  autopayScheduledTime
  autopayRetryNumber
  status
  delinquentCollectionPeriod
  collectionPeriod
  createdTime
  updatedTime
}
    ${AddressFragmentDoc}
${RebillyTransactionFragmentDoc}`;
export const RebillySubscriptionFragmentDoc = gql`
    fragment RebillySubscription on RebillySubscription {
  id
  planType
  planId
  status
  billingStatus
  activationTime
  canceledTime
  renewalTime
  startTime
  upcomingInvoice {
    ...Invoice
  }
  recentInvoice {
    ...Invoice
  }
  initialInvoice {
    ...Invoice
  }
}
    ${InvoiceFragmentDoc}`;
export const CardFragmentDoc = gql`
    fragment Card on PaymentCard {
  id
  bankCountry
  last4
  expYear
  expMonth
  brand
  status
}
    `;
export const KycFragmentDoc = gql`
    fragment Kyc on KycDocument {
  id
  fileId
  customerId
  documentType
  status
  createdTime
  updatedTime
  processedTime
  rejectionReason {
    type
    message
  }
  documentMatches {
    score
    data
  }
}
    `;
export const KycMaxAttemptsFragmentDoc = gql`
    fragment KycMaxAttempts on KycMaxAttempts {
  attempts
  attemptsToday
  maxAttempts
  maxAttemptsToday
}
    `;
export const CumulativeSubscriptionCountFragmentDoc = gql`
    fragment CumulativeSubscriptionCount on CumulativeSubscriptionCount {
  day
  planId
  cumulativeCount
  newCount
  canceledCount
  netCount
}
    `;
export const CumulativeTransactionCountFragmentDoc = gql`
    fragment CumulativeTransactionCount on CumulativeTransactionCount {
  aggregationFieldValue
  authApprovedThroughput
  authApprovalCount
  salesAverage
  salesCount
  salesValue
  disputesRate
  disputesCount
  refundsCount
  refundsValue
  amount
  count
}
    `;
export const RefundRequestFragmentDoc = gql`
    fragment RefundRequest on RefundRequest {
  id
  url
  uid
  email
  photoURL
  date
  expireAt
  refunded
  refunding
  accepted
  active
  error
  startTime
  activeSubscription
  iosSub
  iosErr
  androidSub
  androidErr
  rebillySub {
    subscriptionId
    transactions {
      createdTime
      transactionId
      amount
    }
  }
  rebillyErr
  eligibleMessage
  eligibleMonths
  eligibleAmount
  collectedAmount
  collectedAmountRange
  collectedCount
  droppedAmount
  dropCount
  redeemCount
  xyoCollected
  resetXyoCollectedAmount
}
    `;
export const ShipStationCancelOrderDocument = gql`
    mutation ShipStationCancelOrder($orderId: Float!) {
  cancelOrder(orderId: $orderId) {
    ...ShipStationOrder
  }
}
    ${ShipStationOrderFragmentDoc}`;
export type ShipStationCancelOrderMutationFn = Apollo.MutationFunction<ShipStationCancelOrderMutation, ShipStationCancelOrderMutationVariables>;

/**
 * __useShipStationCancelOrderMutation__
 *
 * To run a mutation, you first call `useShipStationCancelOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShipStationCancelOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shipStationCancelOrderMutation, { data, loading, error }] = useShipStationCancelOrderMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useShipStationCancelOrderMutation(baseOptions?: Apollo.MutationHookOptions<ShipStationCancelOrderMutation, ShipStationCancelOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ShipStationCancelOrderMutation, ShipStationCancelOrderMutationVariables>(ShipStationCancelOrderDocument, options);
      }
export type ShipStationCancelOrderMutationHookResult = ReturnType<typeof useShipStationCancelOrderMutation>;
export type ShipStationCancelOrderMutationResult = Apollo.MutationResult<ShipStationCancelOrderMutation>;
export type ShipStationCancelOrderMutationOptions = Apollo.BaseMutationOptions<ShipStationCancelOrderMutation, ShipStationCancelOrderMutationVariables>;
export const ShipStationDeleteOrderDocument = gql`
    mutation ShipStationDeleteOrder($orderId: Float!) {
  deleteOrder(orderId: $orderId) {
    ...ShipStationOrder
  }
}
    ${ShipStationOrderFragmentDoc}`;
export type ShipStationDeleteOrderMutationFn = Apollo.MutationFunction<ShipStationDeleteOrderMutation, ShipStationDeleteOrderMutationVariables>;

/**
 * __useShipStationDeleteOrderMutation__
 *
 * To run a mutation, you first call `useShipStationDeleteOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShipStationDeleteOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shipStationDeleteOrderMutation, { data, loading, error }] = useShipStationDeleteOrderMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useShipStationDeleteOrderMutation(baseOptions?: Apollo.MutationHookOptions<ShipStationDeleteOrderMutation, ShipStationDeleteOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ShipStationDeleteOrderMutation, ShipStationDeleteOrderMutationVariables>(ShipStationDeleteOrderDocument, options);
      }
export type ShipStationDeleteOrderMutationHookResult = ReturnType<typeof useShipStationDeleteOrderMutation>;
export type ShipStationDeleteOrderMutationResult = Apollo.MutationResult<ShipStationDeleteOrderMutation>;
export type ShipStationDeleteOrderMutationOptions = Apollo.BaseMutationOptions<ShipStationDeleteOrderMutation, ShipStationDeleteOrderMutationVariables>;
export const ShipStationHoldOrderDocument = gql`
    mutation ShipStationHoldOrder($orderId: Float!, $holdUntilDate: String!) {
  holdOrder(orderId: $orderId, holdUntilDate: $holdUntilDate) {
    ...ShipStationOrder
  }
}
    ${ShipStationOrderFragmentDoc}`;
export type ShipStationHoldOrderMutationFn = Apollo.MutationFunction<ShipStationHoldOrderMutation, ShipStationHoldOrderMutationVariables>;

/**
 * __useShipStationHoldOrderMutation__
 *
 * To run a mutation, you first call `useShipStationHoldOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShipStationHoldOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shipStationHoldOrderMutation, { data, loading, error }] = useShipStationHoldOrderMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      holdUntilDate: // value for 'holdUntilDate'
 *   },
 * });
 */
export function useShipStationHoldOrderMutation(baseOptions?: Apollo.MutationHookOptions<ShipStationHoldOrderMutation, ShipStationHoldOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ShipStationHoldOrderMutation, ShipStationHoldOrderMutationVariables>(ShipStationHoldOrderDocument, options);
      }
export type ShipStationHoldOrderMutationHookResult = ReturnType<typeof useShipStationHoldOrderMutation>;
export type ShipStationHoldOrderMutationResult = Apollo.MutationResult<ShipStationHoldOrderMutation>;
export type ShipStationHoldOrderMutationOptions = Apollo.BaseMutationOptions<ShipStationHoldOrderMutation, ShipStationHoldOrderMutationVariables>;
export const ShipStationRestoreOrderDocument = gql`
    mutation ShipStationRestoreOrder($orderId: Float!) {
  restoreOrderFromHold(orderId: $orderId) {
    ...ShipStationOrder
  }
}
    ${ShipStationOrderFragmentDoc}`;
export type ShipStationRestoreOrderMutationFn = Apollo.MutationFunction<ShipStationRestoreOrderMutation, ShipStationRestoreOrderMutationVariables>;

/**
 * __useShipStationRestoreOrderMutation__
 *
 * To run a mutation, you first call `useShipStationRestoreOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShipStationRestoreOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shipStationRestoreOrderMutation, { data, loading, error }] = useShipStationRestoreOrderMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useShipStationRestoreOrderMutation(baseOptions?: Apollo.MutationHookOptions<ShipStationRestoreOrderMutation, ShipStationRestoreOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ShipStationRestoreOrderMutation, ShipStationRestoreOrderMutationVariables>(ShipStationRestoreOrderDocument, options);
      }
export type ShipStationRestoreOrderMutationHookResult = ReturnType<typeof useShipStationRestoreOrderMutation>;
export type ShipStationRestoreOrderMutationResult = Apollo.MutationResult<ShipStationRestoreOrderMutation>;
export type ShipStationRestoreOrderMutationOptions = Apollo.BaseMutationOptions<ShipStationRestoreOrderMutation, ShipStationRestoreOrderMutationVariables>;
export const ShipStationVoidLabelDocument = gql`
    mutation ShipStationVoidLabel($orderId: Float!, $shipmentId: Float!) {
  voidLabel(orderId: $orderId, shipmentId: $shipmentId)
}
    `;
export type ShipStationVoidLabelMutationFn = Apollo.MutationFunction<ShipStationVoidLabelMutation, ShipStationVoidLabelMutationVariables>;

/**
 * __useShipStationVoidLabelMutation__
 *
 * To run a mutation, you first call `useShipStationVoidLabelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShipStationVoidLabelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shipStationVoidLabelMutation, { data, loading, error }] = useShipStationVoidLabelMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      shipmentId: // value for 'shipmentId'
 *   },
 * });
 */
export function useShipStationVoidLabelMutation(baseOptions?: Apollo.MutationHookOptions<ShipStationVoidLabelMutation, ShipStationVoidLabelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ShipStationVoidLabelMutation, ShipStationVoidLabelMutationVariables>(ShipStationVoidLabelDocument, options);
      }
export type ShipStationVoidLabelMutationHookResult = ReturnType<typeof useShipStationVoidLabelMutation>;
export type ShipStationVoidLabelMutationResult = Apollo.MutationResult<ShipStationVoidLabelMutation>;
export type ShipStationVoidLabelMutationOptions = Apollo.BaseMutationOptions<ShipStationVoidLabelMutation, ShipStationVoidLabelMutationVariables>;
export const ShipStationCalculateRatesDocument = gql`
    mutation ShipStationCalculateRates($input: CalculateRatesInput!) {
  calculateRates(input: $input) {
    serviceName
    serviceCode
    shipmentCost
    otherCost
  }
}
    `;
export type ShipStationCalculateRatesMutationFn = Apollo.MutationFunction<ShipStationCalculateRatesMutation, ShipStationCalculateRatesMutationVariables>;

/**
 * __useShipStationCalculateRatesMutation__
 *
 * To run a mutation, you first call `useShipStationCalculateRatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShipStationCalculateRatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shipStationCalculateRatesMutation, { data, loading, error }] = useShipStationCalculateRatesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useShipStationCalculateRatesMutation(baseOptions?: Apollo.MutationHookOptions<ShipStationCalculateRatesMutation, ShipStationCalculateRatesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ShipStationCalculateRatesMutation, ShipStationCalculateRatesMutationVariables>(ShipStationCalculateRatesDocument, options);
      }
export type ShipStationCalculateRatesMutationHookResult = ReturnType<typeof useShipStationCalculateRatesMutation>;
export type ShipStationCalculateRatesMutationResult = Apollo.MutationResult<ShipStationCalculateRatesMutation>;
export type ShipStationCalculateRatesMutationOptions = Apollo.BaseMutationOptions<ShipStationCalculateRatesMutation, ShipStationCalculateRatesMutationVariables>;
export const ShipStationMarkOrderAsShippedDocument = gql`
    mutation ShipStationMarkOrderAsShipped($input: MarkShippedInput!) {
  markOrderAsShipped(input: $input) {
    orderId
    carrierCode
    shipDate
    trackingNumber
    notifyCustomer
    notifySalesChannel
  }
}
    `;
export type ShipStationMarkOrderAsShippedMutationFn = Apollo.MutationFunction<ShipStationMarkOrderAsShippedMutation, ShipStationMarkOrderAsShippedMutationVariables>;

/**
 * __useShipStationMarkOrderAsShippedMutation__
 *
 * To run a mutation, you first call `useShipStationMarkOrderAsShippedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShipStationMarkOrderAsShippedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shipStationMarkOrderAsShippedMutation, { data, loading, error }] = useShipStationMarkOrderAsShippedMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useShipStationMarkOrderAsShippedMutation(baseOptions?: Apollo.MutationHookOptions<ShipStationMarkOrderAsShippedMutation, ShipStationMarkOrderAsShippedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ShipStationMarkOrderAsShippedMutation, ShipStationMarkOrderAsShippedMutationVariables>(ShipStationMarkOrderAsShippedDocument, options);
      }
export type ShipStationMarkOrderAsShippedMutationHookResult = ReturnType<typeof useShipStationMarkOrderAsShippedMutation>;
export type ShipStationMarkOrderAsShippedMutationResult = Apollo.MutationResult<ShipStationMarkOrderAsShippedMutation>;
export type ShipStationMarkOrderAsShippedMutationOptions = Apollo.BaseMutationOptions<ShipStationMarkOrderAsShippedMutation, ShipStationMarkOrderAsShippedMutationVariables>;
export const ShipStationCreateLabelForOrderDocument = gql`
    mutation ShipStationCreateLabelForOrder($input: CreateLabelInput!) {
  createLabelForOrder(input: $input) {
    shipmentId
    shipmentCost
    insuranceCost
    trackingNumber
    labelData
    formData
  }
}
    `;
export type ShipStationCreateLabelForOrderMutationFn = Apollo.MutationFunction<ShipStationCreateLabelForOrderMutation, ShipStationCreateLabelForOrderMutationVariables>;

/**
 * __useShipStationCreateLabelForOrderMutation__
 *
 * To run a mutation, you first call `useShipStationCreateLabelForOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShipStationCreateLabelForOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shipStationCreateLabelForOrderMutation, { data, loading, error }] = useShipStationCreateLabelForOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useShipStationCreateLabelForOrderMutation(baseOptions?: Apollo.MutationHookOptions<ShipStationCreateLabelForOrderMutation, ShipStationCreateLabelForOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ShipStationCreateLabelForOrderMutation, ShipStationCreateLabelForOrderMutationVariables>(ShipStationCreateLabelForOrderDocument, options);
      }
export type ShipStationCreateLabelForOrderMutationHookResult = ReturnType<typeof useShipStationCreateLabelForOrderMutation>;
export type ShipStationCreateLabelForOrderMutationResult = Apollo.MutationResult<ShipStationCreateLabelForOrderMutation>;
export type ShipStationCreateLabelForOrderMutationOptions = Apollo.BaseMutationOptions<ShipStationCreateLabelForOrderMutation, ShipStationCreateLabelForOrderMutationVariables>;
export const ShipStationUpdateOrderAddressDocument = gql`
    mutation ShipStationUpdateOrderAddress($orderId: Float!, $input: OrderAddressInput!) {
  updateOrderAddress(orderId: $orderId, input: $input) {
    ...ShipStationOrder
  }
}
    ${ShipStationOrderFragmentDoc}`;
export type ShipStationUpdateOrderAddressMutationFn = Apollo.MutationFunction<ShipStationUpdateOrderAddressMutation, ShipStationUpdateOrderAddressMutationVariables>;

/**
 * __useShipStationUpdateOrderAddressMutation__
 *
 * To run a mutation, you first call `useShipStationUpdateOrderAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShipStationUpdateOrderAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shipStationUpdateOrderAddressMutation, { data, loading, error }] = useShipStationUpdateOrderAddressMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useShipStationUpdateOrderAddressMutation(baseOptions?: Apollo.MutationHookOptions<ShipStationUpdateOrderAddressMutation, ShipStationUpdateOrderAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ShipStationUpdateOrderAddressMutation, ShipStationUpdateOrderAddressMutationVariables>(ShipStationUpdateOrderAddressDocument, options);
      }
export type ShipStationUpdateOrderAddressMutationHookResult = ReturnType<typeof useShipStationUpdateOrderAddressMutation>;
export type ShipStationUpdateOrderAddressMutationResult = Apollo.MutationResult<ShipStationUpdateOrderAddressMutation>;
export type ShipStationUpdateOrderAddressMutationOptions = Apollo.BaseMutationOptions<ShipStationUpdateOrderAddressMutation, ShipStationUpdateOrderAddressMutationVariables>;
export const ShipStationUpdateOrderItemsDocument = gql`
    mutation ShipStationUpdateOrderItems($orderId: Float!, $items: [OrderItemInput!]!) {
  updateOrderItems(orderId: $orderId, items: $items) {
    ...ShipStationOrder
  }
}
    ${ShipStationOrderFragmentDoc}`;
export type ShipStationUpdateOrderItemsMutationFn = Apollo.MutationFunction<ShipStationUpdateOrderItemsMutation, ShipStationUpdateOrderItemsMutationVariables>;

/**
 * __useShipStationUpdateOrderItemsMutation__
 *
 * To run a mutation, you first call `useShipStationUpdateOrderItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShipStationUpdateOrderItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shipStationUpdateOrderItemsMutation, { data, loading, error }] = useShipStationUpdateOrderItemsMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      items: // value for 'items'
 *   },
 * });
 */
export function useShipStationUpdateOrderItemsMutation(baseOptions?: Apollo.MutationHookOptions<ShipStationUpdateOrderItemsMutation, ShipStationUpdateOrderItemsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ShipStationUpdateOrderItemsMutation, ShipStationUpdateOrderItemsMutationVariables>(ShipStationUpdateOrderItemsDocument, options);
      }
export type ShipStationUpdateOrderItemsMutationHookResult = ReturnType<typeof useShipStationUpdateOrderItemsMutation>;
export type ShipStationUpdateOrderItemsMutationResult = Apollo.MutationResult<ShipStationUpdateOrderItemsMutation>;
export type ShipStationUpdateOrderItemsMutationOptions = Apollo.BaseMutationOptions<ShipStationUpdateOrderItemsMutation, ShipStationUpdateOrderItemsMutationVariables>;
export const ShipStationUpdateOrderNotesDocument = gql`
    mutation ShipStationUpdateOrderNotes($orderId: Float!, $input: OrderNotesInput!) {
  updateOrderNotes(orderId: $orderId, input: $input) {
    ...ShipStationOrder
  }
}
    ${ShipStationOrderFragmentDoc}`;
export type ShipStationUpdateOrderNotesMutationFn = Apollo.MutationFunction<ShipStationUpdateOrderNotesMutation, ShipStationUpdateOrderNotesMutationVariables>;

/**
 * __useShipStationUpdateOrderNotesMutation__
 *
 * To run a mutation, you first call `useShipStationUpdateOrderNotesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShipStationUpdateOrderNotesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shipStationUpdateOrderNotesMutation, { data, loading, error }] = useShipStationUpdateOrderNotesMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useShipStationUpdateOrderNotesMutation(baseOptions?: Apollo.MutationHookOptions<ShipStationUpdateOrderNotesMutation, ShipStationUpdateOrderNotesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ShipStationUpdateOrderNotesMutation, ShipStationUpdateOrderNotesMutationVariables>(ShipStationUpdateOrderNotesDocument, options);
      }
export type ShipStationUpdateOrderNotesMutationHookResult = ReturnType<typeof useShipStationUpdateOrderNotesMutation>;
export type ShipStationUpdateOrderNotesMutationResult = Apollo.MutationResult<ShipStationUpdateOrderNotesMutation>;
export type ShipStationUpdateOrderNotesMutationOptions = Apollo.BaseMutationOptions<ShipStationUpdateOrderNotesMutation, ShipStationUpdateOrderNotesMutationVariables>;
export const CreateSendCloudLabelsForOrderDocument = gql`
    mutation createSendCloudLabelsForOrder($orderNumbers: [String!]!) {
  createSendCloudLabelsForOrder(orderNumbers: $orderNumbers) {
    error
    parcelId
    parcel {
      name
      order_number
      country {
        name
      }
      tracking_number
    }
    normal_printer
    label_printer
  }
}
    `;
export type CreateSendCloudLabelsForOrderMutationFn = Apollo.MutationFunction<CreateSendCloudLabelsForOrderMutation, CreateSendCloudLabelsForOrderMutationVariables>;

/**
 * __useCreateSendCloudLabelsForOrderMutation__
 *
 * To run a mutation, you first call `useCreateSendCloudLabelsForOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSendCloudLabelsForOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSendCloudLabelsForOrderMutation, { data, loading, error }] = useCreateSendCloudLabelsForOrderMutation({
 *   variables: {
 *      orderNumbers: // value for 'orderNumbers'
 *   },
 * });
 */
export function useCreateSendCloudLabelsForOrderMutation(baseOptions?: Apollo.MutationHookOptions<CreateSendCloudLabelsForOrderMutation, CreateSendCloudLabelsForOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSendCloudLabelsForOrderMutation, CreateSendCloudLabelsForOrderMutationVariables>(CreateSendCloudLabelsForOrderDocument, options);
      }
export type CreateSendCloudLabelsForOrderMutationHookResult = ReturnType<typeof useCreateSendCloudLabelsForOrderMutation>;
export type CreateSendCloudLabelsForOrderMutationResult = Apollo.MutationResult<CreateSendCloudLabelsForOrderMutation>;
export type CreateSendCloudLabelsForOrderMutationOptions = Apollo.BaseMutationOptions<CreateSendCloudLabelsForOrderMutation, CreateSendCloudLabelsForOrderMutationVariables>;
export const BatchCreateSendCloudLabelsForOrderDocument = gql`
    mutation batchCreateSendCloudLabelsForOrder($orderNumbers: [String!]!) {
  batchCreateSendCloudLabelsForOrder(orderNumbers: $orderNumbers) {
    batch
    labels {
      error
      parcelId
      parcel {
        name
        order_number
        country {
          name
        }
        tracking_number
      }
      normal_printer
      label_printer
    }
  }
}
    `;
export type BatchCreateSendCloudLabelsForOrderMutationFn = Apollo.MutationFunction<BatchCreateSendCloudLabelsForOrderMutation, BatchCreateSendCloudLabelsForOrderMutationVariables>;

/**
 * __useBatchCreateSendCloudLabelsForOrderMutation__
 *
 * To run a mutation, you first call `useBatchCreateSendCloudLabelsForOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBatchCreateSendCloudLabelsForOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [batchCreateSendCloudLabelsForOrderMutation, { data, loading, error }] = useBatchCreateSendCloudLabelsForOrderMutation({
 *   variables: {
 *      orderNumbers: // value for 'orderNumbers'
 *   },
 * });
 */
export function useBatchCreateSendCloudLabelsForOrderMutation(baseOptions?: Apollo.MutationHookOptions<BatchCreateSendCloudLabelsForOrderMutation, BatchCreateSendCloudLabelsForOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BatchCreateSendCloudLabelsForOrderMutation, BatchCreateSendCloudLabelsForOrderMutationVariables>(BatchCreateSendCloudLabelsForOrderDocument, options);
      }
export type BatchCreateSendCloudLabelsForOrderMutationHookResult = ReturnType<typeof useBatchCreateSendCloudLabelsForOrderMutation>;
export type BatchCreateSendCloudLabelsForOrderMutationResult = Apollo.MutationResult<BatchCreateSendCloudLabelsForOrderMutation>;
export type BatchCreateSendCloudLabelsForOrderMutationOptions = Apollo.BaseMutationOptions<BatchCreateSendCloudLabelsForOrderMutation, BatchCreateSendCloudLabelsForOrderMutationVariables>;
export const SendToSendCloudDocument = gql`
    mutation SendToSendCloud($orderId: Float!) {
  sendToSendCloud(orderId: $orderId) {
    orderId
    order {
      ...ShipStationOrder
    }
    parcel {
      ...SendCloudParcel
    }
  }
}
    ${ShipStationOrderFragmentDoc}
${SendCloudParcelFragmentDoc}`;
export type SendToSendCloudMutationFn = Apollo.MutationFunction<SendToSendCloudMutation, SendToSendCloudMutationVariables>;

/**
 * __useSendToSendCloudMutation__
 *
 * To run a mutation, you first call `useSendToSendCloudMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendToSendCloudMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendToSendCloudMutation, { data, loading, error }] = useSendToSendCloudMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useSendToSendCloudMutation(baseOptions?: Apollo.MutationHookOptions<SendToSendCloudMutation, SendToSendCloudMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendToSendCloudMutation, SendToSendCloudMutationVariables>(SendToSendCloudDocument, options);
      }
export type SendToSendCloudMutationHookResult = ReturnType<typeof useSendToSendCloudMutation>;
export type SendToSendCloudMutationResult = Apollo.MutationResult<SendToSendCloudMutation>;
export type SendToSendCloudMutationOptions = Apollo.BaseMutationOptions<SendToSendCloudMutation, SendToSendCloudMutationVariables>;
export const ShipStationGetOrderDocument = gql`
    query ShipStationGetOrder($orderId: Float!) {
  getOrder(orderId: $orderId) {
    ...ShipStationOrder
  }
}
    ${ShipStationOrderFragmentDoc}`;

/**
 * __useShipStationGetOrderQuery__
 *
 * To run a query within a React component, call `useShipStationGetOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useShipStationGetOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShipStationGetOrderQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useShipStationGetOrderQuery(baseOptions: Apollo.QueryHookOptions<ShipStationGetOrderQuery, ShipStationGetOrderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ShipStationGetOrderQuery, ShipStationGetOrderQueryVariables>(ShipStationGetOrderDocument, options);
      }
export function useShipStationGetOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShipStationGetOrderQuery, ShipStationGetOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ShipStationGetOrderQuery, ShipStationGetOrderQueryVariables>(ShipStationGetOrderDocument, options);
        }
export type ShipStationGetOrderQueryHookResult = ReturnType<typeof useShipStationGetOrderQuery>;
export type ShipStationGetOrderLazyQueryHookResult = ReturnType<typeof useShipStationGetOrderLazyQuery>;
export type ShipStationGetOrderQueryResult = Apollo.QueryResult<ShipStationGetOrderQuery, ShipStationGetOrderQueryVariables>;
export const SendCloudGetParcelDocument = gql`
    query SendCloudGetParcel($parcelId: Float, $trackingNumber: String) {
  getParcel(parcelId: $parcelId, trackingNumber: $trackingNumber) {
    ...SendCloudParcel
  }
}
    ${SendCloudParcelFragmentDoc}`;

/**
 * __useSendCloudGetParcelQuery__
 *
 * To run a query within a React component, call `useSendCloudGetParcelQuery` and pass it any options that fit your needs.
 * When your component renders, `useSendCloudGetParcelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSendCloudGetParcelQuery({
 *   variables: {
 *      parcelId: // value for 'parcelId'
 *      trackingNumber: // value for 'trackingNumber'
 *   },
 * });
 */
export function useSendCloudGetParcelQuery(baseOptions?: Apollo.QueryHookOptions<SendCloudGetParcelQuery, SendCloudGetParcelQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SendCloudGetParcelQuery, SendCloudGetParcelQueryVariables>(SendCloudGetParcelDocument, options);
      }
export function useSendCloudGetParcelLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SendCloudGetParcelQuery, SendCloudGetParcelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SendCloudGetParcelQuery, SendCloudGetParcelQueryVariables>(SendCloudGetParcelDocument, options);
        }
export type SendCloudGetParcelQueryHookResult = ReturnType<typeof useSendCloudGetParcelQuery>;
export type SendCloudGetParcelLazyQueryHookResult = ReturnType<typeof useSendCloudGetParcelLazyQuery>;
export type SendCloudGetParcelQueryResult = Apollo.QueryResult<SendCloudGetParcelQuery, SendCloudGetParcelQueryVariables>;
export const ShipStationListOrdersDocument = gql`
    query ShipStationListOrders($filter: ShipStationOrderFilter, $pagination: Pagination, $sort: Sort) {
  listOrders(filter: $filter, pagination: $pagination, sort: $sort) {
    total
    data {
      ...ShipStationOrder
    }
  }
}
    ${ShipStationOrderFragmentDoc}`;

/**
 * __useShipStationListOrdersQuery__
 *
 * To run a query within a React component, call `useShipStationListOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useShipStationListOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShipStationListOrdersQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useShipStationListOrdersQuery(baseOptions?: Apollo.QueryHookOptions<ShipStationListOrdersQuery, ShipStationListOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ShipStationListOrdersQuery, ShipStationListOrdersQueryVariables>(ShipStationListOrdersDocument, options);
      }
export function useShipStationListOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShipStationListOrdersQuery, ShipStationListOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ShipStationListOrdersQuery, ShipStationListOrdersQueryVariables>(ShipStationListOrdersDocument, options);
        }
export type ShipStationListOrdersQueryHookResult = ReturnType<typeof useShipStationListOrdersQuery>;
export type ShipStationListOrdersLazyQueryHookResult = ReturnType<typeof useShipStationListOrdersLazyQuery>;
export type ShipStationListOrdersQueryResult = Apollo.QueryResult<ShipStationListOrdersQuery, ShipStationListOrdersQueryVariables>;
export const ShipStationListOrdersByTagDocument = gql`
    query ShipStationListOrdersByTag($filter: ShipStationOrderByTagFilter!, $pagination: Pagination) {
  listOrdersByTag(filter: $filter, pagination: $pagination) {
    total
    data {
      ...ShipStationOrder
    }
  }
}
    ${ShipStationOrderFragmentDoc}`;

/**
 * __useShipStationListOrdersByTagQuery__
 *
 * To run a query within a React component, call `useShipStationListOrdersByTagQuery` and pass it any options that fit your needs.
 * When your component renders, `useShipStationListOrdersByTagQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShipStationListOrdersByTagQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useShipStationListOrdersByTagQuery(baseOptions: Apollo.QueryHookOptions<ShipStationListOrdersByTagQuery, ShipStationListOrdersByTagQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ShipStationListOrdersByTagQuery, ShipStationListOrdersByTagQueryVariables>(ShipStationListOrdersByTagDocument, options);
      }
export function useShipStationListOrdersByTagLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShipStationListOrdersByTagQuery, ShipStationListOrdersByTagQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ShipStationListOrdersByTagQuery, ShipStationListOrdersByTagQueryVariables>(ShipStationListOrdersByTagDocument, options);
        }
export type ShipStationListOrdersByTagQueryHookResult = ReturnType<typeof useShipStationListOrdersByTagQuery>;
export type ShipStationListOrdersByTagLazyQueryHookResult = ReturnType<typeof useShipStationListOrdersByTagLazyQuery>;
export type ShipStationListOrdersByTagQueryResult = Apollo.QueryResult<ShipStationListOrdersByTagQuery, ShipStationListOrdersByTagQueryVariables>;
export const ShipStationListShipmentsDocument = gql`
    query ShipStationListShipments($filter: ShipStationShipmentsFilter, $pagination: Pagination, $sort: Sort) {
  listShipments(filter: $filter, pagination: $pagination, sort: $sort) {
    total
    data {
      ...ShipStationShipment
    }
  }
}
    ${ShipStationShipmentFragmentDoc}`;

/**
 * __useShipStationListShipmentsQuery__
 *
 * To run a query within a React component, call `useShipStationListShipmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useShipStationListShipmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShipStationListShipmentsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useShipStationListShipmentsQuery(baseOptions?: Apollo.QueryHookOptions<ShipStationListShipmentsQuery, ShipStationListShipmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ShipStationListShipmentsQuery, ShipStationListShipmentsQueryVariables>(ShipStationListShipmentsDocument, options);
      }
export function useShipStationListShipmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShipStationListShipmentsQuery, ShipStationListShipmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ShipStationListShipmentsQuery, ShipStationListShipmentsQueryVariables>(ShipStationListShipmentsDocument, options);
        }
export type ShipStationListShipmentsQueryHookResult = ReturnType<typeof useShipStationListShipmentsQuery>;
export type ShipStationListShipmentsLazyQueryHookResult = ReturnType<typeof useShipStationListShipmentsLazyQuery>;
export type ShipStationListShipmentsQueryResult = Apollo.QueryResult<ShipStationListShipmentsQuery, ShipStationListShipmentsQueryVariables>;
export const ShipStationListFulfillmentsDocument = gql`
    query ShipStationListFulfillments($filter: ShipStationFulfillmentsFilter, $pagination: Pagination, $sort: Sort) {
  listFulfillments(filter: $filter, pagination: $pagination, sort: $sort) {
    total
    data {
      ...ShipStationFulfillment
    }
  }
}
    ${ShipStationFulfillmentFragmentDoc}`;

/**
 * __useShipStationListFulfillmentsQuery__
 *
 * To run a query within a React component, call `useShipStationListFulfillmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useShipStationListFulfillmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShipStationListFulfillmentsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useShipStationListFulfillmentsQuery(baseOptions?: Apollo.QueryHookOptions<ShipStationListFulfillmentsQuery, ShipStationListFulfillmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ShipStationListFulfillmentsQuery, ShipStationListFulfillmentsQueryVariables>(ShipStationListFulfillmentsDocument, options);
      }
export function useShipStationListFulfillmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShipStationListFulfillmentsQuery, ShipStationListFulfillmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ShipStationListFulfillmentsQuery, ShipStationListFulfillmentsQueryVariables>(ShipStationListFulfillmentsDocument, options);
        }
export type ShipStationListFulfillmentsQueryHookResult = ReturnType<typeof useShipStationListFulfillmentsQuery>;
export type ShipStationListFulfillmentsLazyQueryHookResult = ReturnType<typeof useShipStationListFulfillmentsLazyQuery>;
export type ShipStationListFulfillmentsQueryResult = Apollo.QueryResult<ShipStationListFulfillmentsQuery, ShipStationListFulfillmentsQueryVariables>;
export const ShipStationListProductsDocument = gql`
    query ShipStationListProducts($filter: ShipStationProductFilter, $pagination: Pagination, $sort: Sort) {
  listProducts(filter: $filter, pagination: $pagination, sort: $sort) {
    total
    data {
      ...ShipStationProduct
    }
  }
}
    ${ShipStationProductFragmentDoc}`;

/**
 * __useShipStationListProductsQuery__
 *
 * To run a query within a React component, call `useShipStationListProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useShipStationListProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShipStationListProductsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useShipStationListProductsQuery(baseOptions?: Apollo.QueryHookOptions<ShipStationListProductsQuery, ShipStationListProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ShipStationListProductsQuery, ShipStationListProductsQueryVariables>(ShipStationListProductsDocument, options);
      }
export function useShipStationListProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShipStationListProductsQuery, ShipStationListProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ShipStationListProductsQuery, ShipStationListProductsQueryVariables>(ShipStationListProductsDocument, options);
        }
export type ShipStationListProductsQueryHookResult = ReturnType<typeof useShipStationListProductsQuery>;
export type ShipStationListProductsLazyQueryHookResult = ReturnType<typeof useShipStationListProductsLazyQuery>;
export type ShipStationListProductsQueryResult = Apollo.QueryResult<ShipStationListProductsQuery, ShipStationListProductsQueryVariables>;
export const ShipStationListTagsDocument = gql`
    query ShipStationListTags {
  listTags {
    total
    data {
      id
      tagId
      name
      color
    }
  }
}
    `;

/**
 * __useShipStationListTagsQuery__
 *
 * To run a query within a React component, call `useShipStationListTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useShipStationListTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShipStationListTagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useShipStationListTagsQuery(baseOptions?: Apollo.QueryHookOptions<ShipStationListTagsQuery, ShipStationListTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ShipStationListTagsQuery, ShipStationListTagsQueryVariables>(ShipStationListTagsDocument, options);
      }
export function useShipStationListTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShipStationListTagsQuery, ShipStationListTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ShipStationListTagsQuery, ShipStationListTagsQueryVariables>(ShipStationListTagsDocument, options);
        }
export type ShipStationListTagsQueryHookResult = ReturnType<typeof useShipStationListTagsQuery>;
export type ShipStationListTagsLazyQueryHookResult = ReturnType<typeof useShipStationListTagsLazyQuery>;
export type ShipStationListTagsQueryResult = Apollo.QueryResult<ShipStationListTagsQuery, ShipStationListTagsQueryVariables>;
export const ShipStationListStoresDocument = gql`
    query ShipStationListStores {
  listStores {
    total
    data {
      ...ShipStationStore
    }
  }
}
    ${ShipStationStoreFragmentDoc}`;

/**
 * __useShipStationListStoresQuery__
 *
 * To run a query within a React component, call `useShipStationListStoresQuery` and pass it any options that fit your needs.
 * When your component renders, `useShipStationListStoresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShipStationListStoresQuery({
 *   variables: {
 *   },
 * });
 */
export function useShipStationListStoresQuery(baseOptions?: Apollo.QueryHookOptions<ShipStationListStoresQuery, ShipStationListStoresQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ShipStationListStoresQuery, ShipStationListStoresQueryVariables>(ShipStationListStoresDocument, options);
      }
export function useShipStationListStoresLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShipStationListStoresQuery, ShipStationListStoresQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ShipStationListStoresQuery, ShipStationListStoresQueryVariables>(ShipStationListStoresDocument, options);
        }
export type ShipStationListStoresQueryHookResult = ReturnType<typeof useShipStationListStoresQuery>;
export type ShipStationListStoresLazyQueryHookResult = ReturnType<typeof useShipStationListStoresLazyQuery>;
export type ShipStationListStoresQueryResult = Apollo.QueryResult<ShipStationListStoresQuery, ShipStationListStoresQueryVariables>;
export const ShipStationListCarriersDocument = gql`
    query ShipStationListCarriers {
  listCarriers {
    total
    data {
      ...ShipStationCarrier
    }
  }
}
    ${ShipStationCarrierFragmentDoc}`;

/**
 * __useShipStationListCarriersQuery__
 *
 * To run a query within a React component, call `useShipStationListCarriersQuery` and pass it any options that fit your needs.
 * When your component renders, `useShipStationListCarriersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShipStationListCarriersQuery({
 *   variables: {
 *   },
 * });
 */
export function useShipStationListCarriersQuery(baseOptions?: Apollo.QueryHookOptions<ShipStationListCarriersQuery, ShipStationListCarriersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ShipStationListCarriersQuery, ShipStationListCarriersQueryVariables>(ShipStationListCarriersDocument, options);
      }
export function useShipStationListCarriersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShipStationListCarriersQuery, ShipStationListCarriersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ShipStationListCarriersQuery, ShipStationListCarriersQueryVariables>(ShipStationListCarriersDocument, options);
        }
export type ShipStationListCarriersQueryHookResult = ReturnType<typeof useShipStationListCarriersQuery>;
export type ShipStationListCarriersLazyQueryHookResult = ReturnType<typeof useShipStationListCarriersLazyQuery>;
export type ShipStationListCarriersQueryResult = Apollo.QueryResult<ShipStationListCarriersQuery, ShipStationListCarriersQueryVariables>;
export const ShipStationGetCarrierDocument = gql`
    query ShipStationGetCarrier($carrierCode: String!) {
  getCarrier(carrierCode: $carrierCode) {
    ...ShipStationCarrier
    packages {
      ...ShipStationCarrierPackage
    }
    services {
      ...ShipStationCarrierService
    }
  }
}
    ${ShipStationCarrierFragmentDoc}
${ShipStationCarrierPackageFragmentDoc}
${ShipStationCarrierServiceFragmentDoc}`;

/**
 * __useShipStationGetCarrierQuery__
 *
 * To run a query within a React component, call `useShipStationGetCarrierQuery` and pass it any options that fit your needs.
 * When your component renders, `useShipStationGetCarrierQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShipStationGetCarrierQuery({
 *   variables: {
 *      carrierCode: // value for 'carrierCode'
 *   },
 * });
 */
export function useShipStationGetCarrierQuery(baseOptions: Apollo.QueryHookOptions<ShipStationGetCarrierQuery, ShipStationGetCarrierQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ShipStationGetCarrierQuery, ShipStationGetCarrierQueryVariables>(ShipStationGetCarrierDocument, options);
      }
export function useShipStationGetCarrierLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShipStationGetCarrierQuery, ShipStationGetCarrierQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ShipStationGetCarrierQuery, ShipStationGetCarrierQueryVariables>(ShipStationGetCarrierDocument, options);
        }
export type ShipStationGetCarrierQueryHookResult = ReturnType<typeof useShipStationGetCarrierQuery>;
export type ShipStationGetCarrierLazyQueryHookResult = ReturnType<typeof useShipStationGetCarrierLazyQuery>;
export type ShipStationGetCarrierQueryResult = Apollo.QueryResult<ShipStationGetCarrierQuery, ShipStationGetCarrierQueryVariables>;
export const ShipStationListWarehousesDocument = gql`
    query ShipStationListWarehouses {
  listWarehouses {
    total
    data {
      ...ShipStationWarehouse
    }
  }
}
    ${ShipStationWarehouseFragmentDoc}`;

/**
 * __useShipStationListWarehousesQuery__
 *
 * To run a query within a React component, call `useShipStationListWarehousesQuery` and pass it any options that fit your needs.
 * When your component renders, `useShipStationListWarehousesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShipStationListWarehousesQuery({
 *   variables: {
 *   },
 * });
 */
export function useShipStationListWarehousesQuery(baseOptions?: Apollo.QueryHookOptions<ShipStationListWarehousesQuery, ShipStationListWarehousesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ShipStationListWarehousesQuery, ShipStationListWarehousesQueryVariables>(ShipStationListWarehousesDocument, options);
      }
export function useShipStationListWarehousesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShipStationListWarehousesQuery, ShipStationListWarehousesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ShipStationListWarehousesQuery, ShipStationListWarehousesQueryVariables>(ShipStationListWarehousesDocument, options);
        }
export type ShipStationListWarehousesQueryHookResult = ReturnType<typeof useShipStationListWarehousesQuery>;
export type ShipStationListWarehousesLazyQueryHookResult = ReturnType<typeof useShipStationListWarehousesLazyQuery>;
export type ShipStationListWarehousesQueryResult = Apollo.QueryResult<ShipStationListWarehousesQuery, ShipStationListWarehousesQueryVariables>;
export const UserInfoPageDocument = gql`
    query UserInfoPage($filter: UserInfoFilter, $pagination: Pagination, $sort: Sort) {
  userInfoPage(filter: $filter, pagination: $pagination, sort: $sort) {
    total
    data {
      ...UserInfo
    }
  }
}
    ${UserInfoFragmentDoc}`;

/**
 * __useUserInfoPageQuery__
 *
 * To run a query within a React component, call `useUserInfoPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserInfoPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserInfoPageQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useUserInfoPageQuery(baseOptions?: Apollo.QueryHookOptions<UserInfoPageQuery, UserInfoPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserInfoPageQuery, UserInfoPageQueryVariables>(UserInfoPageDocument, options);
      }
export function useUserInfoPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserInfoPageQuery, UserInfoPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserInfoPageQuery, UserInfoPageQueryVariables>(UserInfoPageDocument, options);
        }
export type UserInfoPageQueryHookResult = ReturnType<typeof useUserInfoPageQuery>;
export type UserInfoPageLazyQueryHookResult = ReturnType<typeof useUserInfoPageLazyQuery>;
export type UserInfoPageQueryResult = Apollo.QueryResult<UserInfoPageQuery, UserInfoPageQueryVariables>;
export const AccountDocument = gql`
    query Account {
  account {
    customer {
      ...Customer
      mainSubscription {
        ...RebillySubscription
      }
      subscriptions {
        ...RebillySubscription
      }
      paymentCards {
        ...Card
      }
    }
    userInfo {
      ...UserInfo
    }
    uid
    email
    customerId
  }
}
    ${CustomerFragmentDoc}
${RebillySubscriptionFragmentDoc}
${CardFragmentDoc}
${UserInfoFragmentDoc}`;

/**
 * __useAccountQuery__
 *
 * To run a query within a React component, call `useAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountQuery({
 *   variables: {
 *   },
 * });
 */
export function useAccountQuery(baseOptions?: Apollo.QueryHookOptions<AccountQuery, AccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountQuery, AccountQueryVariables>(AccountDocument, options);
      }
export function useAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountQuery, AccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountQuery, AccountQueryVariables>(AccountDocument, options);
        }
export type AccountQueryHookResult = ReturnType<typeof useAccountQuery>;
export type AccountLazyQueryHookResult = ReturnType<typeof useAccountLazyQuery>;
export type AccountQueryResult = Apollo.QueryResult<AccountQuery, AccountQueryVariables>;
export const AccountsDocument = gql`
    query Accounts($uids: [String!], $emails: [String!]) {
  accounts(uids: $uids, emails: $emails) {
    customer {
      ...Customer
      mainSubscription {
        ...RebillySubscription
      }
      subscriptions {
        ...RebillySubscription
      }
      paymentCards {
        ...Card
      }
    }
    userInfo {
      ...UserInfo
    }
    uid
    email
    customerId
  }
}
    ${CustomerFragmentDoc}
${RebillySubscriptionFragmentDoc}
${CardFragmentDoc}
${UserInfoFragmentDoc}`;

/**
 * __useAccountsQuery__
 *
 * To run a query within a React component, call `useAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountsQuery({
 *   variables: {
 *      uids: // value for 'uids'
 *      emails: // value for 'emails'
 *   },
 * });
 */
export function useAccountsQuery(baseOptions?: Apollo.QueryHookOptions<AccountsQuery, AccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountsQuery, AccountsQueryVariables>(AccountsDocument, options);
      }
export function useAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountsQuery, AccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountsQuery, AccountsQueryVariables>(AccountsDocument, options);
        }
export type AccountsQueryHookResult = ReturnType<typeof useAccountsQuery>;
export type AccountsLazyQueryHookResult = ReturnType<typeof useAccountsLazyQuery>;
export type AccountsQueryResult = Apollo.QueryResult<AccountsQuery, AccountsQueryVariables>;
export const MeDocument = gql`
    query Me {
  me {
    ...Customer
    mainSubscription {
      ...RebillySubscription
    }
    subscriptions {
      ...RebillySubscription
    }
    paymentCards {
      ...Card
    }
    userInfo {
      ...UserInfo
    }
  }
}
    ${CustomerFragmentDoc}
${RebillySubscriptionFragmentDoc}
${CardFragmentDoc}
${UserInfoFragmentDoc}`;

/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeQuery(baseOptions?: Apollo.QueryHookOptions<MeQuery, MeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeQuery, MeQueryVariables>(MeDocument, options);
      }
export function useMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
export type MeQueryHookResult = ReturnType<typeof useMeQuery>;
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>;
export type MeQueryResult = Apollo.QueryResult<MeQuery, MeQueryVariables>;
export const KycDocument = gql`
    query Kyc {
  me {
    id
    firstName
    lastName
    kycDocuments {
      ...Kyc
    }
    kycMaxAttempts {
      ...KycMaxAttempts
    }
  }
}
    ${KycFragmentDoc}
${KycMaxAttemptsFragmentDoc}`;

/**
 * __useKycQuery__
 *
 * To run a query within a React component, call `useKycQuery` and pass it any options that fit your needs.
 * When your component renders, `useKycQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKycQuery({
 *   variables: {
 *   },
 * });
 */
export function useKycQuery(baseOptions?: Apollo.QueryHookOptions<KycQuery, KycQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KycQuery, KycQueryVariables>(KycDocument, options);
      }
export function useKycLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KycQuery, KycQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KycQuery, KycQueryVariables>(KycDocument, options);
        }
export type KycQueryHookResult = ReturnType<typeof useKycQuery>;
export type KycLazyQueryHookResult = ReturnType<typeof useKycLazyQuery>;
export type KycQueryResult = Apollo.QueryResult<KycQuery, KycQueryVariables>;
export const KycByIdDocument = gql`
    query KycById($id: String!) {
  kycDocumentById(id: $id) {
    ...Kyc
    download
  }
}
    ${KycFragmentDoc}`;

/**
 * __useKycByIdQuery__
 *
 * To run a query within a React component, call `useKycByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useKycByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKycByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useKycByIdQuery(baseOptions: Apollo.QueryHookOptions<KycByIdQuery, KycByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KycByIdQuery, KycByIdQueryVariables>(KycByIdDocument, options);
      }
export function useKycByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KycByIdQuery, KycByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KycByIdQuery, KycByIdQueryVariables>(KycByIdDocument, options);
        }
export type KycByIdQueryHookResult = ReturnType<typeof useKycByIdQuery>;
export type KycByIdLazyQueryHookResult = ReturnType<typeof useKycByIdLazyQuery>;
export type KycByIdQueryResult = Apollo.QueryResult<KycByIdQuery, KycByIdQueryVariables>;
export const CreateKycDocument = gql`
    mutation CreateKyc($input: KycDocumentInput!) {
  createKycDocument(input: $input) {
    customerId
    kycDocument {
      ...Kyc
    }
    kycMaxAttempts {
      ...KycMaxAttempts
    }
  }
}
    ${KycFragmentDoc}
${KycMaxAttemptsFragmentDoc}`;
export type CreateKycMutationFn = Apollo.MutationFunction<CreateKycMutation, CreateKycMutationVariables>;

/**
 * __useCreateKycMutation__
 *
 * To run a mutation, you first call `useCreateKycMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateKycMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createKycMutation, { data, loading, error }] = useCreateKycMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateKycMutation(baseOptions?: Apollo.MutationHookOptions<CreateKycMutation, CreateKycMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateKycMutation, CreateKycMutationVariables>(CreateKycDocument, options);
      }
export type CreateKycMutationHookResult = ReturnType<typeof useCreateKycMutation>;
export type CreateKycMutationResult = Apollo.MutationResult<CreateKycMutation>;
export type CreateKycMutationOptions = Apollo.BaseMutationOptions<CreateKycMutation, CreateKycMutationVariables>;
export const UpdateKycDocument = gql`
    mutation UpdateKyc($id: String!, $input: KycDocumentInput!) {
  updateKycDocument(id: $id, input: $input) {
    customerId
    kycDocument {
      ...Kyc
    }
    kycMaxAttempts {
      ...KycMaxAttempts
    }
  }
}
    ${KycFragmentDoc}
${KycMaxAttemptsFragmentDoc}`;
export type UpdateKycMutationFn = Apollo.MutationFunction<UpdateKycMutation, UpdateKycMutationVariables>;

/**
 * __useUpdateKycMutation__
 *
 * To run a mutation, you first call `useUpdateKycMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateKycMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateKycMutation, { data, loading, error }] = useUpdateKycMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateKycMutation(baseOptions?: Apollo.MutationHookOptions<UpdateKycMutation, UpdateKycMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateKycMutation, UpdateKycMutationVariables>(UpdateKycDocument, options);
      }
export type UpdateKycMutationHookResult = ReturnType<typeof useUpdateKycMutation>;
export type UpdateKycMutationResult = Apollo.MutationResult<UpdateKycMutation>;
export type UpdateKycMutationOptions = Apollo.BaseMutationOptions<UpdateKycMutation, UpdateKycMutationVariables>;
export const AcceptKycDocument = gql`
    mutation AcceptKyc($id: String!) {
  acceptKycDocument(id: $id) {
    ...Kyc
  }
}
    ${KycFragmentDoc}`;
export type AcceptKycMutationFn = Apollo.MutationFunction<AcceptKycMutation, AcceptKycMutationVariables>;

/**
 * __useAcceptKycMutation__
 *
 * To run a mutation, you first call `useAcceptKycMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptKycMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptKycMutation, { data, loading, error }] = useAcceptKycMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAcceptKycMutation(baseOptions?: Apollo.MutationHookOptions<AcceptKycMutation, AcceptKycMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptKycMutation, AcceptKycMutationVariables>(AcceptKycDocument, options);
      }
export type AcceptKycMutationHookResult = ReturnType<typeof useAcceptKycMutation>;
export type AcceptKycMutationResult = Apollo.MutationResult<AcceptKycMutation>;
export type AcceptKycMutationOptions = Apollo.BaseMutationOptions<AcceptKycMutation, AcceptKycMutationVariables>;
export const RejectKycDocument = gql`
    mutation RejectKyc($id: String!, $type: String, $message: String) {
  rejectKycDocument(id: $id, type: $type, message: $message) {
    ...Kyc
  }
}
    ${KycFragmentDoc}`;
export type RejectKycMutationFn = Apollo.MutationFunction<RejectKycMutation, RejectKycMutationVariables>;

/**
 * __useRejectKycMutation__
 *
 * To run a mutation, you first call `useRejectKycMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectKycMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectKycMutation, { data, loading, error }] = useRejectKycMutation({
 *   variables: {
 *      id: // value for 'id'
 *      type: // value for 'type'
 *      message: // value for 'message'
 *   },
 * });
 */
export function useRejectKycMutation(baseOptions?: Apollo.MutationHookOptions<RejectKycMutation, RejectKycMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RejectKycMutation, RejectKycMutationVariables>(RejectKycDocument, options);
      }
export type RejectKycMutationHookResult = ReturnType<typeof useRejectKycMutation>;
export type RejectKycMutationResult = Apollo.MutationResult<RejectKycMutation>;
export type RejectKycMutationOptions = Apollo.BaseMutationOptions<RejectKycMutation, RejectKycMutationVariables>;
export const CustomerProfileDocument = gql`
    query CustomerProfile($uid: String!) {
  customerProfileByUid(uid: $uid) {
    uid
    email
    photoURL
  }
}
    `;

/**
 * __useCustomerProfileQuery__
 *
 * To run a query within a React component, call `useCustomerProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerProfileQuery({
 *   variables: {
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useCustomerProfileQuery(baseOptions: Apollo.QueryHookOptions<CustomerProfileQuery, CustomerProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerProfileQuery, CustomerProfileQueryVariables>(CustomerProfileDocument, options);
      }
export function useCustomerProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerProfileQuery, CustomerProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerProfileQuery, CustomerProfileQueryVariables>(CustomerProfileDocument, options);
        }
export type CustomerProfileQueryHookResult = ReturnType<typeof useCustomerProfileQuery>;
export type CustomerProfileLazyQueryHookResult = ReturnType<typeof useCustomerProfileLazyQuery>;
export type CustomerProfileQueryResult = Apollo.QueryResult<CustomerProfileQuery, CustomerProfileQueryVariables>;
export const CustomerDocument = gql`
    query Customer($id: String, $uid: String, $email: String) {
  customer(id: $id, uid: $uid, email: $email) {
    ...Customer
    mainSubscription {
      ...RebillySubscription
    }
    subscriptions {
      ...RebillySubscription
    }
    pastSubscriptions {
      ...RebillySubscription
    }
    paymentCards {
      ...Card
    }
  }
}
    ${CustomerFragmentDoc}
${RebillySubscriptionFragmentDoc}
${CardFragmentDoc}`;

/**
 * __useCustomerQuery__
 *
 * To run a query within a React component, call `useCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerQuery({
 *   variables: {
 *      id: // value for 'id'
 *      uid: // value for 'uid'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useCustomerQuery(baseOptions?: Apollo.QueryHookOptions<CustomerQuery, CustomerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerQuery, CustomerQueryVariables>(CustomerDocument, options);
      }
export function useCustomerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerQuery, CustomerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerQuery, CustomerQueryVariables>(CustomerDocument, options);
        }
export type CustomerQueryHookResult = ReturnType<typeof useCustomerQuery>;
export type CustomerLazyQueryHookResult = ReturnType<typeof useCustomerLazyQuery>;
export type CustomerQueryResult = Apollo.QueryResult<CustomerQuery, CustomerQueryVariables>;
export const PlansDocument = gql`
    query Plans {
  plans {
    id
  }
}
    `;

/**
 * __usePlansQuery__
 *
 * To run a query within a React component, call `usePlansQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlansQuery({
 *   variables: {
 *   },
 * });
 */
export function usePlansQuery(baseOptions?: Apollo.QueryHookOptions<PlansQuery, PlansQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlansQuery, PlansQueryVariables>(PlansDocument, options);
      }
export function usePlansLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlansQuery, PlansQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlansQuery, PlansQueryVariables>(PlansDocument, options);
        }
export type PlansQueryHookResult = ReturnType<typeof usePlansQuery>;
export type PlansLazyQueryHookResult = ReturnType<typeof usePlansLazyQuery>;
export type PlansQueryResult = Apollo.QueryResult<PlansQuery, PlansQueryVariables>;
export const InvoiceDocument = gql`
    query Invoice($id: String!) {
  invoice(id: $id) {
    ...Invoice
  }
}
    ${InvoiceFragmentDoc}`;

/**
 * __useInvoiceQuery__
 *
 * To run a query within a React component, call `useInvoiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoiceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInvoiceQuery(baseOptions: Apollo.QueryHookOptions<InvoiceQuery, InvoiceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvoiceQuery, InvoiceQueryVariables>(InvoiceDocument, options);
      }
export function useInvoiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvoiceQuery, InvoiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvoiceQuery, InvoiceQueryVariables>(InvoiceDocument, options);
        }
export type InvoiceQueryHookResult = ReturnType<typeof useInvoiceQuery>;
export type InvoiceLazyQueryHookResult = ReturnType<typeof useInvoiceLazyQuery>;
export type InvoiceQueryResult = Apollo.QueryResult<InvoiceQuery, InvoiceQueryVariables>;
export const CheckoutDocument = gql`
    mutation Checkout($planId: String!, $paymentCardId: String!, $customer: CustomerInput, $shipping: AddressInput, $billing: AddressInput, $customJson: JSON, $stickyGatewayId: String) {
  checkout(
    planId: $planId
    customer: $customer
    shipping: $shipping
    billing: $billing
    paymentInstrument: {method: "payment-card", paymentCardId: $paymentCardId}
    customJson: $customJson
    stickyGatewayId: $stickyGatewayId
  ) {
    transaction {
      id
      amount
      status
      result
    }
    customer {
      ...Customer
      mainSubscription {
        ...RebillySubscription
      }
      subscriptions {
        ...RebillySubscription
      }
      paymentCards {
        ...Card
      }
    }
  }
}
    ${CustomerFragmentDoc}
${RebillySubscriptionFragmentDoc}
${CardFragmentDoc}`;
export type CheckoutMutationFn = Apollo.MutationFunction<CheckoutMutation, CheckoutMutationVariables>;

/**
 * __useCheckoutMutation__
 *
 * To run a mutation, you first call `useCheckoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkoutMutation, { data, loading, error }] = useCheckoutMutation({
 *   variables: {
 *      planId: // value for 'planId'
 *      paymentCardId: // value for 'paymentCardId'
 *      customer: // value for 'customer'
 *      shipping: // value for 'shipping'
 *      billing: // value for 'billing'
 *      customJson: // value for 'customJson'
 *      stickyGatewayId: // value for 'stickyGatewayId'
 *   },
 * });
 */
export function useCheckoutMutation(baseOptions?: Apollo.MutationHookOptions<CheckoutMutation, CheckoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CheckoutMutation, CheckoutMutationVariables>(CheckoutDocument, options);
      }
export type CheckoutMutationHookResult = ReturnType<typeof useCheckoutMutation>;
export type CheckoutMutationResult = Apollo.MutationResult<CheckoutMutation>;
export type CheckoutMutationOptions = Apollo.BaseMutationOptions<CheckoutMutation, CheckoutMutationVariables>;
export const CheckoutV2Document = gql`
    mutation CheckoutV2($planId: String!, $paymentCardId: String!, $customer: CustomerInput, $shipping: AddressInput, $billing: AddressInput, $customJson: JSON, $stickyGatewayId: String) {
  checkout(
    planId: $planId
    customer: $customer
    shipping: $shipping
    billing: $billing
    paymentInstruction: {paymentInstrumentId: $paymentCardId}
    customJson: $customJson
    stickyGatewayId: $stickyGatewayId
  ) {
    transaction {
      id
      amount
      status
      result
    }
    customer {
      ...Customer
      mainSubscription {
        ...RebillySubscription
      }
      subscriptions {
        ...RebillySubscription
      }
      paymentCards {
        ...Card
      }
    }
  }
}
    ${CustomerFragmentDoc}
${RebillySubscriptionFragmentDoc}
${CardFragmentDoc}`;
export type CheckoutV2MutationFn = Apollo.MutationFunction<CheckoutV2Mutation, CheckoutV2MutationVariables>;

/**
 * __useCheckoutV2Mutation__
 *
 * To run a mutation, you first call `useCheckoutV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckoutV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkoutV2Mutation, { data, loading, error }] = useCheckoutV2Mutation({
 *   variables: {
 *      planId: // value for 'planId'
 *      paymentCardId: // value for 'paymentCardId'
 *      customer: // value for 'customer'
 *      shipping: // value for 'shipping'
 *      billing: // value for 'billing'
 *      customJson: // value for 'customJson'
 *      stickyGatewayId: // value for 'stickyGatewayId'
 *   },
 * });
 */
export function useCheckoutV2Mutation(baseOptions?: Apollo.MutationHookOptions<CheckoutV2Mutation, CheckoutV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CheckoutV2Mutation, CheckoutV2MutationVariables>(CheckoutV2Document, options);
      }
export type CheckoutV2MutationHookResult = ReturnType<typeof useCheckoutV2Mutation>;
export type CheckoutV2MutationResult = Apollo.MutationResult<CheckoutV2Mutation>;
export type CheckoutV2MutationOptions = Apollo.BaseMutationOptions<CheckoutV2Mutation, CheckoutV2MutationVariables>;
export const CheckoutV3Document = gql`
    mutation CheckoutV3($paymentToken: String, $paymentInstrument: PaymentInstrumentInput, $customer: CustomerInput, $shipping: AddressInput, $billing: AddressInput, $customJson: JSON, $items: [ItemInput!], $shippingAmount: Float) {
  checkout(
    customer: $customer
    shipping: $shipping
    billing: $billing
    paymentInstruction: {token: $paymentToken}
    paymentInstrument: $paymentInstrument
    customJson: $customJson
    items: $items
    shippingAmount: $shippingAmount
  ) {
    transaction {
      id
      amount
      status
      result
      planIds
      paymentInstrument {
        paymentCardId
        method
      }
    }
    customer {
      id
      email
    }
  }
}
    `;
export type CheckoutV3MutationFn = Apollo.MutationFunction<CheckoutV3Mutation, CheckoutV3MutationVariables>;

/**
 * __useCheckoutV3Mutation__
 *
 * To run a mutation, you first call `useCheckoutV3Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckoutV3Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkoutV3Mutation, { data, loading, error }] = useCheckoutV3Mutation({
 *   variables: {
 *      paymentToken: // value for 'paymentToken'
 *      paymentInstrument: // value for 'paymentInstrument'
 *      customer: // value for 'customer'
 *      shipping: // value for 'shipping'
 *      billing: // value for 'billing'
 *      customJson: // value for 'customJson'
 *      items: // value for 'items'
 *      shippingAmount: // value for 'shippingAmount'
 *   },
 * });
 */
export function useCheckoutV3Mutation(baseOptions?: Apollo.MutationHookOptions<CheckoutV3Mutation, CheckoutV3MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CheckoutV3Mutation, CheckoutV3MutationVariables>(CheckoutV3Document, options);
      }
export type CheckoutV3MutationHookResult = ReturnType<typeof useCheckoutV3Mutation>;
export type CheckoutV3MutationResult = Apollo.MutationResult<CheckoutV3Mutation>;
export type CheckoutV3MutationOptions = Apollo.BaseMutationOptions<CheckoutV3Mutation, CheckoutV3MutationVariables>;
export const TransactionDocument = gql`
    mutation Transaction($invoiceId: String!, $paymentCardId: String!) {
  createTransaction(
    invoiceId: $invoiceId
    paymentInstrument: {method: "payment-card", paymentCardId: $paymentCardId}
  ) {
    id
    status
    result
  }
}
    `;
export type TransactionMutationFn = Apollo.MutationFunction<TransactionMutation, TransactionMutationVariables>;

/**
 * __useTransactionMutation__
 *
 * To run a mutation, you first call `useTransactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTransactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transactionMutation, { data, loading, error }] = useTransactionMutation({
 *   variables: {
 *      invoiceId: // value for 'invoiceId'
 *      paymentCardId: // value for 'paymentCardId'
 *   },
 * });
 */
export function useTransactionMutation(baseOptions?: Apollo.MutationHookOptions<TransactionMutation, TransactionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TransactionMutation, TransactionMutationVariables>(TransactionDocument, options);
      }
export type TransactionMutationHookResult = ReturnType<typeof useTransactionMutation>;
export type TransactionMutationResult = Apollo.MutationResult<TransactionMutation>;
export type TransactionMutationOptions = Apollo.BaseMutationOptions<TransactionMutation, TransactionMutationVariables>;
export const TransactionV2Document = gql`
    mutation TransactionV2($invoiceId: String!, $paymentCardId: String!) {
  createTransaction(
    invoiceId: $invoiceId
    paymentInstruction: {paymentInstrumentId: $paymentCardId}
  ) {
    id
    status
    result
  }
}
    `;
export type TransactionV2MutationFn = Apollo.MutationFunction<TransactionV2Mutation, TransactionV2MutationVariables>;

/**
 * __useTransactionV2Mutation__
 *
 * To run a mutation, you first call `useTransactionV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTransactionV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transactionV2Mutation, { data, loading, error }] = useTransactionV2Mutation({
 *   variables: {
 *      invoiceId: // value for 'invoiceId'
 *      paymentCardId: // value for 'paymentCardId'
 *   },
 * });
 */
export function useTransactionV2Mutation(baseOptions?: Apollo.MutationHookOptions<TransactionV2Mutation, TransactionV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TransactionV2Mutation, TransactionV2MutationVariables>(TransactionV2Document, options);
      }
export type TransactionV2MutationHookResult = ReturnType<typeof useTransactionV2Mutation>;
export type TransactionV2MutationResult = Apollo.MutationResult<TransactionV2Mutation>;
export type TransactionV2MutationOptions = Apollo.BaseMutationOptions<TransactionV2Mutation, TransactionV2MutationVariables>;
export const CancelSubscriptionDocument = gql`
    mutation CancelSubscription($subscriptionId: String!) {
  cancelSubscription(subscriptionId: $subscriptionId) {
    ...RebillySubscription
  }
}
    ${RebillySubscriptionFragmentDoc}`;
export type CancelSubscriptionMutationFn = Apollo.MutationFunction<CancelSubscriptionMutation, CancelSubscriptionMutationVariables>;

/**
 * __useCancelSubscriptionMutation__
 *
 * To run a mutation, you first call `useCancelSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelSubscriptionMutation, { data, loading, error }] = useCancelSubscriptionMutation({
 *   variables: {
 *      subscriptionId: // value for 'subscriptionId'
 *   },
 * });
 */
export function useCancelSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<CancelSubscriptionMutation, CancelSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelSubscriptionMutation, CancelSubscriptionMutationVariables>(CancelSubscriptionDocument, options);
      }
export type CancelSubscriptionMutationHookResult = ReturnType<typeof useCancelSubscriptionMutation>;
export type CancelSubscriptionMutationResult = Apollo.MutationResult<CancelSubscriptionMutation>;
export type CancelSubscriptionMutationOptions = Apollo.BaseMutationOptions<CancelSubscriptionMutation, CancelSubscriptionMutationVariables>;
export const ReactivateSubscriptionDocument = gql`
    mutation ReactivateSubscription($subscriptionId: String!) {
  reactivateSubscription(subscriptionId: $subscriptionId) {
    ...RebillySubscription
  }
}
    ${RebillySubscriptionFragmentDoc}`;
export type ReactivateSubscriptionMutationFn = Apollo.MutationFunction<ReactivateSubscriptionMutation, ReactivateSubscriptionMutationVariables>;

/**
 * __useReactivateSubscriptionMutation__
 *
 * To run a mutation, you first call `useReactivateSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReactivateSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reactivateSubscriptionMutation, { data, loading, error }] = useReactivateSubscriptionMutation({
 *   variables: {
 *      subscriptionId: // value for 'subscriptionId'
 *   },
 * });
 */
export function useReactivateSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<ReactivateSubscriptionMutation, ReactivateSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReactivateSubscriptionMutation, ReactivateSubscriptionMutationVariables>(ReactivateSubscriptionDocument, options);
      }
export type ReactivateSubscriptionMutationHookResult = ReturnType<typeof useReactivateSubscriptionMutation>;
export type ReactivateSubscriptionMutationResult = Apollo.MutationResult<ReactivateSubscriptionMutation>;
export type ReactivateSubscriptionMutationOptions = Apollo.BaseMutationOptions<ReactivateSubscriptionMutation, ReactivateSubscriptionMutationVariables>;
export const ChangeSubscriptionPreviewDocument = gql`
    mutation ChangeSubscriptionPreview($subscriptionId: String!, $planId: String!) {
  changeSubscriptionPreview(subscriptionId: $subscriptionId, planId: $planId) {
    status
    billingStatus
    items {
      planId
    }
    lineItemSubtotal
    lineItems {
      quantity
      unitPriceAmount
      unitPriceCurrency
      description
      type
    }
  }
}
    `;
export type ChangeSubscriptionPreviewMutationFn = Apollo.MutationFunction<ChangeSubscriptionPreviewMutation, ChangeSubscriptionPreviewMutationVariables>;

/**
 * __useChangeSubscriptionPreviewMutation__
 *
 * To run a mutation, you first call `useChangeSubscriptionPreviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeSubscriptionPreviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeSubscriptionPreviewMutation, { data, loading, error }] = useChangeSubscriptionPreviewMutation({
 *   variables: {
 *      subscriptionId: // value for 'subscriptionId'
 *      planId: // value for 'planId'
 *   },
 * });
 */
export function useChangeSubscriptionPreviewMutation(baseOptions?: Apollo.MutationHookOptions<ChangeSubscriptionPreviewMutation, ChangeSubscriptionPreviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeSubscriptionPreviewMutation, ChangeSubscriptionPreviewMutationVariables>(ChangeSubscriptionPreviewDocument, options);
      }
export type ChangeSubscriptionPreviewMutationHookResult = ReturnType<typeof useChangeSubscriptionPreviewMutation>;
export type ChangeSubscriptionPreviewMutationResult = Apollo.MutationResult<ChangeSubscriptionPreviewMutation>;
export type ChangeSubscriptionPreviewMutationOptions = Apollo.BaseMutationOptions<ChangeSubscriptionPreviewMutation, ChangeSubscriptionPreviewMutationVariables>;
export const ChangeSubscriptionDocument = gql`
    mutation ChangeSubscription($subscriptionId: String!, $planId: String!, $paymentCardId: String!) {
  changeSubscription(
    subscriptionId: $subscriptionId
    planId: $planId
    paymentInstrument: {method: "payment-card", paymentCardId: $paymentCardId}
  ) {
    ...RebillySubscription
  }
}
    ${RebillySubscriptionFragmentDoc}`;
export type ChangeSubscriptionMutationFn = Apollo.MutationFunction<ChangeSubscriptionMutation, ChangeSubscriptionMutationVariables>;

/**
 * __useChangeSubscriptionMutation__
 *
 * To run a mutation, you first call `useChangeSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeSubscriptionMutation, { data, loading, error }] = useChangeSubscriptionMutation({
 *   variables: {
 *      subscriptionId: // value for 'subscriptionId'
 *      planId: // value for 'planId'
 *      paymentCardId: // value for 'paymentCardId'
 *   },
 * });
 */
export function useChangeSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<ChangeSubscriptionMutation, ChangeSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeSubscriptionMutation, ChangeSubscriptionMutationVariables>(ChangeSubscriptionDocument, options);
      }
export type ChangeSubscriptionMutationHookResult = ReturnType<typeof useChangeSubscriptionMutation>;
export type ChangeSubscriptionMutationResult = Apollo.MutationResult<ChangeSubscriptionMutation>;
export type ChangeSubscriptionMutationOptions = Apollo.BaseMutationOptions<ChangeSubscriptionMutation, ChangeSubscriptionMutationVariables>;
export const CreateCustomerDocument = gql`
    mutation CreateCustomer($firstName: String, $lastName: String, $phone: String) {
  createCustomer(firstName: $firstName, lastName: $lastName, phone: $phone) {
    ...Customer
  }
}
    ${CustomerFragmentDoc}`;
export type CreateCustomerMutationFn = Apollo.MutationFunction<CreateCustomerMutation, CreateCustomerMutationVariables>;

/**
 * __useCreateCustomerMutation__
 *
 * To run a mutation, you first call `useCreateCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomerMutation, { data, loading, error }] = useCreateCustomerMutation({
 *   variables: {
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      phone: // value for 'phone'
 *   },
 * });
 */
export function useCreateCustomerMutation(baseOptions?: Apollo.MutationHookOptions<CreateCustomerMutation, CreateCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCustomerMutation, CreateCustomerMutationVariables>(CreateCustomerDocument, options);
      }
export type CreateCustomerMutationHookResult = ReturnType<typeof useCreateCustomerMutation>;
export type CreateCustomerMutationResult = Apollo.MutationResult<CreateCustomerMutation>;
export type CreateCustomerMutationOptions = Apollo.BaseMutationOptions<CreateCustomerMutation, CreateCustomerMutationVariables>;
export const AddPaymentDocument = gql`
    mutation AddPayment($paymentToken: String!, $customerId: String, $customer: CustomerInput, $authorize: Boolean) {
  addPayment(
    paymentToken: $paymentToken
    customerId: $customerId
    customer: $customer
    authorize: $authorize
  ) {
    ...Customer
    subscriptions {
      ...RebillySubscription
    }
    paymentCards {
      ...Card
    }
  }
}
    ${CustomerFragmentDoc}
${RebillySubscriptionFragmentDoc}
${CardFragmentDoc}`;
export type AddPaymentMutationFn = Apollo.MutationFunction<AddPaymentMutation, AddPaymentMutationVariables>;

/**
 * __useAddPaymentMutation__
 *
 * To run a mutation, you first call `useAddPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPaymentMutation, { data, loading, error }] = useAddPaymentMutation({
 *   variables: {
 *      paymentToken: // value for 'paymentToken'
 *      customerId: // value for 'customerId'
 *      customer: // value for 'customer'
 *      authorize: // value for 'authorize'
 *   },
 * });
 */
export function useAddPaymentMutation(baseOptions?: Apollo.MutationHookOptions<AddPaymentMutation, AddPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPaymentMutation, AddPaymentMutationVariables>(AddPaymentDocument, options);
      }
export type AddPaymentMutationHookResult = ReturnType<typeof useAddPaymentMutation>;
export type AddPaymentMutationResult = Apollo.MutationResult<AddPaymentMutation>;
export type AddPaymentMutationOptions = Apollo.BaseMutationOptions<AddPaymentMutation, AddPaymentMutationVariables>;
export const CumulativeSubscriptionCountDocument = gql`
    query CumulativeSubscriptionCount($start: String, $end: String) {
  cumulativeSubscriptionCount(start: $start, end: $end) {
    data {
      ...CumulativeSubscriptionCount
    }
  }
}
    ${CumulativeSubscriptionCountFragmentDoc}`;

/**
 * __useCumulativeSubscriptionCountQuery__
 *
 * To run a query within a React component, call `useCumulativeSubscriptionCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useCumulativeSubscriptionCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCumulativeSubscriptionCountQuery({
 *   variables: {
 *      start: // value for 'start'
 *      end: // value for 'end'
 *   },
 * });
 */
export function useCumulativeSubscriptionCountQuery(baseOptions?: Apollo.QueryHookOptions<CumulativeSubscriptionCountQuery, CumulativeSubscriptionCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CumulativeSubscriptionCountQuery, CumulativeSubscriptionCountQueryVariables>(CumulativeSubscriptionCountDocument, options);
      }
export function useCumulativeSubscriptionCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CumulativeSubscriptionCountQuery, CumulativeSubscriptionCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CumulativeSubscriptionCountQuery, CumulativeSubscriptionCountQueryVariables>(CumulativeSubscriptionCountDocument, options);
        }
export type CumulativeSubscriptionCountQueryHookResult = ReturnType<typeof useCumulativeSubscriptionCountQuery>;
export type CumulativeSubscriptionCountLazyQueryHookResult = ReturnType<typeof useCumulativeSubscriptionCountLazyQuery>;
export type CumulativeSubscriptionCountQueryResult = Apollo.QueryResult<CumulativeSubscriptionCountQuery, CumulativeSubscriptionCountQueryVariables>;
export const CumulativeTransactionCountDocument = gql`
    query CumulativeTransactionCount($start: String, $end: String) {
  cumulativeTransactionCount(start: $start, end: $end) {
    data {
      ...CumulativeTransactionCount
    }
  }
}
    ${CumulativeTransactionCountFragmentDoc}`;

/**
 * __useCumulativeTransactionCountQuery__
 *
 * To run a query within a React component, call `useCumulativeTransactionCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useCumulativeTransactionCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCumulativeTransactionCountQuery({
 *   variables: {
 *      start: // value for 'start'
 *      end: // value for 'end'
 *   },
 * });
 */
export function useCumulativeTransactionCountQuery(baseOptions?: Apollo.QueryHookOptions<CumulativeTransactionCountQuery, CumulativeTransactionCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CumulativeTransactionCountQuery, CumulativeTransactionCountQueryVariables>(CumulativeTransactionCountDocument, options);
      }
export function useCumulativeTransactionCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CumulativeTransactionCountQuery, CumulativeTransactionCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CumulativeTransactionCountQuery, CumulativeTransactionCountQueryVariables>(CumulativeTransactionCountDocument, options);
        }
export type CumulativeTransactionCountQueryHookResult = ReturnType<typeof useCumulativeTransactionCountQuery>;
export type CumulativeTransactionCountLazyQueryHookResult = ReturnType<typeof useCumulativeTransactionCountLazyQuery>;
export type CumulativeTransactionCountQueryResult = Apollo.QueryResult<CumulativeTransactionCountQuery, CumulativeTransactionCountQueryVariables>;
export const CumulativeStatsDocument = gql`
    query CumulativeStats($start: String, $end: String) {
  cumulativeSubscriptionCount(start: $start, end: $end) {
    data {
      ...CumulativeSubscriptionCount
    }
  }
  cumulativeTransactionCount(start: $start, end: $end) {
    data {
      ...CumulativeTransactionCount
    }
  }
}
    ${CumulativeSubscriptionCountFragmentDoc}
${CumulativeTransactionCountFragmentDoc}`;

/**
 * __useCumulativeStatsQuery__
 *
 * To run a query within a React component, call `useCumulativeStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCumulativeStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCumulativeStatsQuery({
 *   variables: {
 *      start: // value for 'start'
 *      end: // value for 'end'
 *   },
 * });
 */
export function useCumulativeStatsQuery(baseOptions?: Apollo.QueryHookOptions<CumulativeStatsQuery, CumulativeStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CumulativeStatsQuery, CumulativeStatsQueryVariables>(CumulativeStatsDocument, options);
      }
export function useCumulativeStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CumulativeStatsQuery, CumulativeStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CumulativeStatsQuery, CumulativeStatsQueryVariables>(CumulativeStatsDocument, options);
        }
export type CumulativeStatsQueryHookResult = ReturnType<typeof useCumulativeStatsQuery>;
export type CumulativeStatsLazyQueryHookResult = ReturnType<typeof useCumulativeStatsLazyQuery>;
export type CumulativeStatsQueryResult = Apollo.QueryResult<CumulativeStatsQuery, CumulativeStatsQueryVariables>;
export const DeactivatePaymentCardDocument = gql`
    mutation DeactivatePaymentCard($paymentCardId: String!) {
  deactivatePaymentCard(paymentCardId: $paymentCardId) {
    ...Card
  }
}
    ${CardFragmentDoc}`;
export type DeactivatePaymentCardMutationFn = Apollo.MutationFunction<DeactivatePaymentCardMutation, DeactivatePaymentCardMutationVariables>;

/**
 * __useDeactivatePaymentCardMutation__
 *
 * To run a mutation, you first call `useDeactivatePaymentCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivatePaymentCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivatePaymentCardMutation, { data, loading, error }] = useDeactivatePaymentCardMutation({
 *   variables: {
 *      paymentCardId: // value for 'paymentCardId'
 *   },
 * });
 */
export function useDeactivatePaymentCardMutation(baseOptions?: Apollo.MutationHookOptions<DeactivatePaymentCardMutation, DeactivatePaymentCardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeactivatePaymentCardMutation, DeactivatePaymentCardMutationVariables>(DeactivatePaymentCardDocument, options);
      }
export type DeactivatePaymentCardMutationHookResult = ReturnType<typeof useDeactivatePaymentCardMutation>;
export type DeactivatePaymentCardMutationResult = Apollo.MutationResult<DeactivatePaymentCardMutation>;
export type DeactivatePaymentCardMutationOptions = Apollo.BaseMutationOptions<DeactivatePaymentCardMutation, DeactivatePaymentCardMutationVariables>;
export const RefundRequestDocument = gql`
    query refundRequest($id: String!) {
  refundRequest(id: $id) {
    ...RefundRequest
  }
}
    ${RefundRequestFragmentDoc}`;

/**
 * __useRefundRequestQuery__
 *
 * To run a query within a React component, call `useRefundRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useRefundRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRefundRequestQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRefundRequestQuery(baseOptions: Apollo.QueryHookOptions<RefundRequestQuery, RefundRequestQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RefundRequestQuery, RefundRequestQueryVariables>(RefundRequestDocument, options);
      }
export function useRefundRequestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RefundRequestQuery, RefundRequestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RefundRequestQuery, RefundRequestQueryVariables>(RefundRequestDocument, options);
        }
export type RefundRequestQueryHookResult = ReturnType<typeof useRefundRequestQuery>;
export type RefundRequestLazyQueryHookResult = ReturnType<typeof useRefundRequestLazyQuery>;
export type RefundRequestQueryResult = Apollo.QueryResult<RefundRequestQuery, RefundRequestQueryVariables>;
export const RefundRequestsDocument = gql`
    query refundRequests($filter: RefundRequestFilter, $pagination: Pagination, $sort: Sort) {
  refundRequests(filter: $filter, pagination: $pagination, sort: $sort) {
    total
    data {
      ...RefundRequest
    }
  }
}
    ${RefundRequestFragmentDoc}`;

/**
 * __useRefundRequestsQuery__
 *
 * To run a query within a React component, call `useRefundRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRefundRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRefundRequestsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useRefundRequestsQuery(baseOptions?: Apollo.QueryHookOptions<RefundRequestsQuery, RefundRequestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RefundRequestsQuery, RefundRequestsQueryVariables>(RefundRequestsDocument, options);
      }
export function useRefundRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RefundRequestsQuery, RefundRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RefundRequestsQuery, RefundRequestsQueryVariables>(RefundRequestsDocument, options);
        }
export type RefundRequestsQueryHookResult = ReturnType<typeof useRefundRequestsQuery>;
export type RefundRequestsLazyQueryHookResult = ReturnType<typeof useRefundRequestsLazyQuery>;
export type RefundRequestsQueryResult = Apollo.QueryResult<RefundRequestsQuery, RefundRequestsQueryVariables>;
export const GenerateRefundRequestDocument = gql`
    mutation GenerateRefundRequest($uid: String!, $expireSeconds: Int, $preview: Boolean) {
  generateRefundRequest(
    uid: $uid
    expireSeconds: $expireSeconds
    preview: $preview
  ) {
    ...RefundRequest
  }
}
    ${RefundRequestFragmentDoc}`;
export type GenerateRefundRequestMutationFn = Apollo.MutationFunction<GenerateRefundRequestMutation, GenerateRefundRequestMutationVariables>;

/**
 * __useGenerateRefundRequestMutation__
 *
 * To run a mutation, you first call `useGenerateRefundRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateRefundRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateRefundRequestMutation, { data, loading, error }] = useGenerateRefundRequestMutation({
 *   variables: {
 *      uid: // value for 'uid'
 *      expireSeconds: // value for 'expireSeconds'
 *      preview: // value for 'preview'
 *   },
 * });
 */
export function useGenerateRefundRequestMutation(baseOptions?: Apollo.MutationHookOptions<GenerateRefundRequestMutation, GenerateRefundRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateRefundRequestMutation, GenerateRefundRequestMutationVariables>(GenerateRefundRequestDocument, options);
      }
export type GenerateRefundRequestMutationHookResult = ReturnType<typeof useGenerateRefundRequestMutation>;
export type GenerateRefundRequestMutationResult = Apollo.MutationResult<GenerateRefundRequestMutation>;
export type GenerateRefundRequestMutationOptions = Apollo.BaseMutationOptions<GenerateRefundRequestMutation, GenerateRefundRequestMutationVariables>;
export const ProcessRefundRequestDocument = gql`
    mutation ProcessRefundRequest($id: String!) {
  processRefundRequest(id: $id) {
    ...RefundRequest
  }
}
    ${RefundRequestFragmentDoc}`;
export type ProcessRefundRequestMutationFn = Apollo.MutationFunction<ProcessRefundRequestMutation, ProcessRefundRequestMutationVariables>;

/**
 * __useProcessRefundRequestMutation__
 *
 * To run a mutation, you first call `useProcessRefundRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessRefundRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processRefundRequestMutation, { data, loading, error }] = useProcessRefundRequestMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProcessRefundRequestMutation(baseOptions?: Apollo.MutationHookOptions<ProcessRefundRequestMutation, ProcessRefundRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessRefundRequestMutation, ProcessRefundRequestMutationVariables>(ProcessRefundRequestDocument, options);
      }
export type ProcessRefundRequestMutationHookResult = ReturnType<typeof useProcessRefundRequestMutation>;
export type ProcessRefundRequestMutationResult = Apollo.MutationResult<ProcessRefundRequestMutation>;
export type ProcessRefundRequestMutationOptions = Apollo.BaseMutationOptions<ProcessRefundRequestMutation, ProcessRefundRequestMutationVariables>;
export const ProcessedRefundRequestDocument = gql`
    mutation ProcessedRefundRequest($id: String!) {
  processedRefundRequest(id: $id) {
    ...RefundRequest
  }
}
    ${RefundRequestFragmentDoc}`;
export type ProcessedRefundRequestMutationFn = Apollo.MutationFunction<ProcessedRefundRequestMutation, ProcessedRefundRequestMutationVariables>;

/**
 * __useProcessedRefundRequestMutation__
 *
 * To run a mutation, you first call `useProcessedRefundRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessedRefundRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processedRefundRequestMutation, { data, loading, error }] = useProcessedRefundRequestMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProcessedRefundRequestMutation(baseOptions?: Apollo.MutationHookOptions<ProcessedRefundRequestMutation, ProcessedRefundRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessedRefundRequestMutation, ProcessedRefundRequestMutationVariables>(ProcessedRefundRequestDocument, options);
      }
export type ProcessedRefundRequestMutationHookResult = ReturnType<typeof useProcessedRefundRequestMutation>;
export type ProcessedRefundRequestMutationResult = Apollo.MutationResult<ProcessedRefundRequestMutation>;
export type ProcessedRefundRequestMutationOptions = Apollo.BaseMutationOptions<ProcessedRefundRequestMutation, ProcessedRefundRequestMutationVariables>;
export const DeactivateRefundRequestDocument = gql`
    mutation DeactivateRefundRequest($id: String!) {
  deactivateRefundRequest(id: $id) {
    ...RefundRequest
  }
}
    ${RefundRequestFragmentDoc}`;
export type DeactivateRefundRequestMutationFn = Apollo.MutationFunction<DeactivateRefundRequestMutation, DeactivateRefundRequestMutationVariables>;

/**
 * __useDeactivateRefundRequestMutation__
 *
 * To run a mutation, you first call `useDeactivateRefundRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateRefundRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateRefundRequestMutation, { data, loading, error }] = useDeactivateRefundRequestMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeactivateRefundRequestMutation(baseOptions?: Apollo.MutationHookOptions<DeactivateRefundRequestMutation, DeactivateRefundRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeactivateRefundRequestMutation, DeactivateRefundRequestMutationVariables>(DeactivateRefundRequestDocument, options);
      }
export type DeactivateRefundRequestMutationHookResult = ReturnType<typeof useDeactivateRefundRequestMutation>;
export type DeactivateRefundRequestMutationResult = Apollo.MutationResult<DeactivateRefundRequestMutation>;
export type DeactivateRefundRequestMutationOptions = Apollo.BaseMutationOptions<DeactivateRefundRequestMutation, DeactivateRefundRequestMutationVariables>;
export const ActivateRefundRequestDocument = gql`
    mutation ActivateRefundRequest($id: String!) {
  activateRefundRequest(id: $id) {
    ...RefundRequest
  }
}
    ${RefundRequestFragmentDoc}`;
export type ActivateRefundRequestMutationFn = Apollo.MutationFunction<ActivateRefundRequestMutation, ActivateRefundRequestMutationVariables>;

/**
 * __useActivateRefundRequestMutation__
 *
 * To run a mutation, you first call `useActivateRefundRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateRefundRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateRefundRequestMutation, { data, loading, error }] = useActivateRefundRequestMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useActivateRefundRequestMutation(baseOptions?: Apollo.MutationHookOptions<ActivateRefundRequestMutation, ActivateRefundRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActivateRefundRequestMutation, ActivateRefundRequestMutationVariables>(ActivateRefundRequestDocument, options);
      }
export type ActivateRefundRequestMutationHookResult = ReturnType<typeof useActivateRefundRequestMutation>;
export type ActivateRefundRequestMutationResult = Apollo.MutationResult<ActivateRefundRequestMutation>;
export type ActivateRefundRequestMutationOptions = Apollo.BaseMutationOptions<ActivateRefundRequestMutation, ActivateRefundRequestMutationVariables>;